function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

import { pvId as e, Monitor as t } from "@payment/link-monitor";

function n(e, t, n, r, i, o, a) {
  try {
    var s = e[o](a),
        c = s.value;
  } catch (e) {
    return void n(e);
  }

  s.done ? t(c) : Promise.resolve(c).then(r, i);
}

function r(e) {
  return function () {
    var t = this,
        r = arguments;
    return new Promise(function (i, o) {
      var a = e.apply(t, r);

      function s(e) {
        n(a, i, o, s, c, "next", e);
      }

      function c(e) {
        n(a, i, o, s, c, "throw", e);
      }

      s(void 0);
    });
  };
}

function i(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}

function o(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}

function a(e, t, n) {
  return t && o(e.prototype, t), n && o(e, n), e;
}

function s(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}

function c(e, t) {
  return e(t = {
    exports: {}
  }, t.exports), t.exports;
}

var u,
    l,
    p,
    d,
    h,
    f,
    v = c(function (e) {
  var t = function (e) {
    var t,
        n = Object.prototype,
        r = n.hasOwnProperty,
        i = "function" == typeof Symbol ? Symbol : {},
        o = i.iterator || "@@iterator",
        a = i.asyncIterator || "@@asyncIterator",
        s = i.toStringTag || "@@toStringTag";

    function c(e, t, n) {
      return Object.defineProperty(e, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }), e[t];
    }

    try {
      c({}, "");
    } catch (e) {
      c = function c(e, t, n) {
        return e[t] = n;
      };
    }

    function u(e, t, n, r) {
      var i = t && t.prototype instanceof y ? t : y,
          o = Object.create(i.prototype),
          a = new _(r || []);
      return o._invoke = function (e, t, n) {
        var r = p;
        return function (i, o) {
          if (r === h) throw new Error("Generator is already running");

          if (r === f) {
            if ("throw" === i) throw o;
            return P();
          }

          for (n.method = i, n.arg = o;;) {
            var a = n.delegate;

            if (a) {
              var s = I(a, n);

              if (s) {
                if (s === v) continue;
                return s;
              }
            }

            if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
              if (r === p) throw r = f, n.arg;
              n.dispatchException(n.arg);
            } else "return" === n.method && n.abrupt("return", n.arg);
            r = h;
            var c = l(e, t, n);

            if ("normal" === c.type) {
              if (r = n.done ? f : d, c.arg === v) continue;
              return {
                value: c.arg,
                done: n.done
              };
            }

            "throw" === c.type && (r = f, n.method = "throw", n.arg = c.arg);
          }
        };
      }(e, n, a), o;
    }

    function l(e, t, n) {
      try {
        return {
          type: "normal",
          arg: e.call(t, n)
        };
      } catch (e) {
        return {
          type: "throw",
          arg: e
        };
      }
    }

    e.wrap = u;
    var p = "suspendedStart",
        d = "suspendedYield",
        h = "executing",
        f = "completed",
        v = {};

    function y() {}

    function m() {}

    function g() {}

    var b = {};
    c(b, o, function () {
      return this;
    });
    var k = Object.getPrototypeOf,
        x = k && k(k(D([])));
    x && x !== n && r.call(x, o) && (b = x);
    var w = g.prototype = y.prototype = Object.create(b);

    function C(e) {
      ["next", "throw", "return"].forEach(function (t) {
        c(e, t, function (e) {
          return this._invoke(t, e);
        });
      });
    }

    function E(e, t) {
      function n(i, o, a, s) {
        var c = l(e[i], e, o);

        if ("throw" !== c.type) {
          var u = c.arg,
              p = u.value;
          return p && "object" == _typeof(p) && r.call(p, "__await") ? t.resolve(p.__await).then(function (e) {
            n("next", e, a, s);
          }, function (e) {
            n("throw", e, a, s);
          }) : t.resolve(p).then(function (e) {
            u.value = e, a(u);
          }, function (e) {
            return n("throw", e, a, s);
          });
        }

        s(c.arg);
      }

      var i;

      this._invoke = function (e, r) {
        function o() {
          return new t(function (t, i) {
            n(e, r, t, i);
          });
        }

        return i = i ? i.then(o, o) : o();
      };
    }

    function I(e, n) {
      var r = e.iterator[n.method];

      if (r === t) {
        if (n.delegate = null, "throw" === n.method) {
          if (e.iterator["return"] && (n.method = "return", n.arg = t, I(e, n), "throw" === n.method)) return v;
          n.method = "throw", n.arg = new TypeError("The iterator does not provide a 'throw' method");
        }

        return v;
      }

      var i = l(r, e.iterator, n.arg);
      if ("throw" === i.type) return n.method = "throw", n.arg = i.arg, n.delegate = null, v;
      var o = i.arg;
      return o ? o.done ? (n[e.resultName] = o.value, n.next = e.nextLoc, "return" !== n.method && (n.method = "next", n.arg = t), n.delegate = null, v) : o : (n.method = "throw", n.arg = new TypeError("iterator result is not an object"), n.delegate = null, v);
    }

    function S(e) {
      var t = {
        tryLoc: e[0]
      };
      1 in e && (t.catchLoc = e[1]), 2 in e && (t.finallyLoc = e[2], t.afterLoc = e[3]), this.tryEntries.push(t);
    }

    function O(e) {
      var t = e.completion || {};
      t.type = "normal", delete t.arg, e.completion = t;
    }

    function _(e) {
      this.tryEntries = [{
        tryLoc: "root"
      }], e.forEach(S, this), this.reset(!0);
    }

    function D(e) {
      if (e) {
        var n = e[o];
        if (n) return n.call(e);
        if ("function" == typeof e.next) return e;

        if (!isNaN(e.length)) {
          var i = -1,
              a = function n() {
            for (; ++i < e.length;) {
              if (r.call(e, i)) return n.value = e[i], n.done = !1, n;
            }

            return n.value = t, n.done = !0, n;
          };

          return a.next = a;
        }
      }

      return {
        next: P
      };
    }

    function P() {
      return {
        value: t,
        done: !0
      };
    }

    return m.prototype = g, c(w, "constructor", g), c(g, "constructor", m), m.displayName = c(g, s, "GeneratorFunction"), e.isGeneratorFunction = function (e) {
      var t = "function" == typeof e && e.constructor;
      return !!t && (t === m || "GeneratorFunction" === (t.displayName || t.name));
    }, e.mark = function (e) {
      return Object.setPrototypeOf ? Object.setPrototypeOf(e, g) : (e.__proto__ = g, c(e, s, "GeneratorFunction")), e.prototype = Object.create(w), e;
    }, e.awrap = function (e) {
      return {
        __await: e
      };
    }, C(E.prototype), c(E.prototype, a, function () {
      return this;
    }), e.AsyncIterator = E, e.async = function (t, n, r, i, o) {
      void 0 === o && (o = Promise);
      var a = new E(u(t, n, r, i), o);
      return e.isGeneratorFunction(n) ? a : a.next().then(function (e) {
        return e.done ? e.value : a.next();
      });
    }, C(w), c(w, s, "Generator"), c(w, o, function () {
      return this;
    }), c(w, "toString", function () {
      return "[object Generator]";
    }), e.keys = function (e) {
      var t = [];

      for (var n in e) {
        t.push(n);
      }

      return t.reverse(), function n() {
        for (; t.length;) {
          var r = t.pop();
          if (r in e) return n.value = r, n.done = !1, n;
        }

        return n.done = !0, n;
      };
    }, e.values = D, _.prototype = {
      constructor: _,
      reset: function reset(e) {
        if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(O), !e) for (var n in this) {
          "t" === n.charAt(0) && r.call(this, n) && !isNaN(+n.slice(1)) && (this[n] = t);
        }
      },
      stop: function stop() {
        this.done = !0;
        var e = this.tryEntries[0].completion;
        if ("throw" === e.type) throw e.arg;
        return this.rval;
      },
      dispatchException: function dispatchException(e) {
        if (this.done) throw e;
        var n = this;

        function i(r, i) {
          return s.type = "throw", s.arg = e, n.next = r, i && (n.method = "next", n.arg = t), !!i;
        }

        for (var o = this.tryEntries.length - 1; o >= 0; --o) {
          var a = this.tryEntries[o],
              s = a.completion;
          if ("root" === a.tryLoc) return i("end");

          if (a.tryLoc <= this.prev) {
            var c = r.call(a, "catchLoc"),
                u = r.call(a, "finallyLoc");

            if (c && u) {
              if (this.prev < a.catchLoc) return i(a.catchLoc, !0);
              if (this.prev < a.finallyLoc) return i(a.finallyLoc);
            } else if (c) {
              if (this.prev < a.catchLoc) return i(a.catchLoc, !0);
            } else {
              if (!u) throw new Error("try statement without catch or finally");
              if (this.prev < a.finallyLoc) return i(a.finallyLoc);
            }
          }
        }
      },
      abrupt: function abrupt(e, t) {
        for (var n = this.tryEntries.length - 1; n >= 0; --n) {
          var i = this.tryEntries[n];

          if (i.tryLoc <= this.prev && r.call(i, "finallyLoc") && this.prev < i.finallyLoc) {
            var o = i;
            break;
          }
        }

        o && ("break" === e || "continue" === e) && o.tryLoc <= t && t <= o.finallyLoc && (o = null);
        var a = o ? o.completion : {};
        return a.type = e, a.arg = t, o ? (this.method = "next", this.next = o.finallyLoc, v) : this.complete(a);
      },
      complete: function complete(e, t) {
        if ("throw" === e.type) throw e.arg;
        return "break" === e.type || "continue" === e.type ? this.next = e.arg : "return" === e.type ? (this.rval = this.arg = e.arg, this.method = "return", this.next = "end") : "normal" === e.type && t && (this.next = t), v;
      },
      finish: function finish(e) {
        for (var t = this.tryEntries.length - 1; t >= 0; --t) {
          var n = this.tryEntries[t];
          if (n.finallyLoc === e) return this.complete(n.completion, n.afterLoc), O(n), v;
        }
      },
      "catch": function _catch(e) {
        for (var t = this.tryEntries.length - 1; t >= 0; --t) {
          var n = this.tryEntries[t];

          if (n.tryLoc === e) {
            var r = n.completion;

            if ("throw" === r.type) {
              var i = r.arg;
              O(n);
            }

            return i;
          }
        }

        throw new Error("illegal catch attempt");
      },
      delegateYield: function delegateYield(e, n, r) {
        return this.delegate = {
          iterator: D(e),
          resultName: n,
          nextLoc: r
        }, "next" === this.method && (this.arg = t), v;
      }
    }, e;
  }(e.exports);

  try {
    regeneratorRuntime = t;
  } catch (e) {
    "object" == (typeof globalThis === "undefined" ? "undefined" : _typeof(globalThis)) ? globalThis.regeneratorRuntime = t : Function("r", "regeneratorRuntime = r")(t);
  }
});
!function (e) {
  e.CreditCard = "CreditCard", e.FPX = "FPX", e.PaynowQrCode = "PaynowQrCode", e.AlipayQrCode = "AlipayQrCode", e.AlipayWap = "AlipayWap", e.Paypal = "Paypal", e.BankTransfer = "BankTransfer", e.Cash = "Cash", e.ChannelCashier = "ChannelCashier", e.VirtualAccount = "VirtualAccount", e.AtomeBNPL = "AtomeBNPL";
}(u || (u = {})), function (e) {
  e.WorldPay = "WorldPay", e.Useepay = "Useepay";
}(l || (l = {})), function (e) {
  e.Oceanpay = "Oceanpay", e.Xendit = "Xendit", e.Stripe = "Stripe", e.AsiaBill = "AsiaBill", e.Useepay = "Useepay", e.Wintopay = "Wintopay", e.Onekpay = "Onekpay";
}(p || (p = {})), function (e) {
  e.Google = "googleFont", e.System = "system";
}(d || (d = {})), function (e) {
  e.FirstName = "firstName", e.Number = "number", e.Cvc = "cvc", e.ExpDate = "expDate";
}(h || (h = {})), function (e) {
  e.Redirect = "Redirect", e.Confirm = "Confirm", e.QrCode = "QrCode", e.WorldPayChallenge = "WorldPayChallenge", e.WorldPayGather = "WorldPayGather", e.UseepayGather = "UseepayGather", e.UseepayChallenge = "UseepayChallenge";
}(f || (f = {}));
var y = [h.Number, h.FirstName, h.ExpDate, h.Cvc];

function m(e, t) {
  if (null == e) return {};

  var n,
      r,
      i = function (e, t) {
    if (null == e) return {};
    var n,
        r,
        i = {},
        o = Object.keys(e);

    for (r = 0; r < o.length; r++) {
      n = o[r], t.indexOf(n) >= 0 || (i[n] = e[n]);
    }

    return i;
  }(e, t);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);

    for (r = 0; r < o.length; r++) {
      n = o[r], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (i[n] = e[n]);
    }
  }

  return i;
}

function g(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}

function b(e, t) {
  return (b = Object.setPrototypeOf || function (e, t) {
    return e.__proto__ = t, e;
  })(e, t);
}

function k(e, t) {
  if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), t && b(e, t);
}

var x,
    w,
    C = function (e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e["default"] : e;
}(c(function (e) {
  function t(n) {
    return "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? (e.exports = t = function t(e) {
      return _typeof(e);
    }, e.exports["default"] = e.exports, e.exports.__esModule = !0) : (e.exports = t = function t(e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : _typeof(e);
    }, e.exports["default"] = e.exports, e.exports.__esModule = !0), t(n);
  }

  e.exports = t, e.exports["default"] = e.exports, e.exports.__esModule = !0;
}));

function E(e, t) {
  return !t || "object" !== C(t) && "function" != typeof t ? g(e) : t;
}

function I(e) {
  return (I = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
    return e.__proto__ || Object.getPrototypeOf(e);
  })(e);
}

function S() {
  if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
  if (Reflect.construct.sham) return !1;
  if ("function" == typeof Proxy) return !0;

  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
  } catch (e) {
    return !1;
  }
}

function O(e, t, n) {
  return (O = S() ? Reflect.construct : function (e, t, n) {
    var r = [null];
    r.push.apply(r, t);
    var i = new (Function.bind.apply(e, r))();
    return n && b(i, n.prototype), i;
  }).apply(null, arguments);
}

function _(e) {
  var t = "function" == typeof Map ? new Map() : void 0;
  return (_ = function _(e) {
    if (null === e || (n = e, -1 === Function.toString.call(n).indexOf("[native code]"))) return e;
    var n;
    if ("function" != typeof e) throw new TypeError("Super expression must either be null or a function");

    if (void 0 !== t) {
      if (t.has(e)) return t.get(e);
      t.set(e, r);
    }

    function r() {
      return O(e, arguments, I(this).constructor);
    }

    return r.prototype = Object.create(e.prototype, {
      constructor: {
        value: r,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), b(r, e);
  })(e);
}

function D(e) {
  var t = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;

    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }();

  return function () {
    var n,
        r = I(e);

    if (t) {
      var i = I(this).constructor;
      n = Reflect.construct(r, arguments, i);
    } else n = r.apply(this, arguments);

    return E(this, n);
  };
}

!function (e) {
  e.NotSupportBrowser = "1026", e.InnerSDKError = "1027", e.RenderFail = "1028", e.NetworkError = "2905";
}(x || (x = {})), function (e) {
  e.Fatal = "fatal", e.Error = "error";
}(w || (w = {}));

var P = function (e) {
  k(n, _(Error));
  var t = D(n);

  function n(e) {
    var r,
        o = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : x.InnerSDKError,
        a = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "SilenceError",
        c = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : w.Error;
    return i(this, n), s(g(r = t.call(this, e)), "code", void 0), s(g(r), "data", void 0), s(g(r), "errorLevel", void 0), r.name = a, r.code = o, r.errorLevel = c, r;
  }

  return n;
}(),
    j = function (e) {
  k(n, _(Error));
  var t = D(n);

  function n(e) {
    var r,
        o = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : x.InnerSDKError,
        a = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "UnknownError",
        c = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : w.Error;
    return i(this, n), s(g(r = t.call(this, e)), "code", void 0), s(g(r), "isReported", !1), s(g(r), "data", void 0), s(g(r), "errorLevel", void 0), r.name = a, r.code = o, r.errorLevel = c, r;
  }

  return a(n, [{
    key: "setIsReported",
    value: function value() {
      this.isReported = !0;
    }
  }]), n;
}();

function T() {
  return "1.19.0";
}

function R(e, t) {
  (null == t || t > e.length) && (t = e.length);

  for (var n = 0, r = new Array(t); n < t; n++) {
    r[n] = e[n];
  }

  return r;
}

function F(e) {
  return function (e) {
    if (Array.isArray(e)) return R(e);
  }(e) || function (e) {
    if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
  }(e) || function (e, t) {
    if (e) {
      if ("string" == typeof e) return R(e, t);
      var n = Object.prototype.toString.call(e).slice(8, -1);
      return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? R(e, t) : void 0;
    }
  }(e) || function () {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}

function N(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}

function B(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}

function L(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}

function M(e, t, n) {
  return t && L(e.prototype, t), n && L(e, n), e;
}

function A(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}

function H(e) {
  return (H = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
    return e.__proto__ || Object.getPrototypeOf(e);
  })(e);
}

function V(e, t, n) {
  return (V = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function (e, t, n) {
    var r = function (e, t) {
      for (; !Object.prototype.hasOwnProperty.call(e, t) && null !== (e = H(e));) {
        ;
      }

      return e;
    }(e, t);

    if (r) {
      var i = Object.getOwnPropertyDescriptor(r, t);
      return i.get ? i.get.call(n) : i.value;
    }
  })(e, t, n || e);
}

function U(e, t) {
  return (U = Object.setPrototypeOf || function (e, t) {
    return e.__proto__ = t, e;
  })(e, t);
}

function q(e) {
  return (q = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (e) {
    return _typeof(e);
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : _typeof(e);
  })(e);
}

function z(e, t) {
  return !t || "object" !== q(t) && "function" != typeof t ? A(e) : t;
}

var X = /^\s*at (?:(.*?) ?\()?((?:file|https?|blob|chrome-extension|address|native|eval|webpack|<anonymous>|[-a-z]+:|.*bundle|\/).*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i,
    W = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:file|https?|blob|chrome|webpack|resource|moz-extension).*?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js))(?::(\d+))?(?::(\d+))?\s*$/i,
    G = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:file|ms-appx|https?|webpack|blob):.*?):(\d+)(?::(\d+))?\)?\s*$/i,
    Z = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+))?@)([\w.-]+)(?::(\d+))?\/(.+)/;

function J(e) {
  return (e && e.message || "No error message").split("\n").filter(function (e) {
    return !!e;
  })[0];
}

function Q(e) {
  try {
    var t = function (e) {
      if (!e.stack) return null;

      for (var t, n, r = [], i = e.stack.split("\n"), o = 0; o < i.length; ++o) {
        if (t = X.exec(i[o])) n = {
          filename: t[2] && 0 === t[2].indexOf("address at ") ? t[2].substr("address at ".length) : t[2],
          "function": t[1] || "?",
          lineno: t[3] ? +t[3] : null,
          colno: t[4] ? +t[4] : null
        };else if (t = G.exec(i[o])) n = {
          filename: t[2],
          "function": t[1] || "?",
          lineno: +t[3],
          colno: t[4] ? +t[4] : null
        };else {
          if (!(t = W.exec(i[o]))) continue;
          0 !== o || t[5] || void 0 === e.columnNumber || (r[0].column = e.columnNumber + 1), n = {
            filename: t[3],
            "function": t[1] || "?",
            lineno: t[4] ? +t[4] : null,
            colno: t[5] ? +t[5] : null
          };
        }
        !n["function"] && n.lineno && (n["function"] = "?"), r.push(n);
      }

      return r.length ? {
        value: J(e),
        type: e.name,
        stacktrace: {
          frames: r.reverse()
        }
      } : null;
    }(e);

    if (t) return t;
  } catch (e) {}

  return {
    value: J(e),
    type: e && e.name,
    stacktrace: {
      frames: []
    }
  };
}

var Y = Object.assign || function (e) {
  for (var t = arguments.length, n = 1; n < t; n++) {
    var r = arguments[n];

    for (var i in r) {
      Object.prototype.hasOwnProperty.call(r, i) && (e[i] = r[i]);
    }
  }

  return e;
},
    $ = function () {
  function e(t) {
    if (B(this, e), t.dsn) {
      var n = Z.exec(t.dsn),
          r = n ? n.slice(1) : [],
          i = r[5].split("/"),
          o = i.slice(0, -1).join("/");
      this.apiUrl = r[0] + "://" + r[3] + (r[4] ? ":" + r[4] : "") + (o ? "/" + o : "") + "/api/" + i.pop() + "/store/", this.authHeader = "Sentry sentry_version=7,sentry_key=" + r[1] + (r[2] ? ",sentry_secret=" + r[2] : "");
    }

    this.environment = t.environment;
  }

  return M(e, [{
    key: "prepare",
    value: function value(e) {
      return Y(this.getRequestBlank(), {
        exception: {
          values: [Q(e)]
        }
      });
    }
  }, {
    key: "report",
    value: function value(e) {
      this.send(this.prepare(e));
    }
  }, {
    key: "send",
    value: function value(e) {
      if (this.apiUrl) {
        var t = new XMLHttpRequest();
        t.open("POST", this.apiUrl, !0), t.setRequestHeader("Content-type", "application/json"), t.setRequestHeader("X-Sentry-Auth", this.authHeader || ""), t.send(JSON.stringify(e));
      }
    }
  }, {
    key: "getRequestBlank",
    value: function value() {
      return {
        platform: "javascript",
        sdk: {
          name: "micro-sentry.javascript.browser",
          version: "0.0.0"
        },
        timestamp: Date.now() / 1e3,
        request: {
          url: window.location.toString(),
          headers: {
            "User-Agent": window.navigator.userAgent
          }
        },
        environment: this.environment
      };
    }
  }]), e;
}();

function K(e, t) {
  return "[object RegExp]" === Object.prototype.toString.call(t) ? t.test(e) : "string" == typeof t && -1 !== e.indexOf(t);
}

var ee = function (e) {
  !function (e, t) {
    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        writable: !0,
        configurable: !0
      }
    }), t && U(e, t);
  }(n, $);

  var t = function (e) {
    var t = function () {
      if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
      if (Reflect.construct.sham) return !1;
      if ("function" == typeof Proxy) return !0;

      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
      } catch (e) {
        return !1;
      }
    }();

    return function () {
      var n,
          r = H(e);

      if (t) {
        var i = H(this).constructor;
        n = Reflect.construct(r, arguments, i);
      } else n = r.apply(this, arguments);

      return z(this, n);
    };
  }(n);

  function n(e) {
    var r;
    B(this, n), (r = t.call(this, e)).options = e, r.destroyed = !1, r._state = {};
    var i = r.options || {},
        o = i.plugins,
        a = void 0 === o ? [] : o,
        s = i.beforeSend,
        c = void 0 === s ? function (e) {
      return e;
    } : s,
        u = i.beforeBreadcrumb,
        l = void 0 === u ? function (e) {
      return e;
    } : u,
        p = i.blacklistUrls,
        d = void 0 === p ? [] : p,
        h = i.ignoreErrors,
        f = void 0 === h ? [] : h,
        v = i.release,
        y = void 0 === v ? void 0 : v;
    return r.plugins = a.map(function (e) {
      return new e(A(r));
    }), r.beforeSend = c, r.beforeBreadcrumb = l, r.blacklistUrls = d, r.ignoreErrors = f, r.release = y, r;
  }

  return M(n, [{
    key: "state",
    get: function get() {
      return this._state;
    }
  }, {
    key: "clearState",
    value: function value() {
      this._state = {};
    }
  }, {
    key: "setTags",
    value: function value(e) {
      return this.setKeyState("tags", Object.assign({}, e)), this;
    }
  }, {
    key: "setTag",
    value: function value(e, t) {
      return this.extendState({
        tags: N({}, e, t)
      }), this;
    }
  }, {
    key: "setExtra",
    value: function value(e, t) {
      return this.extendState({
        extra: N({}, e, t)
      }), this;
    }
  }, {
    key: "setExtras",
    value: function value(e) {
      return this.setKeyState("extra", Object.assign({}, e)), this;
    }
  }, {
    key: "setUser",
    value: function value(e) {
      return this.setKeyState("user", Object.assign({}, e)), this;
    }
  }, {
    key: "clone",
    value: function value() {
      var e = new n(Object.assign(Object.assign({}, this.options), {
        plugins: []
      }));
      return e.extendState(this.state), e;
    }
  }, {
    key: "withScope",
    value: function value(e) {
      var t = this.clone();
      e(t), t.destroy(), this.setBreadcrumbs(void 0);
    }
  }, {
    key: "addBreadcrumb",
    value: function value(e) {
      this.extendState({
        breadcrumbs: [Object.assign({
          timestamp: Date.now() / 1e3
        }, this.beforeBreadcrumb(e))]
      });
    }
  }, {
    key: "setBreadcrumbs",
    value: function value(e) {
      this.setKeyState("breadcrumbs", e);
    }
  }, {
    key: "captureMessage",
    value: function value(e, t) {
      this.send(Object.assign(Object.assign({}, this.getRequestBlank()), {
        message: e,
        level: t
      }));
    }
  }, {
    key: "destroy",
    value: function value() {
      this.destroyed = !0, this.plugins.forEach(function (e) {
        e.destroy && e.destroy();
      });
    }
  }, {
    key: "isIgnoredError",
    value: function value(e) {
      var t = this;
      return !!this.ignoreErrors.length && this.getPossibleEventMessages(e).some(function (e) {
        return t.ignoreErrors.some(function (t) {
          return K(e, t);
        });
      });
    }
  }, {
    key: "getRequestBlank",
    value: function value() {
      return Object.assign(Object.assign({}, V(H(n.prototype), "getRequestBlank", this).call(this)), this.state);
    }
  }, {
    key: "send",
    value: function value(e) {
      this.destroyed || this.isDeniedUrl(e) || this.isIgnoredError(e) || (V(H(n.prototype), "send", this).call(this, this.beforeSend(Object.assign({
        release: this.release
      }, e))), this.setBreadcrumbs(void 0));
    }
  }, {
    key: "getPossibleEventMessages",
    value: function value(e) {
      if (e.message) return [e.message];
      if (e.exception) try {
        var t = e.exception.values && e.exception.values[0] || {},
            n = t.type,
            r = void 0 === n ? "" : n,
            i = t.value,
            o = void 0 === i ? "" : i;
        return ["".concat(o), "".concat(r, ": ").concat(o)];
      } catch (e) {
        return [];
      }
      return [];
    }
  }, {
    key: "isDeniedUrl",
    value: function value(e) {
      if (!this.blacklistUrls.length) return !1;
      var t = this.getEventFilterUrl(e);
      return !!t && this.blacklistUrls.some(function (e) {
        return K(t, e);
      });
    }
  }, {
    key: "getEventFilterUrl",
    value: function value(e) {
      try {
        if (e.exception) {
          var t = e.exception.values && e.exception.values[0].stacktrace && e.exception.values[0].stacktrace.frames;
          return t && t[t.length - 1].filename || null;
        }

        return null;
      } catch (e) {
        return null;
      }
    }
  }, {
    key: "extendState",
    value: function value(e) {
      var t = this;
      this._state = Object.keys(e).reduce(function (n, r) {
        var i = t.state[r],
            o = Array.isArray(i) ? i : null,
            a = e[r],
            s = Array.isArray(a) ? a : null;
        return Object.assign(Object.assign({}, n), N({}, r, o || s ? [].concat(F(o || []), F(s || [])) : Object.assign(Object.assign({}, "string" != typeof i ? i : {}), "string" != typeof a ? a : {})));
      }, {});
    }
  }, {
    key: "setKeyState",
    value: function value(e, t) {
      this._state[e] = t;
    }
  }]), n;
}();

function te(e, t, n) {
  var r = e[t],
      i = n(r);
  if ("function" == typeof i) try {
    i.prototype = i.prototype || {}, Object.defineProperties(i, {
      __original__: {
        enumerable: !1,
        value: r
      }
    });
  } catch (e) {}
  e[t] = i;
}

function ne(e) {
  if (!e) return {};
  var t = e.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
  if (!t) return {};
  var n = t[6] || "",
      r = t[8] || "";
  return {
    host: t[4],
    path: t[5],
    protocol: t[2],
    relative: t[5] + n + r
  };
}

function re() {
  var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [];
  return "Request" in window && e[0] instanceof Request && e[0].method ? String(e[0].method).toUpperCase() : e[1] && e[1].method ? String(e[1].method).toUpperCase() : "GET";
}

function ie() {
  var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [];
  return "string" == typeof e[0] ? e[0] : "Request" in window && e[0] instanceof Request ? e[0].url : String(e[0]);
}

function oe(e) {
  return e && /^function fetch\(\)\s+\{\s+\[native code\]\s+\}$/.test(e.toString());
}

function ae(e) {
  var t = e,
      n = [];
  if (!t || !t.tagName) return "";
  n.push(t.tagName.toLowerCase()), t.id && n.push("#".concat(t.id));
  var r = t.className;

  if (r && "string" == typeof r) {
    var i = r.split(/\s+/);
    n.concat(i.map(function (e) {
      return ".".concat(e);
    }));
  }

  return ["type", "name", "title", "alt", "automation-id"].forEach(function (e) {
    var r = t.getAttribute(e);
    r && n.push("[".concat(e, '="').concat(r, '"]'));
  }), n.join("");
}

function se(e) {
  try {
    for (var t, n = e, r = [], i = 0, o = 0, a = " > ".length; n && i++ < 5 && !("html" === (t = ae(n)) || i > 1 && o + r.length * a + t.length >= 80);) {
      r.push(t), o += t.length, n = n.parentNode;
    }

    return r.reverse().join(" > ");
  } catch (e) {
    return "<unknown>";
  }
}

function ce(e) {
  var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : " ";
  return Array.isArray(e) ? e.map(function (e) {
    try {
      return String(e);
    } catch (e) {
      return "";
    }
  }).filter(function (e) {
    return "" !== e;
  }).join(t) : "";
}

function ue(e, t) {
  var n = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), n.push.apply(n, r);
  }

  return n;
}

function le(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = null != arguments[t] ? arguments[t] : {};
    t % 2 ? ue(Object(n), !0).forEach(function (t) {
      s(e, t, n[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : ue(Object(n)).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
    });
  }

  return e;
}

!function () {
  function e(t) {
    B(this, e), this.client = t, this.subscriptions = [], this.initDOM(), this.initConsole(), this.initFetch(), this.initHistory(), this.initXHR();
  }

  M(e, [{
    key: "initXHR",
    value: function value() {
      if ("XMLHttpRequest" in window) {
        var e = this,
            t = XMLHttpRequest.prototype;
        te(t, "open", function (t) {
          return function () {
            for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++) {
              r[i] = arguments[i];
            }

            var o = this,
                a = r[1];
            o.__sentry_xhr__ = {
              method: "string" == typeof r[0] ? r[0].toUpperCase() : r[0],
              url: r[1]
            }, "string" == typeof a && "POST" === o.__sentry_xhr__.method && a.match(/sentry_key/) && (o.__sentry_own_request__ = !0);

            var s = function s() {
              if (4 === o.readyState) {
                try {
                  o.__sentry_xhr__ && (o.__sentry_xhr__.status_code = o.status);
                } catch (e) {}

                e.xhrBreadcrumb({
                  args: r,
                  endTimestamp: Date.now(),
                  startTimestamp: Date.now(),
                  xhr: o
                });
              }
            };

            return "onreadystatechange" in o && "function" == typeof o.onreadystatechange ? te(o, "onreadystatechange", function (e) {
              return function () {
                s();

                for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) {
                  n[r] = arguments[r];
                }

                e.apply(o, n);
              };
            }) : o.addEventListener("readystatechange", s), t.apply(o, r);
          };
        }), te(t, "send", function (t) {
          return function () {
            for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++) {
              r[i] = arguments[i];
            }

            return e.xhrBreadcrumb({
              args: r,
              startTimestamp: Date.now(),
              xhr: this
            }), t.apply(this, r);
          };
        });
      }
    }
  }, {
    key: "initHistory",
    value: function value() {
      var e = this,
          t = window.onpopstate;

      function n(t) {
        return function () {
          for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++) {
            r[i] = arguments[i];
          }

          var o = r.length > 2 ? r[2] : void 0;

          if (o) {
            var a = e.lastHref,
                s = String(o);
            e.lastHref = s, e.historyBreadcrumb({
              from: a,
              to: s
            });
          }

          return t.apply(this, r);
        };
      }

      window.onpopstate = function () {
        var n = window.location.href,
            r = e.lastHref;

        if (e.lastHref = n, e.historyBreadcrumb({
          from: r,
          to: n
        }), t) {
          for (var i = arguments.length, o = new Array(i), a = 0; a < i; a++) {
            o[a] = arguments[a];
          }

          return t.apply(this, o);
        }
      }, te(window.history, "pushState", n), te(window.history, "replaceState", n);
    }
  }, {
    key: "destroy",
    value: function value() {
      this.subscriptions.forEach(function (e) {
        return e();
      });
    }
  }, {
    key: "initDOM",
    value: function value() {
      var e = this,
          t = function t(_t2) {
        return e.prepareDomEvent("click", _t2);
      },
          n = function n(t) {
        return e.prepareDomEvent("keypress", t);
      };

      window.document.addEventListener("click", t, !1), window.document.addEventListener("keypress", n, !1), this.subscriptions.push(function () {
        window.document.removeEventListener("click", t, !1), window.document.removeEventListener("keypress", n, !1);
      });
    }
  }, {
    key: "prepareDomEvent",
    value: function value(e, t) {
      var n;

      try {
        n = t.target ? se(t.target) : se(t);
      } catch (e) {
        n = "<unknown>";
      }

      0 !== n.length && this.client.addBreadcrumb({
        category: "ui.".concat(e),
        message: n
      });
    }
  }, {
    key: "initFetch",
    value: function value() {
      var e = this;
      (function () {
        if (!function () {
          if (!("fetch" in window)) return !1;

          try {
            return new Headers(), new Request(""), new Response(), !0;
          } catch (e) {
            return !1;
          }
        }()) return !1;
        if (oe(window.fetch)) return !0;
        var e = !1,
            t = window.document;
        if (t && "function" == typeof t.createElement) try {
          var n = t.createElement("iframe");
          n.sandbox.add("allow-scripts"), n.sandbox.add("allow-same-origin"), n.hidden = !0, t.head.appendChild(n), n.contentWindow && n.contentWindow.fetch && (e = oe(n.contentWindow.fetch)), t.head.removeChild(n);
        } catch (e) {}
        return e;
      })() && te(window, "fetch", function (t) {
        return function () {
          for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++) {
            r[i] = arguments[i];
          }

          var o = {
            args: r,
            fetchData: {
              method: re(r),
              url: ie(r)
            },
            startTimestamp: Date.now()
          };
          return e.fetchBreadcrumb(Object.assign({}, o)), t.apply(window, r).then(function (t) {
            return e.fetchBreadcrumb(Object.assign(Object.assign({}, o), {
              endTimestamp: Date.now(),
              response: t
            })), t;
          }, function (t) {
            throw e.fetchBreadcrumb(Object.assign(Object.assign({}, o), {
              endTimestamp: Date.now(),
              error: t
            })), t;
          });
        };
      });
    }
  }, {
    key: "fetchBreadcrumb",
    value: function value(e) {
      e.endTimestamp && (e.fetchData.url.match(/sentry_key/) && "POST" === e.fetchData.method || (e.error ? this.client.addBreadcrumb({
        category: "fetch",
        data: e.fetchData,
        level: "error",
        type: "http"
      }) : this.client.addBreadcrumb({
        category: "fetch",
        data: Object.assign(Object.assign({}, e.fetchData), {
          status_code: e.response.status
        }),
        type: "http"
      })));
    }
  }, {
    key: "xhrBreadcrumb",
    value: function value(e) {
      if (e.endTimestamp) {
        if (e.xhr.__sentry_own_request__) return;
        this.client.addBreadcrumb({
          category: "xhr",
          data: e.xhr.__sentry_xhr__,
          type: "http"
        });
      }
    }
  }, {
    key: "initConsole",
    value: function value() {
      var e = this;
      ["debug", "info", "warn", "error", "log", "assert"].forEach(function (t) {
        t in window.console && te(window.console, t, function (n) {
          return function () {
            for (var r = arguments.length, i = new Array(r), o = 0; o < r; o++) {
              i[o] = arguments[o];
            }

            var a = {
              category: "console",
              data: {
                arguments: i.map(function (e) {
                  try {
                    return JSON.stringify(e), e;
                  } catch (t) {
                    return Object.prototype.toString.call(e);
                  }
                }),
                logger: "console"
              },
              level: t,
              message: ce(i, " ")
            };

            if ("assert" === t) {
              if (!1 !== i[0]) return;
              a.message = "Assertion failed: ".concat(ce(i.slice(1), " ") || "console.assert"), a.data.arguments = i.slice(1);
            }

            e.client.addBreadcrumb(a), n && Function.prototype.apply.call(n, window.console, i);
          };
        });
      });
    }
  }, {
    key: "historyBreadcrumb",
    value: function value(e) {
      var t = e.from,
          n = e.to,
          r = ne(window.location.href),
          i = ne(t),
          o = ne(n);
      i.path || (i = r), r.protocol === o.protocol && r.host === o.host && (n = o.relative), r.protocol === i.protocol && r.host === i.host && (t = i.relative), this.client.addBreadcrumb({
        category: "navigation",
        data: {
          from: t,
          to: n
        }
      });
    }
  }]);
}();
var pe = new ee({
  dsn: "https://08c0eb817b5a4ac5b5b0de28a29a1932@sentry-new.myshopline.com/304",
  release: "1.19.0",
  environment: "production",
  beforeSend: function beforeSend(e) {
    return e;
  }
});

function de(e, t) {
  if (t) {
    var n = t.message,
        r = t.stack;
    return t.message = JSON.stringify(le(le({}, e || {}), {}, {
      originErrorMessage: n,
      originErrorData: JSON.stringify(t),
      errorLevel: t.errorLevel || w.Error
    })), pe.report(t), t.message = n, void (t.stack = r);
  }

  pe.report(new Error(JSON.stringify(le(le({}, e), {}, {
    errorLevel: e.errorLevel || w.Error
  }))));
}

function he(e, t) {
  var n = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), n.push.apply(n, r);
  }

  return n;
}

function fe(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = null != arguments[t] ? arguments[t] : {};
    t % 2 ? he(Object(n), !0).forEach(function (t) {
      s(e, t, n[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : he(Object(n)).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
    });
  }

  return e;
}

pe.setTag("pvId", e);

var ve = new t("webpaymentsdk", {
  performance: !1
}),
    ye = function () {
  function e() {
    i(this, e);
  }

  return a(e, null, [{
    key: "init",
    value: function value(e) {
      ve.init({
        consumer: e.clientId,
        version: "1.19.0",
        projectName: "webpaymentsdk",
        merchantId: e.merchantId,
        channelId: e.channelId,
        paymentMethod: e.paymentMethod,
        countryCode: e.countryCode,
        currency: e.currency,
        environment: "production"
      });
    }
  }, {
    key: "reportError",
    value: function value(t) {
      var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "report_error",
          r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
      t instanceof P || (t instanceof j ? t.isReported || (de(Object.assign({
        eventName: n
      }, e.formatReportData(r)), t), t.setIsReported()) : de(Object.assign({
        eventName: n
      }, e.formatReportData(r)), t));
    }
  }, {
    key: "handleError",
    value: function value(t) {
      var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "default_error",
          r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
      if (e.reportData(n, r), e.reportError(t, n, r), t instanceof P || t instanceof j) throw t;
      var i = "".concat(n, " ").concat(t.message || "sdk inner error"),
          o = new P(i);
      throw o.name = t.name || "Error", o.code = t.code || o.code, o.errorLevel = t.errorLevel || w.Error, o.data = fe({
        code: x.InnerSDKError,
        msg: i
      }, t.data || {}), o;
    }
  }, {
    key: "formatReportData",
    value: function value(e) {
      if (!e) return {};

      if (e.plugins) {
        var t = fe({}, e);
        return delete t.plugins, t;
      }

      return e;
    }
  }, {
    key: "reportData",
    value: function value(t, n) {
      try {
        ve.report(t, n ? {
          extraData: JSON.stringify(e.formatReportData(n))
        } : {});
      } catch (r) {
        e.reportError(r, "".concat(t, "_report_data_error"), {
          data: n
        });
      }
    }
  }, {
    key: "reportErrorData",
    value: function value(t, n) {
      var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : w.Error;
      e.reportData(t, n), de(Object.assign({
        eventName: t,
        errorLevel: r
      }, e.formatReportData(n)));
    }
  }]), e;
}(),
    me = function e(t) {
  var n = this;
  i(this, e), s(this, "originData", void 0), s(this, "addReportData", function (e) {
    ve.init(e), Object.assign(n.originData, ye.formatReportData(e));
  }), s(this, "reportData", function (e, t) {
    return ye.reportData(e, t);
  }), s(this, "reportErrorData", function (e) {
    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
        r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : w.Error;
    return ye.reportErrorData(e, Object.assign({
      originData: n.originData
    }, t), r);
  }), s(this, "reportError", function (e, t, r) {
    return ye.reportError(e, t, fe(fe({
      eventName: t
    }, r || {}), {}, {
      originData: n.originData
    }));
  }), s(this, "handleError", function (e, t, r) {
    return ye.handleError(e, t, fe(fe({}, r), {}, {
      originData: n.originData
    }));
  }), this.originData = ye.formatReportData(t);
},
    ge = ["body"];

function be(e, t) {
  var n = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), n.push.apply(n, r);
  }

  return n;
}

function ke(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = null != arguments[t] ? arguments[t] : {};
    t % 2 ? be(Object(n), !0).forEach(function (t) {
      s(e, t, n[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : be(Object(n)).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
    });
  }

  return e;
}

var xe,
    we = ["/payment-sdk/assets/i18n/"],
    Ce = new (function () {
  function t() {
    var e = this;
    i(this, t), s(this, "mockValue", void 0), s(this, "options", {}), s(this, "pvIdBlackList", we), s(this, "mockReturnValue", function (t) {
      e.mockValue = t;
    }), s(this, "serialize", function (e) {
      var t = Object.prototype.toString.call(e);
      return e && "[object Object]" === t ? Object.keys(e).map(function (t) {
        return encodeURIComponent(t) + "=" + encodeURIComponent(e[t]);
      }).join("&") : "";
    }), s(this, "isInPvIdBlackList", function (t) {
      if (!t) return !0;

      for (var n = 0; n < e.pvIdBlackList.length; n++) {
        var r = e.pvIdBlackList[n];
        if (t.indexOf(r) > -1) return !0;
      }

      return !1;
    });
  }

  return a(t, [{
    key: "create",
    value: function value(e) {
      this.options = e;
    }
  }, {
    key: "get",
    value: function value(t) {
      var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
      if (this.mockValue) return this.mockValue;
      t = this.buildUrl(t, n.params);
      var r = {
        Accept: "application/json",
        "Content-Type": "application/json;charset=UTF-8"
      };
      return this.isInPvIdBlackList(t) || (r["x-pvid"] = e), this.http(t, ke(ke({
        headers: r,
        method: "GET"
      }, this.options), n));
    }
  }, {
    key: "post",
    value: function value(t, n) {
      var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
      if (this.mockValue) return this.mockValue;
      var i = {
        Accept: "application/json"
      },
          o = n || r.data;
      return "form" === r.requestType ? (i["Content-Type"] = "application/x-www-form-urlencoded;charset=UTF-8", o = this.serialize(o)) : (i["Content-Type"] = "application/json;charset=UTF-8", o = o ? JSON.stringify(o) : null), this.isInPvIdBlackList(t) || (i["x-pvid"] = e), this.http(t, ke(ke({
        headers: i,
        method: "POST",
        body: o
      }, this.options), r));
    }
  }, {
    key: "http",
    value: function value(e, t) {
      var n = this;
      return new Promise(function (r, i) {
        var o = new XMLHttpRequest(),
            a = !1,
            s = t.body,
            c = m(t, ge),
            u = n.options.baseUrl && !/^(https?\:)?(\/\/)/.test(e) ? "".concat(n.options.baseUrl).concat(e) : e;

        if (o.open(t.method, u), Object.keys(t.headers).forEach(function (e) {
          o.setRequestHeader(e, t.headers[e]);
        }), o.onreadystatechange = function () {
          if (4 === o.readyState) {
            var e = {
              options: c,
              statusCode: o.status,
              url: u
            },
                t = "";

            try {
              t = JSON.parse(o.responseText);
            } catch (e) {
              t = o.responseText;
            }

            if (/^(2|3)\d{2}$/.test(o.status.toString())) {
              try {
                r(ke({
                  data: t
                }, e));
              } catch (n) {
                r(ke({
                  data: t
                }, e));
              }

              return;
            }

            i(ke({
              data: t
            }, e));
          }
        }, o.send(s), o.onabort = function (t) {
          a = !0, ye.reportErrorData("xhr_onabort", {
            url: e,
            readyState: t.target.readyState,
            status: t.target.status,
            statusText: t.target.statusText,
            timeout: t.target.timeout,
            withCredentials: t.target.withCredentials
          });
        }, o.onerror = function (t) {
          ye.reportErrorData("xhr_onerror", {
            url: e,
            readyState: t.target.readyState,
            status: t.target.status,
            statusText: t.target.statusText,
            timeout: t.target.timeout,
            withCredentials: t.target.withCredentials
          });
        }, o.ontimeout = function (t) {
          ye.reportErrorData("xhr_ontimeout", {
            url: e,
            readyState: t.target.readyState,
            status: t.target.status,
            statusText: t.target.statusText,
            timeout: t.target.timeout,
            withCredentials: t.target.withCredentials
          });
        }, t.timeout) {
          if (a) return;
          setTimeout(function () {
            o.abort();
            var t = new Error("XMLHttpRequest timeout");
            t.code = "ETIMEDOUT", ye.reportErrorData("xhr_timeout", {
              url: e
            }), i(t);
          }, t.timeout);
        }
      });
    }
  }, {
    key: "buildUrl",
    value: function value(e, t) {
      var n = Object.prototype.toString.call(t);
      if (!t || "[object Object]" !== n) return e;
      var r = Object.keys(t);
      return (e = decodeURIComponent(e).indexOf("?") > -1 ? "".concat(e, "&") : "".concat(e, "?")) + r.map(function (e) {
        return "".concat(e, "=").concat(t[e]);
      }).join("&");
    }
  }]), t;
}())(),
    Ee = {
  Android: ["(?:(?:Orca-)?Android|Adr)[ /](?:[a-z]+ )?(\\d+[\\.\\d]*)", "Android|Silk-Accelerated=[a-z]{4,5}", "(?:TwitterAndroid).*[ /](?:[a-z]+ )?(\\d+[\\.\\d]*)", "FB4A.*FBSV/(\\d+[\\.\\d]*);", "BeyondPod|AntennaPod|Podkicker|DoggCatcher|Player FM|okhttp|Podcatcher Deluxe"],
  Linux: ["Arch ?Linux(?:[ /\\-](\\d+[\\.\\d]+))?", "VectorLinux(?: package)?(?:[ /\\-](\\d+[\\.\\d]+))?", "Linux(?:OS)?[^a-z]"],
  iOS: ["CFNetwork/889", "CFNetwork/887", "CFNetwork/811", "CFNetwork/808\\.3", "CFNetwork/808\\.2", "CFNetwork/808\\.1", "CFNetwork/808\\.0", "CFNetwork/808", "CFNetwork/758\\.4\\.3", "CFNetwork/758\\.3\\.15", "CFNetwork/758\\.2\\.[78]", "CFNetwork/758\\.1\\.6", "CFNetwork/758\\.0\\.2", "CFNetwork/711\\.5\\.6", "CFNetwork/711\\.4\\.6", "CFNetwork/711\\.3\\.18", "CFNetwork/711\\.2\\.23", "CFNetwork/711\\.1\\.1[26]", "CFNetwork/711\\.0\\.6", "CFNetwork/672\\.1", "CFNetwork/672\\.0", "CFNetwork/609\\.1", "CFNetwork/60[29]", "CFNetwork/548\\.1", "CFNetwork/548\\.0", "CFNetwork/485\\.13", "CFNetwork/485\\.12", "CFNetwork/485\\.10", "CFNetwork/485\\.2", "CFNetwork/467\\.12", "CFNetwork/459", "(?:CPU OS|iPh(?:one)?[ _]OS|iOS)[ _/](\\d+(?:[_\\.]\\d+)*)", "FBIOS.*FBSV/(\\d+[\\.\\d]*);", "(?:Apple-)?(?:iPhone|iPad|iPod)(?:.*Mac OS X.*Version/(\\d+\\.\\d+)|; Opera)?", "Podcasts/(?:[\\d\\.]+)|Instacast(?:HD)?/(?:\\d\\.[\\d\\.abc]+)|Pocket Casts, iOS|Overcast|Castro|Podcat|i[cC]atcher|RSSRadio/", "iTunes-(iPod|iPad|iPhone)/(?:[\\d\\.]+)"],
  MacOS: ["CFNetwork/887.*(x86_64)", "CFNetwork/811.*(x86_64)", "CFNetwork/807", "CFNetwork/760", "CFNetwork/720", "CFNetwork/673", "CFNetwork/596", "CFNetwork/520", "CFNetwork/454", "CFNetwork/(?:438|422|339|330|221|220|217)", "CFNetwork/12[89]", "CFNetwork/1\\.2", "CFNetwork/1\\.1", "Mac[ +]OS[ +]X(?:[ /](?:Version )?(\\d+(?:[_\\.]\\d+)+))?", "Mac (\\d+(?:[_\\.]\\d+)+)", "Darwin|Macintosh|Mac_PowerPC|PPC|Mac PowerPC|iMac|MacBook"],
  Windows: ["CYGWIN_NT-10.0|Windows NT 10.0|Windows 10", "CYGWIN_NT-6.4|Windows NT 6.4|Windows 10", "CYGWIN_NT-6.3|Windows NT 6.3|Windows 8.1", "CYGWIN_NT-6.2|Windows NT 6.2|Windows 8", "CYGWIN_NT-6.1|Windows NT 6.1|Windows 7", "CYGWIN_NT-6.0|Windows NT 6.0|Windows Vista", "CYGWIN_NT-5.2|Windows NT 5.2|Windows Server 2003 / XP x64", "CYGWIN_NT-5.1|Windows NT 5.1|Windows XP", "CYGWIN_NT-5.0|Windows NT 5.0|Windows 2000", "CYGWIN_NT-4.0|Windows NT 4.0|WinNT|Windows NT", "CYGWIN_ME-4.90|Win 9x 4.90|Windows ME", "CYGWIN_98-4.10|Win98|Windows 98", "CYGWIN_95-4.0|Win32|Win95|Windows 95|Windows_95", "Windows 3.1", "Windows"]
},
    Ie = (xe = {}, {
  set: function set(e, t) {
    xe[e] = t;
  },
  get: function get(e) {
    if (xe.hasOwnProperty(e)) return xe[e];
  }
}),
    Se = function Se(e, t) {
  try {
    var n = function (e) {
      var t = Ie.get(e);
      if (t) return t.value;
      var n = RegExp("(?:^|[^A-Z0-9-_]|[^A-Z0-9-]_|sprd-)(?:".concat(e, ")"), "i");
      return Ie.set(e, {
        value: n
      }), n;
    }(e).exec(t);

    return n ? n.slice(1) : null;
  } catch (e) {
    return null;
  }
};

function Oe(e, t) {
  var _n2 = "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];

  if (!_n2) {
    if (Array.isArray(e) || (_n2 = function (e, t) {
      if (!e) return;
      if ("string" == typeof e) return _e(e, t);
      var n = Object.prototype.toString.call(e).slice(8, -1);
      "Object" === n && e.constructor && (n = e.constructor.name);
      if ("Map" === n || "Set" === n) return Array.from(e);
      if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _e(e, t);
    }(e)) || t && e && "number" == typeof e.length) {
      _n2 && (e = _n2);

      var r = 0,
          i = function i() {};

      return {
        s: i,
        n: function n() {
          return r >= e.length ? {
            done: !0
          } : {
            done: !1,
            value: e[r++]
          };
        },
        e: function e(_e2) {
          throw _e2;
        },
        f: i
      };
    }

    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  var o,
      a = !0,
      s = !1;
  return {
    s: function s() {
      _n2 = _n2.call(e);
    },
    n: function n() {
      var e = _n2.next();

      return a = e.done, e;
    },
    e: function e(_e3) {
      s = !0, o = _e3;
    },
    f: function f() {
      try {
        a || null == _n2["return"] || _n2["return"]();
      } finally {
        if (s) throw o;
      }
    }
  };
}

function _e(e, t) {
  (null == t || t > e.length) && (t = e.length);

  for (var n = 0, r = new Array(t); n < t; n++) {
    r[n] = e[n];
  }

  return r;
}

var De = function e() {
  i(this, e), s(this, "parse", function (e) {
    for (var t = null, n = 0, r = Object.keys(Ee); n < r.length; n++) {
      var i,
          o = r[n],
          a = Oe(Ee[o]);

      try {
        for (a.s(); !(i = a.n()).done;) {
          var s = i.value;
          if (Se(s, e)) return t = o;
        }
      } catch (e) {
        a.e(e);
      } finally {
        a.f();
      }
    }

    return t;
  });
},
    Pe = "https://h.online-metrix.net/fp/tags.js",
    je = "cybs_script",
    Te = function () {
  var e;
  return function () {
    var t = r(v.mark(function t() {
      var n,
          r,
          i,
          o,
          a,
          s,
          c,
          u = arguments;
      return v.wrap(function (t) {
        for (;;) {
          switch (t.prev = t.next) {
            case 0:
              if (n = u.length > 0 && void 0 !== u[0] ? u[0] : "", !e) {
                t.next = 5;
                break;
              }

              return t.next = 4, e;

            case 4:
              return t.abrupt("return", t.sent);

            case 5:
              return r = window.screen, i = r.width, o = r.height, a = "".concat(n, "/v1/api/cashier/paysession"), s = {
                screenHeight: i.toString(),
                screenWidth: o.toString()
              }, c = Ce.get(a, {
                params: s
              }).then(function (e) {
                return e.data.paySession;
              })["catch"](function (e) {
                return ye.handleError(e, "get_paysession_error", {
                  url: a,
                  request: {
                    params: s
                  },
                  response: {
                    error: e
                  }
                });
              }), e = c, t.abrupt("return", c);

            case 11:
            case "end":
              return t.stop();
          }
        }
      }, t);
    }));
    return function () {
      return t.apply(this, arguments);
    };
  }();
}(),
    Re = function () {
  function e(t, n) {
    i(this, e), s(this, "env", void 0), s(this, "host", void 0), this.env = t, this.host = n || this.env.host;
  }

  return a(e, [{
    key: "init",
    value: function value() {
      var e = this;
      return Te(this.host).then(function (t) {
        document.querySelector("#".concat(je)) || e.appendCybsScript(t);
        var n = new De().parse(navigator.userAgent) || "Other";
        return t.label = e.env.cybsLabel, t.deviceType = e.getDeviceType(n), t.deviceOS = n, t;
      });
    }
  }, {
    key: "getDeviceType",
    value: function value(e) {
      return e ? "Linux" === e || "Windows" === e || "MacOS" === e ? "PC" : "iOS" === e || "Android" === e || "HarmonyOS" === e ? "Mobile" : "Other" : "Other";
    }
  }, {
    key: "appendCybsScript",
    value: function value(e) {
      var t = this.env.cybsMerchantId + e.sessionId,
          n = "".concat(Pe, "?org_id=").concat(this.env.cybsOrgId, "&session_id=").concat(t);
      this.appendScript(n);
    }
  }, {
    key: "appendScript",
    value: function value(e, t) {
      var n,
          r = document.getElementsByTagName("head")[0],
          i = document.createElement("script");
      i.type = "text/javascript", i.src = e, i.id = je, null === (n = document.querySelector("#".concat(je))) || void 0 === n || n.remove(), i.onload = i.onreadystatechange = function () {
        this.readyState && "loaded" !== this.readyState && "complete" !== this.readyState || (t && t(), i.onload = i.onreadystatechange = null);
      }, r.appendChild(i);
    }
  }]), e;
}();

function Fe(e, t) {
  var _n3 = "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];

  if (!_n3) {
    if (Array.isArray(e) || (_n3 = function (e, t) {
      if (!e) return;
      if ("string" == typeof e) return Ne(e, t);
      var n = Object.prototype.toString.call(e).slice(8, -1);
      "Object" === n && e.constructor && (n = e.constructor.name);
      if ("Map" === n || "Set" === n) return Array.from(e);
      if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Ne(e, t);
    }(e)) || t && e && "number" == typeof e.length) {
      _n3 && (e = _n3);

      var r = 0,
          i = function i() {};

      return {
        s: i,
        n: function n() {
          return r >= e.length ? {
            done: !0
          } : {
            done: !1,
            value: e[r++]
          };
        },
        e: function e(_e4) {
          throw _e4;
        },
        f: i
      };
    }

    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  var o,
      a = !0,
      s = !1;
  return {
    s: function s() {
      _n3 = _n3.call(e);
    },
    n: function n() {
      var e = _n3.next();

      return a = e.done, e;
    },
    e: function e(_e5) {
      s = !0, o = _e5;
    },
    f: function f() {
      try {
        a || null == _n3["return"] || _n3["return"]();
      } finally {
        if (s) throw o;
      }
    }
  };
}

function Ne(e, t) {
  (null == t || t > e.length) && (t = e.length);

  for (var n = 0, r = new Array(t); n < t; n++) {
    r[n] = e[n];
  }

  return r;
}

function Be(e, t) {
  if (!e) return null;
  var n = e.content,
      r = e.props,
      i = e.children,
      o = document.createElement(n);
  if (Object.keys(r).forEach(function (e) {
    void 0 !== r[e] && ("innerHTML" === e ? o.innerHTML = r[e] : o.setAttribute(e, r[e]));
  }), !t) return null;

  if (Array.isArray(i)) {
    var a,
        s = Fe(i);

    try {
      for (s.s(); !(a = s.n()).done;) {
        Be(a.value, o);
      }
    } catch (e) {
      s.e(e);
    } finally {
      s.f();
    }
  } else "string" == typeof i ? o.textContent = i : i || r.innerHTML ? Be(i, o) : o.textContent = "";

  "img" === n && o.addEventListener("error", function (e) {
    var t = e.target.parentNode;
    ye.reportErrorData("load_img_error", {
      src: o.src,
      parentNode: {
        nodeName: (null == t ? void 0 : t.nodeName) || "",
        className: (null == t ? void 0 : t.className) || "",
        id: (null == t ? void 0 : t.id) || ""
      }
    });
  }), t.appendChild(o);
}

var Le = [],
    Me = [];

function Ae(e, t) {
  if (e && "undefined" != typeof document) {
    var n,
        r = !0 === t.prepend ? "prepend" : "append",
        i = !0 === t.singleTag,
        o = "string" == typeof t.container ? document.querySelector(t.container) : document.getElementsByTagName("head")[0];

    if (i) {
      var a = Le.indexOf(o);
      -1 === a && (a = Le.push(o) - 1, Me[a] = {}), n = Me[a] && Me[a][r] ? Me[a][r] : Me[a][r] = s();
    } else n = s();

    65279 === e.charCodeAt(0) && (e = e.substring(1)), n.styleSheet ? n.styleSheet.cssText += e : n.appendChild(document.createTextNode(e));
  }

  function s() {
    var e = document.createElement("style");
    if (e.setAttribute("type", "text/css"), t.attributes) for (var n = Object.keys(t.attributes), i = 0; i < n.length; i++) {
      e.setAttribute(n[i], t.attributes[n[i]]);
    }
    var a = "prepend" === r ? "afterbegin" : "beforeend";
    return o.insertAdjacentElement(a, e), e;
  }
}

Ae(".pci-tooltip-wrap {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n  -webkit-tap-highlight-color: transparent;\n}\n\n.pci-tooltip-wrap::after {\n  display: none;\n  position: absolute;\n  top: -14px;\n  left: 50%;\n  content: \"\";\n  width: 0px;\n  height: 0px;\n  transform: translateX(-50%);\n  border: 7px solid;\n  border-color: rgba(30, 30, 30, 0.9) transparent transparent transparent;\n}\n\n.pci-tooltip-content {\n  display: none;\n  position: absolute;\n  bottom: 26px;\n  right: -17px;\n  box-sizing: content-box;\n  width: 180px;\n  padding: 6px 12px;\n  border-radius: 4px;\n  background-color: rgba(30, 30, 30, 0.9);\n  font-size: 12px;\n  line-height: 18px;\n  color: rgba(255, 255, 255, 0.9);\n}\n\n.pci-tooltip-wrap::before{\n  content: '';\n  display: block;\n  position: absolute;\n  left: -50%;\n  top: -50%;\n  width: 200%;\n  height: 200%;\n}\n\n.pci-tooltip-wrap:hover::after,\n.pci-tooltip-wrap:hover .pci-tooltip-content {\n  display: block;\n}\n", {});

var He = function () {
  function e() {
    i(this, e);
  }

  return a(e, [{
    key: "mount",
    value: function value(e, t) {
      Be({
        content: "div",
        props: {
          "class": "pci-tooltip-wrap"
        },
        children: {
          content: "div",
          props: {
            "class": "pci-tooltip-content"
          },
          children: t
        }
      }, e);
    }
  }]), e;
}(),
    Ve = function () {
  var e = r(v.mark(function e(t, n) {
    return v.wrap(function (e) {
      for (;;) {
        switch (e.prev = e.next) {
          case 0:
            return e.next = 2, Ce.post(t, n)["catch"](function (e) {
              ye.handleError(e, "order_pay_error", {
                url: t,
                response: {
                  error: e
                }
              });
            });

          case 2:
            return e.abrupt("return", e.sent);

          case 3:
          case "end":
            return e.stop();
        }
      }
    }, e);
  }));
  return function (t, n) {
    return e.apply(this, arguments);
  };
}(),
    Ue = function () {
  function e(t, n) {
    var r = this;
    i(this, e), s(this, "type", void 0), s(this, "payOptions", void 0), s(this, "domId", void 0), s(this, "handlePostmessage", function (e) {
      var t = e.data,
          n = e.origin;

      if (/^https:\/\/cashiers(-[^\.]+)?\.myshopline\.com$/.test(n)) {
        ye.reportData("challenge_next_action", {
          validateState: JSON.stringify(t)
        });
        var i = t.success,
            o = t.nextAction || {},
            a = o.url,
            s = o.type;

        if (window.removeEventListener("message", r.handlePostmessage, !1), i) {
          if (s === f.Redirect && a) {
            if (r.type === f.WorldPayChallenge) {
              var c = document.getElementById(r.domId);
              c && c.parentElement && c.parentElement.removeChild(c);
            }

            Je(o, r.payOptions);
          }
        } else ye.reportErrorData("challenge_next_action_error", t);
      }
    }), this.type = t, this.payOptions = n;
  }

  return a(e, [{
    key: "startChallenge",
    value: function value(e) {
      this.type === f.WorldPayChallenge && this.iframePost(e, "worldPayChallengeIframe-".concat(Date.now()));
    }
  }, {
    key: "iframePost",
    value: function value(e, t) {
      var n = e.url,
          r = e.method,
          i = e.data,
          o = i.size,
          a = i.requestParams,
          s = void 0 === a ? {} : a;
      this.domId = t, Be({
        content: "div",
        props: {
          id: t
        },
        children: [{
          content: "div",
          props: {
            style: "\n            position: fixed;\n            width: 100%;\n            height: 100%;\n            z-index: 1000;\n            top: 0;\n            left: 0;\n            background-color: rgba(0, 0, 0, 0.45);\n            "
          }
        }, {
          content: "div",
          props: {
            style: "\n              position: fixed;\n              width: 100%;\n              height: 100%;\n              z-index: 1000;\n              top: 0;\n              left: 0;\n            "
          },
          children: {
            content: "iframe",
            props: {
              src: n,
              name: t,
              style: "\n                position: relative;\n                width: ".concat(o.width, ";\n                height: ").concat(o.height, ";\n                top: 50%;\n                left: 50%;\n                transform: translate(-50%, -50%);\n                background: #fff;\n              ")
            }
          }
        }]
      }, document.body), window.removeEventListener("message", this.handlePostmessage, !1), window.addEventListener("message", this.handlePostmessage, !1), Ze(n, s, r, t);
    }
  }]), e;
}(),
    qe = function () {
  function e(t, n) {
    var r = this;
    i(this, e), s(this, "type", void 0), s(this, "payOptions", void 0), s(this, "domId", void 0), s(this, "handlePostmessage", function (e) {
      var t = e.data;

      if (function (e) {
        return /^https:\/\/cashiers(-[^\.]+)?\.myshopline\.com$/.test(e);
      }(e.origin)) {
        var n = t.success,
            i = t.nextAction || {},
            o = t.nextAction || {},
            a = o.url,
            s = o.type;

        if (ye.reportData("useepay_3ds_next_action_".concat(s), {
          validateState: JSON.stringify(t)
        }), n) {
          if (s === f.Redirect && a) {
            if (window.removeEventListener("message", r.handlePostmessage, !1), r.domId) {
              var c = document.getElementById(r.domId);
              c && c.parentElement && c.parentElement.removeChild(c);
            }

            Je(i, r.payOptions);
          }

          s === f.UseepayChallenge && r.challenge(t.nextAction);
        } else ye.reportErrorData("useepay_3ds_next_action_".concat(s, "_error"), t);
      }
    }), this.type = t, this.payOptions = n;
  }

  return a(e, [{
    key: "gather",
    value: function value(e) {
      var t = e.url,
          n = e.method,
          r = e.data,
          i = "UseepayGatherIframe-".concat(Date.now()),
          o = document.createElement("iframe");
      o.src = t, o.name = i, o.style.width = "0", o.style.height = "0", o.style.display = "none", document.body.appendChild(o), window.removeEventListener("message", this.handlePostmessage, !1), window.addEventListener("message", this.handlePostmessage, !1), Ze(t, r, n, i);
    }
  }, {
    key: "challenge",
    value: function value(e) {
      e.type === f.UseepayChallenge && this.iframePost(e, "UseepayChallengeIframe-".concat(Date.now()));
    }
  }, {
    key: "iframePost",
    value: function value(e, t) {
      var n = e.url;
      this.domId = t, Be({
        content: "div",
        props: {
          id: t
        },
        children: [{
          content: "div",
          props: {
            style: "\n            position: fixed;\n            width: 100%;\n            height: 100%;\n            z-index: 1000;\n            top: 0;\n            left: 0;\n            "
          }
        }, {
          content: "div",
          props: {
            style: "\n              position: fixed;\n              width: 100%;\n              height: 100%;\n              z-index: 1000;\n              top: 0;\n              left: 0;\n            "
          },
          children: {
            content: "iframe",
            props: {
              src: n,
              name: t,
              style: "\n                position: relative;\n                width: 100%;\n                height: 100%;\n                top: 50%;\n                left: 50%;\n                transform: translate(-50%, -50%);\n                background: #fff;\n              "
            }
          }
        }]
      }, document.body), window.removeEventListener("message", this.handlePostmessage, !1), window.addEventListener("message", this.handlePostmessage, !1);
    }
  }]), e;
}();

function ze(e) {
  return (ze = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (e) {
    return _typeof(e);
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : _typeof(e);
  })(e);
}

function Xe(e) {
  return "[object Object]" === Object.prototype.toString.call(e);
}

function We(e) {
  return !e || !!e.nodeType || "object" !== ze(e) ? e : JSON.parse(JSON.stringify(e));
}

function Ge(e, t) {
  if (function (e) {
    return void 0 === e;
  }(n = t) || function (e) {
    return null === e;
  }(n)) return We(e);
  var n;
  if (!Xe(t) || !Xe(e)) return We(t);
  var r = {};
  return Object.keys(e).map(function (n) {
    r[n] = Ge(e[n], t[n]);
  }), Object.keys(t).map(function (e) {
    r[e] || (r[e] = We(t[e]));
  }), r;
}

function Ze(e, t) {
  var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "post",
      r = arguments.length > 3 ? arguments[3] : void 0,
      i = document.createElement("form");

  for (var o in i.style.display = "none", i.method = n, i.action = e, r && (i.target = r), t) {
    var a = document.createElement("input");
    a.name = o, a.value = t[o], i.appendChild(a);
  }

  document.body.appendChild(i), i.submit();
}

function Je(e, t) {
  return Qe.apply(this, arguments);
}

function Qe() {
  return (Qe = r(v.mark(function e(t, n) {
    var i, o, a, s, c, u, l, p;
    return v.wrap(function (e) {
      for (;;) {
        switch (e.prev = e.next) {
          case 0:
            return i = t.method, o = void 0 === i ? "GET" : i, a = t.url, s = t.data, c = t.target, u = null == n ? void 0 : n.beforeRedirect, l = new Promise(function () {
              var e = r(v.mark(function e(n) {
                return v.wrap(function (e) {
                  for (;;) {
                    switch (e.prev = e.next) {
                      case 0:
                        if (!u) {
                          e.next = 9;
                          break;
                        }

                        return e.prev = 1, e.next = 4, u(c);

                      case 4:
                        e.next = 9;
                        break;

                      case 6:
                        e.prev = 6, e.t0 = e["catch"](1), ye.reportErrorData("before_redirect_error", {
                          nextAction: t,
                          error: e.t0
                        });

                      case 9:
                        n(null);

                      case 10:
                      case "end":
                        return e.stop();
                    }
                  }
                }, e, null, [[1, 6]]);
              }));
              return function (t) {
                return e.apply(this, arguments);
              };
            }()), p = new Promise(function (e) {
              setTimeout(e, 3e3);
            }), e.abrupt("return", Promise.race([l, p]).then(function () {
              "POST" === o ? Ze(a, s) : "GET" === o && (window.location.href = a);
            }));

          case 5:
          case "end":
            return e.stop();
        }
      }
    }, e);
  }))).apply(this, arguments);
}

function Ye(e) {
  return $e.apply(this, arguments);
}

function $e() {
  return ($e = r(v.mark(function e(t) {
    var n,
        r,
        i,
        o,
        a,
        s,
        c,
        u,
        l = arguments;
    return v.wrap(function (e) {
      for (;;) {
        switch (e.prev = e.next) {
          case 0:
            if (n = l.length > 1 && void 0 !== l[1] ? l[1] : {}, r = n.payOptions, i = n.paymentMethod, o = n.subPaymentMethod, a = null == r ? void 0 : r.hooks, t.type !== f.Confirm) {
              e.next = 24;
              break;
            }

            if (e.t0 = null == a ? void 0 : a.beforeConfirm, !e.t0) {
              e.next = 8;
              break;
            }

            return e.next = 8, a.beforeConfirm()["catch"](ye.handleError);

          case 8:
            if (s = {
              paymentInstrument: {
                paymentMethod: i,
                subPaymentMethod: o
              }
            }, null == a || !a.extendConfirmParams) {
              e.next = 14;
              break;
            }

            return e.next = 12, a.extendConfirmParams()["catch"](ye.handleError);

          case 12:
            (c = e.sent) && Xe(c) && (s = Ge(c, s));

          case 14:
            return e.next = 16, Ve(t.url, s)["catch"](ye.handleError);

          case 16:
            if (u = e.sent, e.t1 = null == a ? void 0 : a.afterConfirm, !e.t1) {
              e.next = 21;
              break;
            }

            return e.next = 21, a.afterConfirm()["catch"](ye.handleError);

          case 21:
            return e.abrupt("return", Ke(u, r));

          case 24:
            if (t.type !== f.Redirect) {
              e.next = 29;
              break;
            }

            return e.next = 27, Je(t)["catch"](ye.handleError);

          case 27:
            e.next = 47;
            break;

          case 29:
            if (t.type !== f.WorldPayChallenge) {
              e.next = 35;
              break;
            }

            return new Ue(t.type, r).startChallenge(t), e.abrupt("return");

          case 35:
            if (t.type !== f.UseepayChallenge) {
              e.next = 40;
              break;
            }

            new qe(t.type, r).challenge(t), e.next = 47;
            break;

          case 40:
            if (t.type !== f.UseepayGather) {
              e.next = 45;
              break;
            }

            new qe(t.type, r).gather(t), e.next = 47;
            break;

          case 45:
            if (null == a || !a.handlePayAction) {
              e.next = 47;
              break;
            }

            return e.abrupt("return", a.handlePayAction(t));

          case 47:
          case "end":
            return e.stop();
        }
      }
    }, e);
  }))).apply(this, arguments);
}

function Ke(e, t) {
  return et.apply(this, arguments);
}

function et() {
  return (et = r(v.mark(function e(t, n) {
    var r;
    return v.wrap(function (e) {
      for (;;) {
        switch (e.prev = e.next) {
          case 0:
            if (200 !== t.statusCode) {
              e.next = 5;
              break;
            }

            return r = t.data.nextAction, e.abrupt("return", Ye(r, {
              payOptions: n
            }));

          case 5:
            ye.handleError(t, "pay_nextAction_error");

          case 6:
          case "end":
            return e.stop();
        }
      }
    }, e);
  }))).apply(this, arguments);
}

var tt = function tt(e, t, n) {
  var r = {},
      i = window.navigator,
      o = i.userAgent,
      a = i.language,
      s = window.screen,
      c = s.colorDepth,
      u = s.width,
      p = s.height,
      d = window.navigator.javaEnabled().toString();
  return r.client = {
    transactionWebSite: window.location.href,
    javaEnabled: d,
    colorDepth: c.toString(),
    screenHeight: u.toString(),
    screenWidth: p.toString(),
    timeZoneOffset: new Date().getTimezoneOffset().toString(),
    accept: "application/json",
    userAgent: o,
    language: a,
    javaScriptEnabled: "true"
  }, e === l.WorldPay && (null == t ? void 0 : t.type) === f.WorldPayGather && (r.additionalData = {
    ddcReferenceId: (null == t ? void 0 : t.SessionId) || ""
  }), null != n && n.isInstallment && null != n && n.installmentCount && (r.paymentMethodOptions = {
    installments: {
      count: null == n ? void 0 : n.installmentCount
    }
  }), r;
};

function nt() {
  var e = new Date().getTime();
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (t) {
    var n = (e + 16 * Math.random()) % 16 | 0;
    return e = Math.floor(e / 16), ("x" == t ? n : 3 & n | 8).toString(16);
  });
}

function rt(e, t, n, r, i, o, a) {
  try {
    var s = e[o](a),
        c = s.value;
  } catch (e) {
    return void n(e);
  }

  s.done ? t(c) : Promise.resolve(c).then(r, i);
}

function it(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}

function ot(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}

function at(e, t, n) {
  return t && ot(e.prototype, t), n && ot(e, n), e;
}

function st(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}

var ct = {
  exports: {}
};
!function (e) {
  var t = function (e) {
    var t,
        n = Object.prototype,
        r = n.hasOwnProperty,
        i = "function" == typeof Symbol ? Symbol : {},
        o = i.iterator || "@@iterator",
        a = i.asyncIterator || "@@asyncIterator",
        s = i.toStringTag || "@@toStringTag";

    function c(e, t, n) {
      return Object.defineProperty(e, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }), e[t];
    }

    try {
      c({}, "");
    } catch (e) {
      c = function c(e, t, n) {
        return e[t] = n;
      };
    }

    function u(e, t, n, r) {
      var i = t && t.prototype instanceof y ? t : y,
          o = Object.create(i.prototype),
          a = new _(r || []);
      return o._invoke = function (e, t, n) {
        var r = p;
        return function (i, o) {
          if (r === h) throw new Error("Generator is already running");

          if (r === f) {
            if ("throw" === i) throw o;
            return P();
          }

          for (n.method = i, n.arg = o;;) {
            var a = n.delegate;

            if (a) {
              var s = I(a, n);

              if (s) {
                if (s === v) continue;
                return s;
              }
            }

            if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
              if (r === p) throw r = f, n.arg;
              n.dispatchException(n.arg);
            } else "return" === n.method && n.abrupt("return", n.arg);
            r = h;
            var c = l(e, t, n);

            if ("normal" === c.type) {
              if (r = n.done ? f : d, c.arg === v) continue;
              return {
                value: c.arg,
                done: n.done
              };
            }

            "throw" === c.type && (r = f, n.method = "throw", n.arg = c.arg);
          }
        };
      }(e, n, a), o;
    }

    function l(e, t, n) {
      try {
        return {
          type: "normal",
          arg: e.call(t, n)
        };
      } catch (e) {
        return {
          type: "throw",
          arg: e
        };
      }
    }

    e.wrap = u;
    var p = "suspendedStart",
        d = "suspendedYield",
        h = "executing",
        f = "completed",
        v = {};

    function y() {}

    function m() {}

    function g() {}

    var b = {};

    b[o] = function () {
      return this;
    };

    var k = Object.getPrototypeOf,
        x = k && k(k(D([])));
    x && x !== n && r.call(x, o) && (b = x);
    var w = g.prototype = y.prototype = Object.create(b);

    function C(e) {
      ["next", "throw", "return"].forEach(function (t) {
        c(e, t, function (e) {
          return this._invoke(t, e);
        });
      });
    }

    function E(e, t) {
      function n(i, o, a, s) {
        var c = l(e[i], e, o);

        if ("throw" !== c.type) {
          var u = c.arg,
              p = u.value;
          return p && "object" == _typeof(p) && r.call(p, "__await") ? t.resolve(p.__await).then(function (e) {
            n("next", e, a, s);
          }, function (e) {
            n("throw", e, a, s);
          }) : t.resolve(p).then(function (e) {
            u.value = e, a(u);
          }, function (e) {
            return n("throw", e, a, s);
          });
        }

        s(c.arg);
      }

      var i;

      this._invoke = function (e, r) {
        function o() {
          return new t(function (t, i) {
            n(e, r, t, i);
          });
        }

        return i = i ? i.then(o, o) : o();
      };
    }

    function I(e, n) {
      var r = e.iterator[n.method];

      if (r === t) {
        if (n.delegate = null, "throw" === n.method) {
          if (e.iterator["return"] && (n.method = "return", n.arg = t, I(e, n), "throw" === n.method)) return v;
          n.method = "throw", n.arg = new TypeError("The iterator does not provide a 'throw' method");
        }

        return v;
      }

      var i = l(r, e.iterator, n.arg);
      if ("throw" === i.type) return n.method = "throw", n.arg = i.arg, n.delegate = null, v;
      var o = i.arg;
      return o ? o.done ? (n[e.resultName] = o.value, n.next = e.nextLoc, "return" !== n.method && (n.method = "next", n.arg = t), n.delegate = null, v) : o : (n.method = "throw", n.arg = new TypeError("iterator result is not an object"), n.delegate = null, v);
    }

    function S(e) {
      var t = {
        tryLoc: e[0]
      };
      1 in e && (t.catchLoc = e[1]), 2 in e && (t.finallyLoc = e[2], t.afterLoc = e[3]), this.tryEntries.push(t);
    }

    function O(e) {
      var t = e.completion || {};
      t.type = "normal", delete t.arg, e.completion = t;
    }

    function _(e) {
      this.tryEntries = [{
        tryLoc: "root"
      }], e.forEach(S, this), this.reset(!0);
    }

    function D(e) {
      if (e) {
        var n = e[o];
        if (n) return n.call(e);
        if ("function" == typeof e.next) return e;

        if (!isNaN(e.length)) {
          var i = -1,
              a = function n() {
            for (; ++i < e.length;) {
              if (r.call(e, i)) return n.value = e[i], n.done = !1, n;
            }

            return n.value = t, n.done = !0, n;
          };

          return a.next = a;
        }
      }

      return {
        next: P
      };
    }

    function P() {
      return {
        value: t,
        done: !0
      };
    }

    return m.prototype = w.constructor = g, g.constructor = m, m.displayName = c(g, s, "GeneratorFunction"), e.isGeneratorFunction = function (e) {
      var t = "function" == typeof e && e.constructor;
      return !!t && (t === m || "GeneratorFunction" === (t.displayName || t.name));
    }, e.mark = function (e) {
      return Object.setPrototypeOf ? Object.setPrototypeOf(e, g) : (e.__proto__ = g, c(e, s, "GeneratorFunction")), e.prototype = Object.create(w), e;
    }, e.awrap = function (e) {
      return {
        __await: e
      };
    }, C(E.prototype), E.prototype[a] = function () {
      return this;
    }, e.AsyncIterator = E, e.async = function (t, n, r, i, o) {
      void 0 === o && (o = Promise);
      var a = new E(u(t, n, r, i), o);
      return e.isGeneratorFunction(n) ? a : a.next().then(function (e) {
        return e.done ? e.value : a.next();
      });
    }, C(w), c(w, s, "Generator"), w[o] = function () {
      return this;
    }, w.toString = function () {
      return "[object Generator]";
    }, e.keys = function (e) {
      var t = [];

      for (var n in e) {
        t.push(n);
      }

      return t.reverse(), function n() {
        for (; t.length;) {
          var r = t.pop();
          if (r in e) return n.value = r, n.done = !1, n;
        }

        return n.done = !0, n;
      };
    }, e.values = D, _.prototype = {
      constructor: _,
      reset: function reset(e) {
        if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(O), !e) for (var n in this) {
          "t" === n.charAt(0) && r.call(this, n) && !isNaN(+n.slice(1)) && (this[n] = t);
        }
      },
      stop: function stop() {
        this.done = !0;
        var e = this.tryEntries[0].completion;
        if ("throw" === e.type) throw e.arg;
        return this.rval;
      },
      dispatchException: function dispatchException(e) {
        if (this.done) throw e;
        var n = this;

        function i(r, i) {
          return s.type = "throw", s.arg = e, n.next = r, i && (n.method = "next", n.arg = t), !!i;
        }

        for (var o = this.tryEntries.length - 1; o >= 0; --o) {
          var a = this.tryEntries[o],
              s = a.completion;
          if ("root" === a.tryLoc) return i("end");

          if (a.tryLoc <= this.prev) {
            var c = r.call(a, "catchLoc"),
                u = r.call(a, "finallyLoc");

            if (c && u) {
              if (this.prev < a.catchLoc) return i(a.catchLoc, !0);
              if (this.prev < a.finallyLoc) return i(a.finallyLoc);
            } else if (c) {
              if (this.prev < a.catchLoc) return i(a.catchLoc, !0);
            } else {
              if (!u) throw new Error("try statement without catch or finally");
              if (this.prev < a.finallyLoc) return i(a.finallyLoc);
            }
          }
        }
      },
      abrupt: function abrupt(e, t) {
        for (var n = this.tryEntries.length - 1; n >= 0; --n) {
          var i = this.tryEntries[n];

          if (i.tryLoc <= this.prev && r.call(i, "finallyLoc") && this.prev < i.finallyLoc) {
            var o = i;
            break;
          }
        }

        o && ("break" === e || "continue" === e) && o.tryLoc <= t && t <= o.finallyLoc && (o = null);
        var a = o ? o.completion : {};
        return a.type = e, a.arg = t, o ? (this.method = "next", this.next = o.finallyLoc, v) : this.complete(a);
      },
      complete: function complete(e, t) {
        if ("throw" === e.type) throw e.arg;
        return "break" === e.type || "continue" === e.type ? this.next = e.arg : "return" === e.type ? (this.rval = this.arg = e.arg, this.method = "return", this.next = "end") : "normal" === e.type && t && (this.next = t), v;
      },
      finish: function finish(e) {
        for (var t = this.tryEntries.length - 1; t >= 0; --t) {
          var n = this.tryEntries[t];
          if (n.finallyLoc === e) return this.complete(n.completion, n.afterLoc), O(n), v;
        }
      },
      "catch": function _catch(e) {
        for (var t = this.tryEntries.length - 1; t >= 0; --t) {
          var n = this.tryEntries[t];

          if (n.tryLoc === e) {
            var r = n.completion;

            if ("throw" === r.type) {
              var i = r.arg;
              O(n);
            }

            return i;
          }
        }

        throw new Error("illegal catch attempt");
      },
      delegateYield: function delegateYield(e, n, r) {
        return this.delegate = {
          iterator: D(e),
          resultName: n,
          nextLoc: r
        }, "next" === this.method && (this.arg = t), v;
      }
    }, e;
  }(ct.exports);

  try {
    regeneratorRuntime = t;
  } catch (e) {
    Function("r", "regeneratorRuntime = r")(t);
  }
}();

var ut,
    lt,
    pt,
    dt = ct.exports,
    ht = function () {
  function e() {
    it(this, e), st(this, "uuid", void 0), st(this, "iframeHost", "*");
  }

  return at(e, [{
    key: "setUuid",
    value: function value(e) {
      this.uuid = e;
    }
  }, {
    key: "setIframeHost",
    value: function value(e) {
      this.iframeHost = e || "https://cashiers.myshopline.com";
    }
  }, {
    key: "setAttr",
    value: function value(e, t) {
      var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : this.iframeHost,
          r = {
        eventType: "setAttr",
        uuid: this.uuid,
        attr: e
      };
      this.postToChild(t + this.uuid, r, n);
    }
  }, {
    key: "setInitData",
    value: function value(e, t) {
      var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : this.iframeHost,
          r = {
        eventType: "initData",
        uuid: this.uuid,
        pvId: e.pvId,
        extraConfig: e.extraConfig
      };
      this.postToChild(t + this.uuid, r, n);
    }
  }, {
    key: "setStyle",
    value: function value(e, t, n) {
      var r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : this.iframeHost,
          i = {
        eventType: "setStyle",
        uuid: this.uuid,
        type: t,
        name: n,
        style: e
      };
      this.postToChild(n + this.uuid, i, r);
    }
  }, {
    key: "postInput",
    value: function value(e, t, n) {
      var r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : "*",
          i = {
        eventType: "input",
        name: e,
        uuid: this.uuid,
        isEmpty: t,
        isValid: n
      };
      this.postToParent(i, r);
    }
  }, {
    key: "postFocus",
    value: function value(e, t, n, r) {
      var i = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : "*",
          o = {
        eventType: "focus",
        name: e,
        uuid: this.uuid,
        isEmpty: t,
        isFocus: n,
        isValid: r
      };
      this.postToParent(o, i);
    }
  }, {
    key: "postFocusToNumber",
    value: function value(e, t) {
      var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "*",
          r = {
        eventType: "focus",
        name: e,
        uuid: this.uuid,
        isFocus: t
      };
      this.postToIframe("number".concat(this.uuid), r, n);
    }
  }, {
    key: "postPasteToNumber",
    value: function value(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "*",
          n = {
        eventType: "paste",
        name: e,
        uuid: this.uuid
      };
      this.postToIframe("number".concat(this.uuid), n, t);
    }
  }, {
    key: "brandChange",
    value: function value(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "*",
          n = {
        eventType: "brandChange",
        uuid: this.uuid,
        brand: e
      };
      this.postToParent(n, t);
    }
  }, {
    key: "postValue",
    value: function value(e, t, n) {
      var r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : "*",
          i = {
        eventType: "input",
        name: e,
        uuid: this.uuid,
        value: t
      };
      this.postToIframe(n + this.uuid, i, r);
    }
  }, {
    key: "postFilling",
    value: function value(e, t, n) {
      var r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : "*",
          i = {
        eventType: "filling",
        name: e,
        uuid: this.uuid,
        value: t
      };
      this.postToIframe(n + this.uuid, i, r);
    }
  }, {
    key: "getValidate",
    value: function value(e, t) {
      var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : this.iframeHost,
          r = {
        eventType: "getValidate",
        uuid: this.uuid,
        hasCardName: e
      };
      this.postToChild(t + this.uuid, r, n);
    }
  }, {
    key: "postValidate",
    value: function value(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "*",
          n = {
        eventType: "validate",
        uuid: this.uuid,
        isValid: e
      };
      this.postToParent(n, t);
    }
  }, {
    key: "getCardBrand",
    value: function value(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : this.iframeHost,
          n = {
        eventType: "getCardBrand",
        uuid: this.uuid
      };
      this.postToChild(e + this.uuid, n, t);
    }
  }, {
    key: "postCardBrand",
    value: function value(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "*",
          n = {
        eventType: "getCardBrand",
        uuid: this.uuid,
        brand: e
      };
      this.postToParent(n, t);
    }
  }, {
    key: "getBeforePayData",
    value: function value(e, t) {
      var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : this.iframeHost,
          r = {
        eventType: "getBeforePayData",
        nextAction: e,
        uuid: this.uuid
      };
      this.postToChild(t + this.uuid, r, n);
    }
  }, {
    key: "postBeforePayData",
    value: function value(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "*",
          n = {
        eventType: "getBeforePayData",
        uuid: this.uuid,
        value: e
      };
      this.postToParent(n, t);
    }
  }, {
    key: "setCardBinOptions",
    value: function value(e, t) {
      var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : this.iframeHost,
          r = {
        eventType: "setCardBinOptions",
        cardBinOptions: e,
        uuid: this.uuid
      };
      this.postToChild(t + this.uuid, r, n);
    }
  }, {
    key: "postCardBinOptionsResolve",
    value: function value() {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "*",
          t = {
        eventType: "setCardBinOptions",
        uuid: this.uuid
      };
      this.postToParent(t, e);
    }
  }, {
    key: "getCardToken",
    value: function value(e, t, n) {
      var r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : this.iframeHost,
          i = {
        eventType: "getCardToken",
        options: e,
        hasCardName: t,
        uuid: this.uuid
      };
      this.postToChild(n + this.uuid, i, r);
    }
  }, {
    key: "postCardTokenResult",
    value: function value(e, t) {
      var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "*",
          r = {
        eventType: "cardTokenResult",
        uuid: this.uuid,
        status: e,
        value: t
      };
      this.postToParent(r, n);
    }
  }, {
    key: "cardBinVerifyChange",
    value: function value(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "*",
          n = {
        eventType: "cardBinVerifyChange",
        uuid: this.uuid,
        value: e
      };
      this.postToParent(n, t);
    }
  }, {
    key: "getCardBinVerifyResult",
    value: function value(e, t) {
      var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : this.iframeHost,
          r = {
        eventType: "getCardBinVerifyResult",
        readCache: e,
        uuid: this.uuid
      };
      this.postToChild(t + this.uuid, r, n);
    }
  }, {
    key: "postCardBinVerifyResult",
    value: function value(e, t) {
      var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "*",
          r = {
        eventType: "cardBinVerifyResult",
        uuid: this.uuid,
        status: e,
        value: t
      };
      this.postToParent(r, n);
    }
  }, {
    key: "pay",
    value: function value(e, t, n, r) {
      var i = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : this.iframeHost,
          o = {
        eventType: "pay",
        uuid: this.uuid,
        nextAction: e,
        hasCardName: t,
        requestParams: n
      };
      this.postToChild(r + this.uuid, o, i);
    }
  }, {
    key: "payResult",
    value: function value(e, t) {
      var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "*",
          r = {
        eventType: "payResult",
        uuid: this.uuid,
        status: e,
        value: t
      };
      this.postToParent(r, n);
    }
  }, {
    key: "loadFinished",
    value: function value(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "*",
          n = {
        eventType: "loadFinished",
        uuid: this.uuid,
        name: e
      };
      this.postToParent(n, t);
    }
  }, {
    key: "postToChild",
    value: function value(e, t, n) {
      var r;
      null === (r = window.frames[e]) || void 0 === r || r.postMessage(t, n);
    }
  }, {
    key: "postToParent",
    value: function value(e, t) {
      window.parent.postMessage(e, t);
    }
  }, {
    key: "postToIframe",
    value: function value(e, t, n) {
      var r;
      null === (r = window.parent.frames[e]) || void 0 === r || r.postMessage(t, n);
    }
  }]), e;
}();

function ft(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}

function vt(e, t) {
  return (vt = Object.setPrototypeOf || function (e, t) {
    return e.__proto__ = t, e;
  })(e, t);
}

function yt(e, t) {
  if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), t && vt(e, t);
}

function mt(e) {
  return (mt = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (e) {
    return _typeof(e);
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : _typeof(e);
  })(e);
}

function gt(e, t) {
  return !t || "object" !== mt(t) && "function" != typeof t ? ft(e) : t;
}

function bt(e) {
  return (bt = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
    return e.__proto__ || Object.getPrototypeOf(e);
  })(e);
}

function kt() {
  if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
  if (Reflect.construct.sham) return !1;
  if ("function" == typeof Proxy) return !0;

  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
  } catch (e) {
    return !1;
  }
}

function xt(e, t, n) {
  return (xt = kt() ? Reflect.construct : function (e, t, n) {
    var r = [null];
    r.push.apply(r, t);
    var i = new (Function.bind.apply(e, r))();
    return n && vt(i, n.prototype), i;
  }).apply(null, arguments);
}

function wt(e) {
  var t = "function" == typeof Map ? new Map() : void 0;
  return (wt = function wt(e) {
    if (null === e || (n = e, -1 === Function.toString.call(n).indexOf("[native code]"))) return e;
    var n;
    if ("function" != typeof e) throw new TypeError("Super expression must either be null or a function");

    if (void 0 !== t) {
      if (t.has(e)) return t.get(e);
      t.set(e, r);
    }

    function r() {
      return xt(e, arguments, bt(this).constructor);
    }

    return r.prototype = Object.create(e.prototype, {
      constructor: {
        value: r,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), vt(r, e);
  })(e);
}

function Ct(e) {
  var t = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;

    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }();

  return function () {
    var n,
        r = bt(e);

    if (t) {
      var i = bt(this).constructor;
      n = Reflect.construct(r, arguments, i);
    } else n = r.apply(this, arguments);

    return gt(this, n);
  };
}

!function (e) {
  e.NotSupportBrowser = "1026", e.InnerSDKError = "1027", e.RenderFail = "1028", e.NetworkError = "2905";
}(ut || (ut = {})), function (e) {
  e.Fatal = "fatal", e.Error = "error";
}(lt || (lt = {})), function (e) {
  e.IframeError = "PciIframeError", e.NoDom = "NoDomError";
}(pt || (pt = {}));

var Et,
    It,
    St = function (e) {
  yt(n, wt(Error));
  var t = Ct(n);

  function n(e) {
    var r,
        i = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : ut.InnerSDKError,
        o = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "SilenceError",
        a = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : lt.Error;
    return it(this, n), st(ft(r = t.call(this, e)), "code", void 0), st(ft(r), "data", void 0), st(ft(r), "errorLevel", void 0), r.name = o, r.code = i, r.errorLevel = a, r;
  }

  return n;
}(),
    Ot = function (e) {
  yt(n, wt(Error));
  var t = Ct(n);

  function n(e) {
    var r,
        i = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "UnknownError",
        o = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : ut.InnerSDKError,
        a = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : lt.Error;
    return it(this, n), st(ft(r = t.call(this, e)), "code", void 0), st(ft(r), "isReported", !1), st(ft(r), "data", void 0), st(ft(r), "errorLevel", void 0), r.name = i, r.code = o, r.errorLevel = a, r;
  }

  return at(n, [{
    key: "setIsReported",
    value: function value() {
      this.isReported = !0;
    }
  }]), n;
}(),
    _t = function () {
  function t(e) {
    it(this, t), st(this, "uuid", void 0), st(this, "parentDom", void 0), this.uuid = e;
  }

  return at(t, [{
    key: "setParentDom",
    value: function value(e) {
      this.parentDom = e;
    }
  }, {
    key: "mountIframe",
    value: function value(e, t, n, r) {
      var i = this.parentDom.querySelector(e);
      if (!i) throw new Ot("Can't find the related dom node to mount the iframe", pt.NoDom);
      var o = document.createElement("iframe");
      o.onload = r, o.src = n, o.name = t, o.id = t, o.style.width = "100%", o.style.height = "100%", o.style.border = "none", i.innerHTML = "", i.appendChild(o);
    }
  }, {
    key: "unmountDom",
    value: function value(e) {
      var t = this.parentDom.querySelector(e);
      t && (t.innerHTML = "");
    }
  }, {
    key: "renderIframe",
    value: function value(t, n, r, i) {
      var o = this,
          a = t ? "".concat(t, "/pci-sdk") : "https://cashiers.myshopline.com/pci-sdk";
      n.forEach(function (t) {
        var n = "".concat(a, "/iframe.html?name=").concat(t);
        o.mountIframe('[data-pci="'.concat(t, '"]'), "".concat(t).concat(o.uuid), n, function () {
          var n = r.placeholder,
              o = r.extraConfig;
          i.setInitData({
            pvId: e,
            extraConfig: o
          }, t), n && n[t] && i.setAttr({
            placeholder: n[t]
          }, t);
        });
      });
    }
  }]), t;
}();

function Dt(e, t) {
  (null == t || t > e.length) && (t = e.length);

  for (var n = 0, r = new Array(t); n < t; n++) {
    r[n] = e[n];
  }

  return r;
}

function Pt(e) {
  return function (e) {
    if (Array.isArray(e)) return Dt(e);
  }(e) || function (e) {
    if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
  }(e) || function (e, t) {
    if (e) {
      if ("string" == typeof e) return Dt(e, t);
      var n = Object.prototype.toString.call(e).slice(8, -1);
      return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? Dt(e, t) : void 0;
    }
  }(e) || function () {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}

function jt(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}

function Tt(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}

function Rt(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}

function Ft(e, t, n) {
  return t && Rt(e.prototype, t), n && Rt(e, n), e;
}

function Nt(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}

function Bt(e) {
  return (Bt = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
    return e.__proto__ || Object.getPrototypeOf(e);
  })(e);
}

function Lt(e, t, n) {
  return (Lt = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function (e, t, n) {
    var r = function (e, t) {
      for (; !Object.prototype.hasOwnProperty.call(e, t) && null !== (e = Bt(e));) {
        ;
      }

      return e;
    }(e, t);

    if (r) {
      var i = Object.getOwnPropertyDescriptor(r, t);
      return i.get ? i.get.call(n) : i.value;
    }
  })(e, t, n || e);
}

function Mt(e, t) {
  return (Mt = Object.setPrototypeOf || function (e, t) {
    return e.__proto__ = t, e;
  })(e, t);
}

function At(e) {
  return (At = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (e) {
    return _typeof(e);
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : _typeof(e);
  })(e);
}

function Ht(e, t) {
  return !t || "object" !== At(t) && "function" != typeof t ? Nt(e) : t;
}

!function (e) {
  e.Redirect = "Redirect", e.Confirm = "Confirm", e.QrCode = "QrCode", e.WorldPayGather = "WorldPayGather";
}(Et || (Et = {})), function (e) {
  e.Success = "success", e.Fail = "fail";
}(It || (It = {}));
var Vt = /^\s*at (?:(.*?) ?\()?((?:file|https?|blob|chrome-extension|address|native|eval|webpack|<anonymous>|[-a-z]+:|.*bundle|\/).*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i,
    Ut = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:file|https?|blob|chrome|webpack|resource|moz-extension).*?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js))(?::(\d+))?(?::(\d+))?\s*$/i,
    qt = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:file|ms-appx|https?|webpack|blob):.*?):(\d+)(?::(\d+))?\)?\s*$/i,
    zt = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+))?@)([\w.-]+)(?::(\d+))?\/(.+)/;

function Xt(e) {
  return (e && e.message || "No error message").split("\n").filter(function (e) {
    return !!e;
  })[0];
}

function Wt(e) {
  try {
    var t = function (e) {
      if (!e.stack) return null;

      for (var t, n, r = [], i = e.stack.split("\n"), o = 0; o < i.length; ++o) {
        if (t = Vt.exec(i[o])) n = {
          filename: t[2] && 0 === t[2].indexOf("address at ") ? t[2].substr("address at ".length) : t[2],
          "function": t[1] || "?",
          lineno: t[3] ? +t[3] : null,
          colno: t[4] ? +t[4] : null
        };else if (t = qt.exec(i[o])) n = {
          filename: t[2],
          "function": t[1] || "?",
          lineno: +t[3],
          colno: t[4] ? +t[4] : null
        };else {
          if (!(t = Ut.exec(i[o]))) continue;
          0 !== o || t[5] || void 0 === e.columnNumber || (r[0].column = e.columnNumber + 1), n = {
            filename: t[3],
            "function": t[1] || "?",
            lineno: t[4] ? +t[4] : null,
            colno: t[5] ? +t[5] : null
          };
        }
        !n["function"] && n.lineno && (n["function"] = "?"), r.push(n);
      }

      return r.length ? {
        value: Xt(e),
        type: e.name,
        stacktrace: {
          frames: r.reverse()
        }
      } : null;
    }(e);

    if (t) return t;
  } catch (e) {}

  return {
    value: Xt(e),
    type: e && e.name,
    stacktrace: {
      frames: []
    }
  };
}

var Gt = Object.assign || function (e) {
  for (var t = arguments.length, n = 1; n < t; n++) {
    var r = arguments[n];

    for (var i in r) {
      Object.prototype.hasOwnProperty.call(r, i) && (e[i] = r[i]);
    }
  }

  return e;
},
    Zt = function () {
  function e(t) {
    if (Tt(this, e), t.dsn) {
      var n = zt.exec(t.dsn),
          r = n ? n.slice(1) : [],
          i = r[5].split("/"),
          o = i.slice(0, -1).join("/");
      this.apiUrl = r[0] + "://" + r[3] + (r[4] ? ":" + r[4] : "") + (o ? "/" + o : "") + "/api/" + i.pop() + "/store/", this.authHeader = "Sentry sentry_version=7,sentry_key=" + r[1] + (r[2] ? ",sentry_secret=" + r[2] : "");
    }

    this.environment = t.environment;
  }

  return Ft(e, [{
    key: "prepare",
    value: function value(e) {
      return Gt(this.getRequestBlank(), {
        exception: {
          values: [Wt(e)]
        }
      });
    }
  }, {
    key: "report",
    value: function value(e) {
      this.send(this.prepare(e));
    }
  }, {
    key: "send",
    value: function value(e) {
      if (this.apiUrl) {
        var t = new XMLHttpRequest();
        t.open("POST", this.apiUrl, !0), t.setRequestHeader("Content-type", "application/json"), t.setRequestHeader("X-Sentry-Auth", this.authHeader || ""), t.send(JSON.stringify(e));
      }
    }
  }, {
    key: "getRequestBlank",
    value: function value() {
      return {
        platform: "javascript",
        sdk: {
          name: "micro-sentry.javascript.browser",
          version: "0.0.0"
        },
        timestamp: Date.now() / 1e3,
        request: {
          url: window.location.toString(),
          headers: {
            "User-Agent": window.navigator.userAgent
          }
        },
        environment: this.environment
      };
    }
  }]), e;
}();

function Jt(e, t) {
  return "[object RegExp]" === Object.prototype.toString.call(t) ? t.test(e) : "string" == typeof t && -1 !== e.indexOf(t);
}

var Qt = function (e) {
  !function (e, t) {
    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        writable: !0,
        configurable: !0
      }
    }), t && Mt(e, t);
  }(n, Zt);

  var t = function (e) {
    var t = function () {
      if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
      if (Reflect.construct.sham) return !1;
      if ("function" == typeof Proxy) return !0;

      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
      } catch (e) {
        return !1;
      }
    }();

    return function () {
      var n,
          r = Bt(e);

      if (t) {
        var i = Bt(this).constructor;
        n = Reflect.construct(r, arguments, i);
      } else n = r.apply(this, arguments);

      return Ht(this, n);
    };
  }(n);

  function n(e) {
    var r;
    Tt(this, n), (r = t.call(this, e)).options = e, r.destroyed = !1, r._state = {};
    var i = r.options || {},
        o = i.plugins,
        a = void 0 === o ? [] : o,
        s = i.beforeSend,
        c = void 0 === s ? function (e) {
      return e;
    } : s,
        u = i.beforeBreadcrumb,
        l = void 0 === u ? function (e) {
      return e;
    } : u,
        p = i.blacklistUrls,
        d = void 0 === p ? [] : p,
        h = i.ignoreErrors,
        f = void 0 === h ? [] : h,
        v = i.release,
        y = void 0 === v ? void 0 : v;
    return r.plugins = a.map(function (e) {
      return new e(Nt(r));
    }), r.beforeSend = c, r.beforeBreadcrumb = l, r.blacklistUrls = d, r.ignoreErrors = f, r.release = y, r;
  }

  return Ft(n, [{
    key: "state",
    get: function get() {
      return this._state;
    }
  }, {
    key: "clearState",
    value: function value() {
      this._state = {};
    }
  }, {
    key: "setTags",
    value: function value(e) {
      return this.setKeyState("tags", Object.assign({}, e)), this;
    }
  }, {
    key: "setTag",
    value: function value(e, t) {
      return this.extendState({
        tags: jt({}, e, t)
      }), this;
    }
  }, {
    key: "setExtra",
    value: function value(e, t) {
      return this.extendState({
        extra: jt({}, e, t)
      }), this;
    }
  }, {
    key: "setExtras",
    value: function value(e) {
      return this.setKeyState("extra", Object.assign({}, e)), this;
    }
  }, {
    key: "setUser",
    value: function value(e) {
      return this.setKeyState("user", Object.assign({}, e)), this;
    }
  }, {
    key: "clone",
    value: function value() {
      var e = new n(Object.assign(Object.assign({}, this.options), {
        plugins: []
      }));
      return e.extendState(this.state), e;
    }
  }, {
    key: "withScope",
    value: function value(e) {
      var t = this.clone();
      e(t), t.destroy(), this.setBreadcrumbs(void 0);
    }
  }, {
    key: "addBreadcrumb",
    value: function value(e) {
      this.extendState({
        breadcrumbs: [Object.assign({
          timestamp: Date.now() / 1e3
        }, this.beforeBreadcrumb(e))]
      });
    }
  }, {
    key: "setBreadcrumbs",
    value: function value(e) {
      this.setKeyState("breadcrumbs", e);
    }
  }, {
    key: "captureMessage",
    value: function value(e, t) {
      this.send(Object.assign(Object.assign({}, this.getRequestBlank()), {
        message: e,
        level: t
      }));
    }
  }, {
    key: "destroy",
    value: function value() {
      this.destroyed = !0, this.plugins.forEach(function (e) {
        e.destroy && e.destroy();
      });
    }
  }, {
    key: "isIgnoredError",
    value: function value(e) {
      var t = this;
      return !!this.ignoreErrors.length && this.getPossibleEventMessages(e).some(function (e) {
        return t.ignoreErrors.some(function (t) {
          return Jt(e, t);
        });
      });
    }
  }, {
    key: "getRequestBlank",
    value: function value() {
      return Object.assign(Object.assign({}, Lt(Bt(n.prototype), "getRequestBlank", this).call(this)), this.state);
    }
  }, {
    key: "send",
    value: function value(e) {
      this.destroyed || this.isDeniedUrl(e) || this.isIgnoredError(e) || (Lt(Bt(n.prototype), "send", this).call(this, this.beforeSend(Object.assign({
        release: this.release
      }, e))), this.setBreadcrumbs(void 0));
    }
  }, {
    key: "getPossibleEventMessages",
    value: function value(e) {
      if (e.message) return [e.message];
      if (e.exception) try {
        var t = e.exception.values && e.exception.values[0] || {},
            n = t.type,
            r = void 0 === n ? "" : n,
            i = t.value,
            o = void 0 === i ? "" : i;
        return ["".concat(o), "".concat(r, ": ").concat(o)];
      } catch (e) {
        return [];
      }
      return [];
    }
  }, {
    key: "isDeniedUrl",
    value: function value(e) {
      if (!this.blacklistUrls.length) return !1;
      var t = this.getEventFilterUrl(e);
      return !!t && this.blacklistUrls.some(function (e) {
        return Jt(t, e);
      });
    }
  }, {
    key: "getEventFilterUrl",
    value: function value(e) {
      try {
        if (e.exception) {
          var t = e.exception.values && e.exception.values[0].stacktrace && e.exception.values[0].stacktrace.frames;
          return t && t[t.length - 1].filename || null;
        }

        return null;
      } catch (e) {
        return null;
      }
    }
  }, {
    key: "extendState",
    value: function value(e) {
      var t = this;
      this._state = Object.keys(e).reduce(function (n, r) {
        var i = t.state[r],
            o = Array.isArray(i) ? i : null,
            a = e[r],
            s = Array.isArray(a) ? a : null;
        return Object.assign(Object.assign({}, n), jt({}, r, o || s ? [].concat(Pt(o || []), Pt(s || [])) : Object.assign(Object.assign({}, "string" != typeof i ? i : {}), "string" != typeof a ? a : {})));
      }, {});
    }
  }, {
    key: "setKeyState",
    value: function value(e, t) {
      this._state[e] = t;
    }
  }]), n;
}();

function Yt(e, t, n) {
  var r = e[t],
      i = n(r);
  if ("function" == typeof i) try {
    i.prototype = i.prototype || {}, Object.defineProperties(i, {
      __original__: {
        enumerable: !1,
        value: r
      }
    });
  } catch (e) {}
  e[t] = i;
}

function $t(e) {
  if (!e) return {};
  var t = e.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
  if (!t) return {};
  var n = t[6] || "",
      r = t[8] || "";
  return {
    host: t[4],
    path: t[5],
    protocol: t[2],
    relative: t[5] + n + r
  };
}

function Kt() {
  var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [];
  return "Request" in window && e[0] instanceof Request && e[0].method ? String(e[0].method).toUpperCase() : e[1] && e[1].method ? String(e[1].method).toUpperCase() : "GET";
}

function en() {
  var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [];
  return "string" == typeof e[0] ? e[0] : "Request" in window && e[0] instanceof Request ? e[0].url : String(e[0]);
}

function tn(e) {
  return e && /^function fetch\(\)\s+\{\s+\[native code\]\s+\}$/.test(e.toString());
}

function nn(e) {
  var t = e,
      n = [];
  if (!t || !t.tagName) return "";
  n.push(t.tagName.toLowerCase()), t.id && n.push("#".concat(t.id));
  var r = t.className;

  if (r && "string" == typeof r) {
    var i = r.split(/\s+/);
    n.concat(i.map(function (e) {
      return ".".concat(e);
    }));
  }

  return ["type", "name", "title", "alt", "automation-id"].forEach(function (e) {
    var r = t.getAttribute(e);
    r && n.push("[".concat(e, '="').concat(r, '"]'));
  }), n.join("");
}

function rn(e) {
  try {
    for (var t, n = e, r = [], i = 0, o = 0, a = " > ".length; n && i++ < 5 && !("html" === (t = nn(n)) || i > 1 && o + r.length * a + t.length >= 80);) {
      r.push(t), o += t.length, n = n.parentNode;
    }

    return r.reverse().join(" > ");
  } catch (e) {
    return "<unknown>";
  }
}

function on(e) {
  var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : " ";
  return Array.isArray(e) ? e.map(function (e) {
    try {
      return String(e);
    } catch (e) {
      return "";
    }
  }).filter(function (e) {
    return "" !== e;
  }).join(t) : "";
}

function an(e, t) {
  var n = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), n.push.apply(n, r);
  }

  return n;
}

function sn(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = null != arguments[t] ? arguments[t] : {};
    t % 2 ? an(Object(n), !0).forEach(function (t) {
      st(e, t, n[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : an(Object(n)).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
    });
  }

  return e;
}

Ft(function e(t) {
  Tt(this, e), this.client = t, this.subscriptions = [], this.initDOM(), this.initConsole(), this.initFetch(), this.initHistory(), this.initXHR();
}, [{
  key: "initXHR",
  value: function value() {
    if ("XMLHttpRequest" in window) {
      var e = this,
          t = XMLHttpRequest.prototype;
      Yt(t, "open", function (t) {
        return function () {
          for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++) {
            r[i] = arguments[i];
          }

          var o = this,
              a = r[1];
          o.__sentry_xhr__ = {
            method: "string" == typeof r[0] ? r[0].toUpperCase() : r[0],
            url: r[1]
          }, "string" == typeof a && "POST" === o.__sentry_xhr__.method && a.match(/sentry_key/) && (o.__sentry_own_request__ = !0);

          var s = function s() {
            if (4 === o.readyState) {
              try {
                o.__sentry_xhr__ && (o.__sentry_xhr__.status_code = o.status);
              } catch (e) {}

              e.xhrBreadcrumb({
                args: r,
                endTimestamp: Date.now(),
                startTimestamp: Date.now(),
                xhr: o
              });
            }
          };

          return "onreadystatechange" in o && "function" == typeof o.onreadystatechange ? Yt(o, "onreadystatechange", function (e) {
            return function () {
              s();

              for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) {
                n[r] = arguments[r];
              }

              e.apply(o, n);
            };
          }) : o.addEventListener("readystatechange", s), t.apply(o, r);
        };
      }), Yt(t, "send", function (t) {
        return function () {
          for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++) {
            r[i] = arguments[i];
          }

          return e.xhrBreadcrumb({
            args: r,
            startTimestamp: Date.now(),
            xhr: this
          }), t.apply(this, r);
        };
      });
    }
  }
}, {
  key: "initHistory",
  value: function value() {
    var e = this,
        t = window.onpopstate;

    function n(t) {
      return function () {
        for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++) {
          r[i] = arguments[i];
        }

        var o = r.length > 2 ? r[2] : void 0;

        if (o) {
          var a = e.lastHref,
              s = String(o);
          e.lastHref = s, e.historyBreadcrumb({
            from: a,
            to: s
          });
        }

        return t.apply(this, r);
      };
    }

    window.onpopstate = function () {
      var n = window.location.href,
          r = e.lastHref;

      if (e.lastHref = n, e.historyBreadcrumb({
        from: r,
        to: n
      }), t) {
        for (var i = arguments.length, o = new Array(i), a = 0; a < i; a++) {
          o[a] = arguments[a];
        }

        return t.apply(this, o);
      }
    }, Yt(window.history, "pushState", n), Yt(window.history, "replaceState", n);
  }
}, {
  key: "destroy",
  value: function value() {
    this.subscriptions.forEach(function (e) {
      return e();
    });
  }
}, {
  key: "initDOM",
  value: function value() {
    var e = this,
        t = function t(_t3) {
      return e.prepareDomEvent("click", _t3);
    },
        n = function n(t) {
      return e.prepareDomEvent("keypress", t);
    };

    window.document.addEventListener("click", t, !1), window.document.addEventListener("keypress", n, !1), this.subscriptions.push(function () {
      window.document.removeEventListener("click", t, !1), window.document.removeEventListener("keypress", n, !1);
    });
  }
}, {
  key: "prepareDomEvent",
  value: function value(e, t) {
    var n;

    try {
      n = t.target ? rn(t.target) : rn(t);
    } catch (e) {
      n = "<unknown>";
    }

    0 !== n.length && this.client.addBreadcrumb({
      category: "ui.".concat(e),
      message: n
    });
  }
}, {
  key: "initFetch",
  value: function value() {
    var e = this;
    (function () {
      if (!function () {
        if (!("fetch" in window)) return !1;

        try {
          return new Headers(), new Request(""), new Response(), !0;
        } catch (e) {
          return !1;
        }
      }()) return !1;
      if (tn(window.fetch)) return !0;
      var e = !1,
          t = window.document;
      if (t && "function" == typeof t.createElement) try {
        var n = t.createElement("iframe");
        n.sandbox.add("allow-scripts"), n.sandbox.add("allow-same-origin"), n.hidden = !0, t.head.appendChild(n), n.contentWindow && n.contentWindow.fetch && (e = tn(n.contentWindow.fetch)), t.head.removeChild(n);
      } catch (e) {}
      return e;
    })() && Yt(window, "fetch", function (t) {
      return function () {
        for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++) {
          r[i] = arguments[i];
        }

        var o = {
          args: r,
          fetchData: {
            method: Kt(r),
            url: en(r)
          },
          startTimestamp: Date.now()
        };
        return e.fetchBreadcrumb(Object.assign({}, o)), t.apply(window, r).then(function (t) {
          return e.fetchBreadcrumb(Object.assign(Object.assign({}, o), {
            endTimestamp: Date.now(),
            response: t
          })), t;
        }, function (t) {
          throw e.fetchBreadcrumb(Object.assign(Object.assign({}, o), {
            endTimestamp: Date.now(),
            error: t
          })), t;
        });
      };
    });
  }
}, {
  key: "fetchBreadcrumb",
  value: function value(e) {
    e.endTimestamp && (e.fetchData.url.match(/sentry_key/) && "POST" === e.fetchData.method || (e.error ? this.client.addBreadcrumb({
      category: "fetch",
      data: e.fetchData,
      level: "error",
      type: "http"
    }) : this.client.addBreadcrumb({
      category: "fetch",
      data: Object.assign(Object.assign({}, e.fetchData), {
        status_code: e.response.status
      }),
      type: "http"
    })));
  }
}, {
  key: "xhrBreadcrumb",
  value: function value(e) {
    if (e.endTimestamp) {
      if (e.xhr.__sentry_own_request__) return;
      this.client.addBreadcrumb({
        category: "xhr",
        data: e.xhr.__sentry_xhr__,
        type: "http"
      });
    }
  }
}, {
  key: "initConsole",
  value: function value() {
    var e = this;
    ["debug", "info", "warn", "error", "log", "assert"].forEach(function (t) {
      t in window.console && Yt(window.console, t, function (n) {
        return function () {
          for (var r = arguments.length, i = new Array(r), o = 0; o < r; o++) {
            i[o] = arguments[o];
          }

          var a = {
            category: "console",
            data: {
              arguments: i.map(function (e) {
                try {
                  return JSON.stringify(e), e;
                } catch (t) {
                  return Object.prototype.toString.call(e);
                }
              }),
              logger: "console"
            },
            level: t,
            message: on(i, " ")
          };

          if ("assert" === t) {
            if (!1 !== i[0]) return;
            a.message = "Assertion failed: ".concat(on(i.slice(1), " ") || "console.assert"), a.data.arguments = i.slice(1);
          }

          e.client.addBreadcrumb(a), n && Function.prototype.apply.call(n, window.console, i);
        };
      });
    });
  }
}, {
  key: "historyBreadcrumb",
  value: function value(e) {
    var t = e.from,
        n = e.to,
        r = $t(window.location.href),
        i = $t(t),
        o = $t(n);
    i.path || (i = r), r.protocol === o.protocol && r.host === o.host && (n = o.relative), r.protocol === i.protocol && r.host === i.host && (t = i.relative), this.client.addBreadcrumb({
      category: "navigation",
      data: {
        from: t,
        to: n
      }
    });
  }
}]);
var cn = new Qt({
  dsn: "https://820fe9124d6a4b4d8ef0ee1e44a29c4b@sentry-new.myshopline.com/305",
  release: "1.9.0",
  environment: "production",
  beforeSend: function beforeSend(e) {
    return e;
  }
});

function un(e, t) {
  if (t) {
    var n = t.message,
        r = t.stack;
    return t.message = JSON.stringify(sn(sn({}, e || {}), {}, {
      originErrorMessage: n,
      originErrorData: JSON.stringify(t),
      errorLevel: t.errorLevel || lt.Error
    })), cn.report(t), t.message = n, void (t.stack = r);
  }

  cn.report(new Error(JSON.stringify(sn(sn({}, e), {}, {
    errorLevel: e.errorLevel || lt.Error
  }))));
}

function ln(e, t) {
  var n = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), n.push.apply(n, r);
  }

  return n;
}

function pn(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = null != arguments[t] ? arguments[t] : {};
    t % 2 ? ln(Object(n), !0).forEach(function (t) {
      st(e, t, n[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : ln(Object(n)).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
    });
  }

  return e;
}

cn.setTag("host", window.location.origin);

var dn = new t("webpaymentsdk", {
  performance: !1
}),
    hn = function () {
  function t() {
    it(this, t);
  }

  return at(t, null, [{
    key: "init",
    value: function value() {
      dn.init({
        projectName: "webpaymentsdk",
        environment: "production"
      }), cn.setTag("pvId", e);
    }
  }, {
    key: "reportError",
    value: function value(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "report_error",
          n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
      e instanceof St || e.name === pt.IframeError || (e instanceof Ot ? e.isReported || (un(pn({
        eventName: t
      }, n), e), e.setIsReported()) : un(pn({
        eventName: t
      }, n), e));
    }
  }, {
    key: "handleError",
    value: function value(e) {
      var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "default_error",
          r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
      if (t.reportData(n, r), t.reportError(e, n, r), e instanceof St || e instanceof Ot) throw e;
      var i = "".concat(n, " ").concat(e.message || "pci sdk inner error"),
          o = new St(i);
      throw Object.assign(o, e), o.name = e.name || "Error", o.code = e.code || o.code, o.errorLevel = e.errorLevel || lt.Error, o.data = pn({
        code: ut.InnerSDKError,
        msg: i
      }, e.data || {}), o;
    }
  }, {
    key: "reportData",
    value: function value(e, n) {
      try {
        dn.report(e, n ? {
          extraData: JSON.stringify(n)
        } : {});
      } catch (r) {
        t.reportError(r, "".concat(e, "_report_data_error"), {
          data: n
        });
      }
    }
  }, {
    key: "reportErrorData",
    value: function value(e, n) {
      var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : lt.Error;
      t.reportData(e, n), un(pn({
        eventName: e,
        errorLevel: r
      }, n));
    }
  }]), t;
}(),
    fn = function e(t) {
  var n = this;
  it(this, e), st(this, "originData", void 0), st(this, "addReportData", function (e) {
    dn.init(e), Object.assign(n.originData, e || {});
  }), st(this, "reportData", function (e, t) {
    return hn.reportData(e, t);
  }), st(this, "reportErrorData", function (e) {
    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
        r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : lt.Error;
    return hn.reportErrorData(e, Object.assign({
      originData: n.originData
    }, t), r);
  }), st(this, "reportError", function (e, t, r) {
    return hn.reportError(e, t, pn({
      eventName: t,
      originData: n.originData
    }, r || {}));
  }), st(this, "handleError", function (e, t, r) {
    return hn.handleError(e, t, pn({
      originData: n.originData
    }, r));
  }), this.originData = pn({}, t);
};

st(fn, "init", void 0);

var vn = function () {
  function e(t) {
    it(this, e), st(this, "config", {}), st(this, "validateResolve", void 0), st(this, "payResolve", void 0), st(this, "payReject", void 0), st(this, "cardBrandResolve", void 0), st(this, "beforePayResolve", void 0), st(this, "cardBinVerifyResolve", void 0), st(this, "cardBinVerifyReject", void 0), st(this, "cardBinOptionsResolve", void 0), st(this, "cardTokenResolve", void 0), st(this, "cardTokenReject", void 0), st(this, "iframeLoaded", {}), this.config = t;
  }

  return at(e, [{
    key: "setValidateResolve",
    value: function value(e) {
      this.validateResolve = e;
    }
  }, {
    key: "setPayResolve",
    value: function value(e) {
      this.payResolve = e;
    }
  }, {
    key: "setPayReject",
    value: function value(e) {
      this.payReject = e;
    }
  }, {
    key: "setCardBrandResolve",
    value: function value(e) {
      this.cardBrandResolve = e;
    }
  }, {
    key: "setBeforePayResolve",
    value: function value(e) {
      this.beforePayResolve = e;
    }
  }, {
    key: "setCardBinVerifyResolve",
    value: function value(e) {
      this.cardBinVerifyResolve = e;
    }
  }, {
    key: "setCardBinVerifyReject",
    value: function value(e) {
      this.cardBinVerifyReject = e;
    }
  }, {
    key: "setCardBinOptionsResolve",
    value: function value(e) {
      this.cardBinOptionsResolve = e;
    }
  }, {
    key: "setCardTokenResolve",
    value: function value(e) {
      this.cardTokenResolve = e;
    }
  }, {
    key: "setCardTokenReject",
    value: function value(e) {
      this.cardTokenReject = e;
    }
  }, {
    key: "setIframeLoaded",
    value: function value(e) {
      var t = this;
      e.forEach(function (e) {
        return t.iframeLoaded[e] = !1;
      });
    }
  }, {
    key: "handleEvent",
    value: function value(e) {
      var t = this,
          n = e.eventType,
          r = e.name,
          i = e.isEmpty,
          o = e.isValid,
          a = e.brand,
          s = e.isFocus,
          c = e.status,
          u = e.value;
      "focus" === n ? this.triggerEvent("onFocus", {
        fieldName: r,
        isEmpty: i,
        isFocus: s,
        isValid: o
      }) : "input" === n ? this.triggerEvent("onFieldValidChange", {
        fieldName: r,
        isValid: o,
        isEmpty: i
      }) : "brandChange" === n ? this.triggerEvent("onBrandChange", {
        brand: a
      }) : "validate" === n ? this.validateResolve(o) : "payResult" === n ? c === It.Success ? this.payResolve(u) : this.payReject(u) : "getCardBrand" === n ? this.cardBrandResolve(a) : "loadFinished" === n ? (this.iframeLoaded[r] = !0, Object.keys(this.iframeLoaded).every(function (e) {
        return t.iframeLoaded[e];
      }) && (hn.reportData("pci_sdk_onInit"), this.triggerEvent("onInit", {}))) : "getBeforePayData" === n ? this.beforePayResolve(u) : "cardBinVerifyChange" === n ? this.triggerEvent("onCardBinChange", u) : "setCardBinOptions" === n ? this.cardBinOptionsResolve() : "cardBinVerifyResult" === n ? c === It.Success ? this.cardBinVerifyResolve(u) : this.cardBinVerifyReject(u) : "cardTokenResult" === n && (c === It.Success ? this.cardTokenResolve(u) : this.cardTokenReject(u));
    }
  }, {
    key: "triggerEvent",
    value: function value(e, t) {
      try {
        this.config[e] && this.config[e](t);
      } catch (n) {
        hn.handleError(n, "pci_sdk_triggerEvent_".concat(e), t);
      }
    }
  }]), e;
}(),
    yn = ["number", "expDate", "cvc", "firstName"],
    mn = function () {
  function e(t) {
    it(this, e), st(this, "config", {}), st(this, "uuid", void 0), st(this, "host", void 0), st(this, "mountDom", void 0), st(this, "postMessageInstance", new ht()), st(this, "cardIframeInstance", void 0), st(this, "cardEventInstance", void 0), st(this, "hasCardName", !0), st(this, "reporter", void 0), this.initReporter(t);

    try {
      this.reporter.reportData("pci_sdk_constructor_start"), this.host = (null == t ? void 0 : t.host) || "", this.uuid = function () {
        var e = new Date().getTime();
        return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (t) {
          var n = (e + 16 * Math.random()) % 16 | 0;
          return e = Math.floor(e / 16), ("x" == t ? n : 3 & n | 8).toString(16);
        });
      }(), this.postMessageInstance.setUuid(this.uuid), this.postMessageInstance.setIframeHost(this.host), this.cardIframeInstance = new _t(this.uuid), this.reporter.reportData("pci_sdk_constructor_end");
    } catch (e) {
      this.reporter.handleError(e, "pci_sdk_constructor_error");
    }
  }

  var t, n;
  return at(e, [{
    key: "initReporter",
    value: function value(e) {
      try {
        hn.init(), this.reporter = new fn(e);
      } catch (e) {
        hn.handleError(e, "pci_sdk_init_reporter_error");
      }
    }
  }, {
    key: "create",
    value: function value(e) {
      try {
        this.reporter.reportData("pci_sdk_create_start", {
          config: e
        }), this.config = e, this.cardEventInstance = new vn(e), this.reporter.reportData("pci_sdk_create_end");
      } catch (e) {
        this.reporter.handleError(e, "pci_sdk_create_error");
      }
    }
  }, {
    key: "mount",
    value: function value(e) {
      var t = this;

      try {
        this.reporter.reportData("pci_sdk_mount_start");
        var n = "string" == typeof e ? document.querySelector(e) : e;
        if (this.mountDom = n, this.cardIframeInstance.setParentDom(n), !n) throw new Ot("Can't find the mount dom", pt.NoDom);
        this.hasCardName = !!n.querySelector('[data-pci="firstName"]');
        var r = this.hasCardName ? yn : yn.slice(0, 3);
        this.cardIframeInstance.renderIframe(this.host, r, this.config, this.postMessageInstance), this.cardEventInstance.setIframeLoaded(r), window.addEventListener("message", function (e) {
          e.data.uuid === t.uuid && t.cardEventInstance.handleEvent(e.data);
        }), this.reporter.reportData("pci_sdk_mount_end", {
          hasCardName: this.hasCardName
        });
      } catch (e) {
        this.reporter.handleError(e, "pci_sdk_mount_error");
      }
    }
  }, {
    key: "setStyle",
    value: function value(e) {
      try {
        this.reporter.reportData("pci_sdk_setStyle_start", {
          params: e
        });
        var t = e.type,
            n = e.fieldName,
            r = e.style;
        this.postMessageInstance.setStyle(r, t, n), this.reporter.reportData("pci_sdk_setStyle_end");
      } catch (e) {
        this.reporter.handleError(e, "pci_sdk_setStyle_error");
      }
    }
  }, {
    key: "destroy",
    value: function value() {
      var e = this;

      try {
        if (this.reporter.reportData("pci_sdk_destroy_start"), !this.mountDom) return void this.reporter.reportData("pci_sdk_destroy_no_dom");
        yn.forEach(function (t) {
          return e.cardIframeInstance.unmountDom('[data-pci="'.concat(t, '"]'));
        }), this.reporter.reportData("pci_sdk_destroy_end");
      } catch (e) {
        this.reporter.handleError(e, "pci_sdk_destroy_error");
      }
    }
  }, {
    key: "validate",
    value: (t = dt.mark(function e() {
      var t = this;
      return dt.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return this.reporter.reportData("pci_sdk_validate_start"), e.abrupt("return", new Promise(function (e) {
                t.cardEventInstance.setValidateResolve(e), t.postMessageInstance.getValidate(t.hasCardName, "number");
              }).then(function (e) {
                return t.reporter.reportData("pci_sdk_validate_end", {
                  validateResult: e
                }), e;
              })["catch"](function (e) {
                return t.reporter.handleError(e, "pci_sdk_validate_error");
              }));

            case 2:
            case "end":
              return e.stop();
          }
        }
      }, e, this);
    }), n = function n() {
      var e = this,
          n = arguments;
      return new Promise(function (r, i) {
        var o = t.apply(e, n);

        function a(e) {
          rt(o, r, i, a, s, "next", e);
        }

        function s(e) {
          rt(o, r, i, a, s, "throw", e);
        }

        a(void 0);
      });
    }, function () {
      return n.apply(this, arguments);
    })
  }, {
    key: "pay",
    value: function value(e) {
      var t = this,
          n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
      return this.reporter.reportData("pci_sdk_pay_start", {
        nextAction: e
      }), new Promise(function (r, i) {
        t.cardEventInstance.setPayResolve(r), t.cardEventInstance.setPayReject(i), t.postMessageInstance.pay(e, t.hasCardName, n, "number");
      }).then(function (e) {
        return t.reporter.reportData("pci_sdk_pay_end", {
          payResult: e
        }), e;
      })["catch"](function (e) {
        return t.reporter.handleError(e, "pci_sdk_pay_error");
      });
    }
  }, {
    key: "getCardBrand",
    value: function value() {
      var e = this;
      return this.reporter.reportData("pci_sdk_getCardBrand_start"), new Promise(function (t) {
        e.cardEventInstance.setCardBrandResolve(t), e.postMessageInstance.getCardBrand("number");
      }).then(function (t) {
        return e.reporter.reportData("pci_sdk_getCardBrand_end", {
          cardBrand: t
        }), t;
      })["catch"](function (t) {
        return e.reporter.handleError(t, "pci_sdk_getCardBrand_error");
      });
    }
  }, {
    key: "getBeforePayData",
    value: function value(e) {
      var t = this;
      return this.reporter.reportData("pci_sdk_getBeforePayData_start", {
        nextAction: e
      }), new Promise(function (n) {
        t.cardEventInstance.setBeforePayResolve(n), t.postMessageInstance.getBeforePayData(e, "number");
      }).then(function (e) {
        return t.reporter.reportData("pci_sdk_getBeforePayData_end", {
          beforePayData: e
        }), e;
      })["catch"](function (e) {
        return t.reporter.handleError(e, "pci_sdk_getBeforePayData_error");
      });
    }
  }, {
    key: "setCardBinOptions",
    value: function value(e) {
      var t = this;
      return this.reporter.reportData("pci_sdk_setCardBinOptions_start", e), new Promise(function (n) {
        t.cardEventInstance.setCardBinOptionsResolve(n), t.postMessageInstance.setCardBinOptions(e, "number");
      }).then(function (e) {
        return t.reporter.reportData("pci_sdk_setCardBinOptions_end", {
          result: e
        }), e;
      })["catch"](function (e) {
        return t.reporter.handleError(e, "pci_sdk_setCardBinOptions_error");
      });
    }
  }, {
    key: "getCardBinVerifyResult",
    value: function value() {
      var e = this,
          t = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0];
      return this.reporter.reportData("pci_sdk_getCardBinVerifyResult_start", {
        readCache: t
      }), new Promise(function (n, r) {
        e.cardEventInstance.setCardBinVerifyResolve(n), e.cardEventInstance.setCardBinVerifyReject(r), e.postMessageInstance.getCardBinVerifyResult(t, "number");
      }).then(function (t) {
        return e.reporter.reportData("pci_sdk_getCardBinVerifyResult_end", {
          cardBinVerifyResult: t
        }), t;
      })["catch"](function (t) {
        return e.reporter.handleError(t, "pci_sdk_getCardBinVerifyResult_error");
      });
    }
  }, {
    key: "getCardToken",
    value: function value(e) {
      var t = this;
      return this.reporter.reportData("pci_sdk_getCardToken_start", e), new Promise(function (n, r) {
        t.cardEventInstance.setCardTokenResolve(n), t.cardEventInstance.setCardTokenReject(r), t.postMessageInstance.getCardToken(e, t.hasCardName, "number");
      }).then(function (e) {
        return t.reporter.reportData("pci_sdk_getCardToken_end"), e;
      })["catch"](function (e) {
        return t.reporter.handleError(e, "pci_sdk_getCardToken_error");
      });
    }
  }]), e;
}();

function gn(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}

var bn,
    kn,
    xn = {
  splitReg: "!\\[[^\\]]+\\][\\\\]*\\([^)]+\\)",
  matchReg: /!\[([^\]]+)\]\(([^)]+)\)/,
  replaceReg: "(!\\[[^\\]]+\\])(\\\\+)(\\([^)]+\\))"
},
    wn = {
  splitReg: "\\[[^\\]]+\\][\\\\]*\\([^)]+\\)",
  matchReg: /\[([^\]]+)\]\(([^)]+)\)/,
  replaceReg: "(\\[[^\\]]+\\])(\\\\+)(\\([^)]+\\))"
},
    Cn = {
  splitReg: "\\\\?\\*\\\\?\\*[^\\s]+\\\\?\\*\\\\?\\*",
  matchReg: /\*\*([^\s]+)\*\*/,
  replaceReg: "\\\\\\*\\\\\\*([^\\s]+)\\\\\\*\\\\\\*"
},
    En = function En(e) {
  var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "",
      n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
  return {
    tagName: e,
    content: t,
    property: n
  };
},
    In = function In(e, t, n, r) {
  return t + (n ? n.slice(1) : "") + r;
},
    Sn = function () {
  function e() {
    !function (e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }(this, e), gn(this, "handleStrong", function (e, t) {
      var n = t.match(e);
      return En("strong", n[1]);
    }), gn(this, "handleStrongReplace", function (e, t) {
      var n = t.replace(new RegExp(e, "g"), "**$1**");
      return En("text", n);
    });
  }

  var t;
  return (t = [{
    key: "parseToTagConfig",
    value: function value(e) {
      var t = this,
          n = [],
          r = wn,
          i = xn,
          o = Cn;
      if (!e || 0 !== e.indexOf("$RT$")) return [En("text", e)];
      e = e.slice("$RT$".length);
      var a = "(".concat(i.splitReg, ")|(").concat(r.splitReg, ")|(").concat(o.splitReg, ")");
      return e.split(new RegExp(a)).filter(function (e) {
        return !!e;
      }).forEach(function (e) {
        var a;

        if (new RegExp(i.matchReg).test(e)) {
          var s = e.match(i.matchReg);
          a = En("img", "", {
            alt: s[1],
            src: s[2]
          });
        } else if (new RegExp(r.matchReg).test(e)) {
          var c = e.match(r.matchReg);
          a = En("a", c[1], {
            href: c[2],
            target: "_blank"
          });
        } else if (o.matchReg.test(e)) a = t.handleStrong(o.matchReg, e);else if (new RegExp(i.replaceReg).test(e)) {
          var u = e.replace(new RegExp(i.replaceReg, "g"), In);
          a = En("text", u);
        } else if (new RegExp(r.replaceReg).test(e)) {
          var l = e.replace(new RegExp(r.replaceReg, "g"), In);
          a = En("text", l);
        } else a = new RegExp(o.replaceReg).test(e) ? t.handleStrongReplace(o.replaceReg, e) : En("text", e);

        n.push(a);
      }), n;
    }
  }, {
    key: "parseToDom",
    value: function value(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "div",
          n = document.createElement(t);
      return e.forEach(function (e) {
        var t = document.createElement("text" === e.tagName ? "span" : e.tagName);
        t.textContent = e.content, e.property && Object.keys(e.property).forEach(function (n) {
          return t.setAttribute(n, e.property[n]);
        }), n.appendChild(t);
      }), n;
    }
  }, {
    key: "autoParseToDom",
    value: function value(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "div",
          n = this.parseToTagConfig(e);
      return this.parseToDom(n, t);
    }
  }]) && function (e, t) {
    for (var n = 0; n < t.length; n++) {
      var r = t[n];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
    }
  }(e.prototype, t), e;
}(),
    On = '<svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M13.6 8C13.6 11.0928 11.0928 13.6 8 13.6C4.90721 13.6 2.4 11.0928 2.4 8C2.4 4.90721 4.90721 2.4 8 2.4C11.0928 2.4 13.6 4.90721 13.6 8ZM15 8C15 11.866 11.866 15 8 15C4.13401 15 1 11.866 1 8C1 4.13401 4.13401 1 8 1C11.866 1 15 4.13401 15 8ZM9.45298 7.94043C8.86649 8.2889 8.60666 8.62269 8.59923 9.33797C8.59563 9.68549 8.31985 9.94303 7.89582 9.94303C7.49737 9.94303 7.1924 9.68549 7.1924 9.33797C7.19612 8.05414 7.54504 7.66166 8.16865 7.27285C8.62522 6.98674 8.97785 6.66762 8.97785 6.1871C8.97785 5.67724 8.57325 5.34712 8.07214 5.34712C7.58587 5.34712 7.15624 5.63856 7.11445 6.26413C7.0902 6.62714 6.78059 6.98126 6.35721 6.98126C5.93369 6.98126 5.59998 6.61104 5.59998 6.26413C5.59998 4.80823 6.73212 4.09998 8.07956 4.09998C9.55321 4.09998 10.6 4.84826 10.6 6.13208C10.6 6.99407 10.1471 7.53328 9.45298 7.94043ZM7.92373 12.4033C8.39886 12.4033 8.81089 12.0109 8.8146 11.523C8.81089 11.0425 8.39886 10.65 7.92373 10.65C7.43375 10.65 7.02915 11.0425 7.03286 11.523C7.02915 12.0109 7.43375 12.4033 7.92373 12.4033Z" fill="currentColor"/></svg>',
    _n = '\n<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">\n<path d="M10.8773 5.33337H10.1557C9.99882 5.33337 9.84958 5.40529 9.75727 5.52856L7.33873 8.72793L6.24331 7.27795C6.151 7.15613 6.0033 7.08275 5.84484 7.08275H5.12328C5.02327 7.08275 4.96481 7.19136 5.02327 7.26914L6.94026 9.80515C6.98554 9.86545 7.04524 9.91458 7.11441 9.94847C7.18357 9.98236 7.26021 10 7.33796 10C7.41572 10 7.49235 9.98236 7.56152 9.94847C7.63068 9.91458 7.69038 9.86545 7.73567 9.80515L10.9758 5.51976C11.0358 5.44198 10.9773 5.33337 10.8773 5.33337V5.33337Z" fill="currentColor"/>\n<path d="M13.25 3.46888V9.59634C13.25 10.0143 13.0411 10.4046 12.6934 10.6364L8.13867 13.6729C8.0547 13.7289 7.9453 13.7289 7.86132 13.6729L3.30662 10.6364C2.95888 10.4046 2.75 10.0143 2.75 9.59634V3.46888C2.75 3.3517 2.83138 3.25025 2.94577 3.22483L7.94577 2.11372C7.98149 2.10578 8.01851 2.10578 8.05423 2.11372L13.0542 3.22483C13.1686 3.25025 13.25 3.3517 13.25 3.46888Z" stroke="currentColor" stroke-width="1.5"/>\n</svg>\n',
    Dn = (s(bn = {}, u.CreditCard, {
  inputBackground: "#fff",
  formItemGutter: "12px",
  inputHeight: "46px",
  cardNumberIconSvg: '<svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M7.99998 2.70002C6.70211 2.70002 5.64998 3.75216 5.64998 5.05002V5.79999H10.35V5.05002C10.35 3.75216 9.29784 2.70002 7.99998 2.70002ZM4.34998 5.05002V5.79999H4C2.89543 5.79999 2 6.69542 2 7.79999V12.8C2 13.9046 2.89543 14.8 4 14.8H12C13.1046 14.8 14 13.9046 14 12.8V7.79999C14 6.69542 13.1046 5.79999 12 5.79999H11.65V5.05002C11.65 3.03418 10.0158 1.40002 7.99998 1.40002C5.98414 1.40002 4.34998 3.03418 4.34998 5.05002ZM4 7.09999H12C12.3866 7.09999 12.7 7.41339 12.7 7.79999V12.8C12.7 13.1866 12.3866 13.5 12 13.5H4C3.6134 13.5 3.3 13.1866 3.3 12.8V7.79999C3.3 7.41339 3.6134 7.09999 4 7.09999ZM8.59998 10.5395C8.9587 10.332 9.20005 9.94419 9.20005 9.49999C9.20005 8.83725 8.66279 8.29999 8.00005 8.29999C7.33731 8.29999 6.80005 8.83725 6.80005 9.49999C6.80005 9.94413 7.04134 10.3319 7.39998 10.5394V11.9C7.39998 12.2314 7.6686 12.5 7.99998 12.5C8.33135 12.5 8.59998 12.2314 8.59998 11.9V10.5395Z" fill="currentColor"/></svg>',
  holderNameIconSvg: On,
  securityCodeIconSvg: On,
  inputBorderColor: "rgba(142, 142, 142, 0.3)",
  inputBorderRadius: "4px",
  inputFocusBorderColor: "#276EAF",
  inputErrorBorderColor: "#F04949",
  inputErrorFontColor: "#F04949",
  inputTipGutter: "6px",
  inputLabelColor: "rgba(44, 44, 44, 0.75)",
  inputFontColor: "#2C2C2C",
  inputTipColor: "rgba(44, 44, 44, 0.5)",
  inputIconColor: "rgba(44, 44, 44, 0.75)",
  footerFontColor: "rgba(44, 44, 44, 0.5)",
  footerIconColor: "#35C08E",
  footerLinkColor: "#466c63",
  footerIconSvg: _n
}), s(bn, u.FPX, {
  selectFontColor: "#363D4D",
  selectPlaceholderFontColor: "#999999",
  selectBackground: "#FFFFFF",
  selectBorderColor: "#CCCCCC",
  selectIconColor: "#1E1E1E",
  selectErrorBorderColor: "#F04949",
  selectErrorFontColor: "#F04949",
  optionsFontColor: "#363D4D",
  optionsBackground: "#FFFFFF",
  optionsDisabledBackground: "#F7F8FB",
  optionsDisabledFontColor: "#B8BECC",
  maintainTimeFontColor: "#F86140",
  nextStepTipFontColor: "rgba(44, 44, 44, 0.75)",
  footerFontColor: "rgba(30, 30, 30, 0.4)",
  footerLinkColor: "#356DFF",
  footerIconColor: "#35C08E"
}), s(bn, "installment", {
  selectIconColor: "#1E1E1E",
  optionsFontColor: "#363D4D",
  optionsBackground: "#FFFFFF"
}), s(bn, "block", {
  imgColor: "rgba(44, 44, 44, 0.5)",
  fontColor: "#1E1E1E"
}), s(bn, "simple", {
  fontColor: "rgba(44, 44, 44, 0.5)"
}), s(bn, "default", {
  fontFamily: ["Helvetica Neue", " Arial", " sans-serif"],
  fontLib: d.System
}), bn),
    Pn = (s(kn = {}, u.CreditCard, ["inputBackground", "formItemGutter", "inputHeight", "inputTipGutter", "inputLabelColor", "inputFontColor", "inputBorderColor", "inputBorderRadius", "inputIconColor", "inputFocusBorderColor", "inputErrorBorderColor", "inputErrorFontColor", "inputTipColor", "footerFontColor", "footerIconColor", "footerLinkColor"]), s(kn, u.FPX, ["selectFontColor", "selectPlaceholderFontColor", "selectBackground", "selectBorderColor", "selectIconColor", "selectErrorBorderColor", "selectErrorFontColor", "optionsFontColor", "optionsBackground", "optionsDisabledBackground", "optionsDisabledFontColor", "maintainTimeFontColor", "nextStepTipFontColor", "footerFontColor", "footerLinkColor", "footerIconColor"]), s(kn, "installment", ["selectIconColor", "optionsFontColor", "optionsBackground"]), s(kn, "block", ["imgColor", "fontColor"]), s(kn, "simple", ["fontColor"]), s(kn, "default", ["fontFamily", "fontLib"]), kn),
    jn = {
  number: "cardNumberIcon",
  cvc: "securityCodeIcon",
  firstName: "holderNameIcon",
  footer: "footerIcon"
};

function Tn(e) {
  return e.replace(/([A-Z])/g, "-$1").toLowerCase();
}

var Rn = function () {
  function e(t) {
    i(this, e), s(this, "theme", {}), this.theme = this.combineTheme(t);
  }

  return a(e, [{
    key: "combineTheme",
    value: function value(e) {
      if (!e || "object" !== ze(e) || 0 === Object.keys(e).length) return Dn;
      var t = JSON.parse(JSON.stringify(Dn));
      return Object.keys(e).forEach(function (n) {
        Object.keys(e[n]).forEach(function (r) {
          var i = e[n][r];
          i && ("string" == typeof i || Array.isArray(i)) && (t[n] || (t[n] = {}), t[n][r] = i);
        });
      }), t;
    }
  }, {
    key: "getTheme",
    value: function value() {
      return this.theme;
    }
  }, {
    key: "get",
    value: function value(e, t) {
      var n,
          r,
          i,
          o = null === (n = this.theme) || void 0 === n || null === (r = n[e]) || void 0 === r ? void 0 : r[t];
      return o && "string" == typeof o ? o : (null === (i = Dn[e]) || void 0 === i ? void 0 : i[t]) || "";
    }
  }, {
    key: "getCreditCardThemeValue",
    value: function value(e) {
      return this.get(u.CreditCard, e);
    }
  }, {
    key: "getFPXThemeValue",
    value: function value(e) {
      return this.get(u.FPX, e);
    }
  }, {
    key: "getInstallmentThemeValue",
    value: function value(e) {
      return this.get("installment", e);
    }
  }, {
    key: "getCreditCardStyle",
    value: function value() {
      var e = this;
      return Pn[u.CreditCard].map(function (t) {
        var n = Tn(t),
            r = e.getCreditCardThemeValue(t);
        return "--".concat(n, ": ").concat(r, ";");
      }).join("");
    }
  }, {
    key: "getFPXStyle",
    value: function value() {
      var e = this;
      return Pn[u.FPX].map(function (t) {
        var n = Tn(t),
            r = e.getFPXThemeValue(t);
        return "--".concat(n, ": ").concat(r, ";");
      }).join("");
    }
  }, {
    key: "getInstallmentStyle",
    value: function value() {
      var e = this;
      return Pn.installment.map(function (t) {
        var n = Tn(t),
            r = e.getInstallmentThemeValue(t);
        return "--".concat(n, ": ").concat(r, ";");
      }).join("");
    }
  }, {
    key: "getInputIcon",
    value: function value(e) {
      var t = jn[e],
          n = this.getCreditCardThemeValue(t);
      if (n) return {
        imgSrc: n
      };
      var r = this.getCreditCardThemeValue("".concat(t, "Svg"));
      return r ? {
        svg: r
      } : void 0;
    }
  }, {
    key: "getBlockStyle",
    value: function value() {
      var e = this;
      return Pn.block.map(function (t) {
        var n = Tn(t),
            r = e.get("block", t);
        return "--block-".concat(n, ": ").concat(r, ";");
      }).join("");
    }
  }, {
    key: "getSimpleStyle",
    value: function value() {
      var e = this;
      return Pn.simple.map(function (t) {
        var n = Tn(t),
            r = e.get("simple", t);
        return "--simple-".concat(n, ": ").concat(r, ";");
      }).join("");
    }
  }, {
    key: "getDefaultFontFamily",
    value: function value() {
      return this.theme["default"].fontFamily;
    }
  }, {
    key: "getDefaultFontLib",
    value: function value() {
      return this.theme["default"].fontLib;
    }
  }, {
    key: "handleDefaultThemeValidate",
    value: function value() {
      var e = this.theme["default"],
          t = e.fontLib,
          n = e.fontFamily;
      return !(!Array.isArray(n) || 0 === n.length) && (t === d.Google || t === d.System);
    }
  }]), e;
}(),
    Fn = window.CSS && window.CSS.supports && window.CSS.supports("(--foo: red)");

function Nn() {
  if (!Fn) {
    Element.prototype.matches || (Element.prototype.matches = Element.prototype.msMatchesSelector);
    var e,
        t = [],
        n = document,
        r = !1;
    document.addEventListener("DOMContentLoaded", function () {
      r = !0;
    }), "classList" in Element.prototype || j("classList", HTMLElement.prototype, Element.prototype), "innerHTML" in Element.prototype || j("innerHTML", HTMLElement.prototype, Element.prototype), "runtimeStyle" in Element.prototype || j("runtimeStyle", HTMLElement.prototype, Element.prototype), "undefined" == typeof SVGStyleElement || "sheet" in SVGStyleElement.prototype || Object.defineProperty(SVGStyleElement.prototype, "sheet", {
      get: function get() {
        for (var e, t = document.styleSheets, n = 0; e = t[n++];) {
          if (e.ownerNode === this) return e;
        }
      }
    });
    var i = {},
        o = new Set(),
        a = !1,
        s = !1,
        c = /([\s{;])(--([A-Za-z0-9-_]*)\s*:([^;!}{]+)(!important)?)(?=\s*([;}]|$))/g,
        u = /([{;]\s*)([A-Za-z0-9-_]+\s*:[^;}{]*var\([^!;}{]+)(!important)?(?=\s*([;}$]|$))/g,
        l = /-ieVar-([^:]+):/g,
        p = /-ie-([^};]+)/g,
        d = /:(hover|active|focus|target|visited|link|:before|:after|:first-letter|:first-line)/;
    O("style:not([iecp-ignore])", T), O("link[rel=stylesheet]:not([iecp-ignore])", T), O("[ie-style]", function (e) {
      var t = R("{" + e.getAttribute("ie-style")).substr(1);
      e.style.cssText += ";" + t;
      var n = F(e.style);
      n.getters && L(e, n.getters, "%styleAttr"), n.setters && A(e, n.setters);
    });
    var h = {
      hover: {
        on: "mouseenter",
        off: "mouseleave"
      },
      focus: {
        on: "focusin",
        off: "focusout"
      },
      active: {
        on: "CSSActivate",
        off: "CSSDeactivate"
      }
    },
        f = null;
    document.addEventListener("mousedown", function (e) {
      setTimeout(function () {
        if (e.target === document.activeElement) {
          var t = document.createEvent("Event");
          t.initEvent("CSSActivate", !0, !0), (f = e.target).dispatchEvent(t);
        }
      });
    }), document.addEventListener("mouseup", function () {
      if (f) {
        var e = document.createEvent("Event");
        e.initEvent("CSSDeactivate", !0, !0), f.dispatchEvent(e), f = null;
      }
    });
    var v = 0,
        y = new MutationObserver(function (e) {
      if (!s) for (var t, n = 0; t = e[n++];) {
        "iecp-needed" !== t.attributeName && X(t.target);
      }
    });
    setTimeout(function () {
      y.observe(document, {
        attributes: !0,
        subtree: !0
      });
    });
    var m = location.hash;
    addEventListener("hashchange", function (e) {
      var t = document.getElementById(location.hash.substr(1));

      if (t) {
        var n = document.getElementById(m.substr(1));
        X(t), X(n);
      } else X(document);

      m = location.hash;
    });
    var g = Object.getOwnPropertyDescriptor(HTMLElement.prototype, "style"),
        b = g.get;
    g.get = function () {
      var e = b.call(this);
      return e.owningElement = this, e;
    }, Object.defineProperty(HTMLElement.prototype, "style", g);
    var k = getComputedStyle;

    window.getComputedStyle = function (e) {
      var t = k.apply(this, arguments);
      return t.computedFor = e, t;
    };

    var x = CSSStyleDeclaration.prototype,
        w = x.getPropertyValue;

    x.getPropertyValue = function (e) {
      if (this.lastPropertyServedBy = !1, "-" !== (e = e.trim())[0] || "-" !== e[1]) return w.apply(this, arguments);
      var t = e.substr(2),
          n = "-ie-" + t,
          r = "-ie-❗" + t,
          i = this[r] || this[n];

      if (this.computedFor) {
        if (void 0 === i || C[i]) {
          if (C[i] || !I[e] || I[e].inherits) for (var o = this.computedFor.parentNode; o && 1 === o.nodeType;) {
            var a = getComputedStyle(o),
                s = a[r] || a[n];

            if (void 0 !== s) {
              i = G(this, s), this.lastPropertyServedBy = o;
              break;
            }

            o = o.parentNode;
          }
        } else i = G(this, i), this.lastPropertyServedBy = this.computedFor;

        if ("initial" === i) return "";
      }

      return void 0 === i && I[e] && (i = I[e].initialValue), void 0 === i ? "" : i;
    };

    var C = {
      inherit: 1,
      revert: 1,
      unset: 1
    },
        E = x.setProperty;
    x.setProperty = function (e, t, n) {
      if ("-" !== e[0] || "-" !== e[1]) return E.apply(this, arguments);
      var r = this.owningElement;
      r && (r.ieCP_setters || (r.ieCP_setters = {}), r.ieCP_setters[e] = 1), e = "-ie-" + ("important" === n ? "❗" : "") + e.substr(2), this.cssText += "; " + e + ":" + t + ";", r && X(r);
    }, window.CSS || (window.CSS = {});
    var I = {};

    CSS.registerProperty = function (e) {
      I[e.name] = e;
    };
  }

  function S(e, t) {
    try {
      return e.querySelectorAll(t);
    } catch (e) {
      return [];
    }
  }

  function O(r, i) {
    for (var o, a = {
      selector: r,
      callback: i,
      elements: new WeakMap()
    }, s = S(n, a.selector), c = 0; o = s[c++];) {
      a.elements.set(o, !0), a.callback.call(o, o);
    }

    t.push(a), e || (e = new MutationObserver(P)).observe(n, {
      childList: !0,
      subtree: !0
    }), _(a);
  }

  function _(e, t) {
    var i,
        o = 0,
        a = [];

    try {
      t && t.matches(e.selector) && a.push(t);
    } catch (e) {}

    for (r && Array.prototype.push.apply(a, S(t || n, e.selector)); i = a[o++];) {
      e.elements.has(i) || (e.elements.set(i, !0), e.callback.call(i, i));
    }
  }

  function D(e) {
    for (var n, r = 0; n = t[r++];) {
      _(n, e);
    }
  }

  function P(e) {
    for (var t, n, r, i, o = 0; n = e[o++];) {
      for (r = n.addedNodes, t = 0; i = r[t++];) {
        1 === i.nodeType && D(i);
      }
    }
  }

  function j(e, t, n) {
    var r = Object.getOwnPropertyDescriptor(t, e) || {};
    Object.defineProperty(n, e, r);
  }

  function T(e) {
    if (!e.ieCP_polyfilled && !e.ieCP_elementSheet && e.sheet) {
      if (e.href) return function (e, t) {
        var n = new XMLHttpRequest();
        n.open("GET", e), n.overrideMimeType("text/css"), n.onload = function () {
          n.status >= 200 && n.status < 400 && t(n.responseText);
        }, n.send();
      }(e.href, function (t) {
        var n = R(t);
        t !== n && N(e, n);
      });
      var t = e.innerHTML,
          n = R(t);
      t !== n && N(e, n);
    }
  }

  function R(e) {
    return e.replace(c, function (e, t, n, r, i, o) {
      return t + "-ie-" + (o ? "❗" : "") + r + ":" + i;
    }).replace(u, function (e, t, n, r) {
      return t + "-ieVar-" + (r ? "❗" : "") + n + "; " + n;
    });
  }

  function F(e) {
    var t,
        n,
        r = e.cssText,
        o = r.match(l);

    if (o) {
      var a = [];

      for (t = 0; n = o[t++];) {
        var s = n.slice(7, -1);
        "❗" === s[0] && (s = s.substr(1)), a.push(s), i[s] || (i[s] = []), i[s].push(e);
      }
    }

    var c = r.match(p);

    if (c) {
      var u = {};

      for (t = 0; n = c[t++];) {
        var d = n.substr(4).split(":"),
            h = d[0],
            f = d[1];
        "❗" === h[0] && (h = h.substr(1)), u[h] = f;
      }
    }

    return {
      getters: a,
      setters: u
    };
  }

  function N(e, t) {
    e.sheet.cssText = t, e.ieCP_polyfilled = !0;

    for (var n, r = e.sheet.rules, i = 0; n = r[i++];) {
      var o = F(n.style);
      o.getters && B(n.selectorText, o.getters), o.setters && M(n.selectorText, o.setters);
      var a = n.parentRule && n.parentRule.media && n.parentRule.media.mediaText;
      a && (o.getters || o.setters) && matchMedia(a).addListener(function () {
        X(document.documentElement);
      });
    }

    H();
  }

  function B(e, t) {
    V(e), O(U(e), function (n) {
      L(n, t, e), q(n);
    });
  }

  function L(e, t, n) {
    var r,
        i,
        o = 0,
        a = n.split(",");

    for (e.setAttribute("iecp-needed", !0), e.ieCPSelectors || (e.ieCPSelectors = {}); r = t[o++];) {
      for (i = 0; n = a[i++];) {
        var s = n.trim().split("::");
        e.ieCPSelectors[r] || (e.ieCPSelectors[r] = []), e.ieCPSelectors[r].push({
          selector: s[0],
          pseudo: s[1] ? "::" + s[1] : ""
        });
      }
    }
  }

  function M(e, t) {
    V(e), O(U(e), function (e) {
      A(e, t);
    });
  }

  function A(e, t) {
    for (var n in e.ieCP_setters || (e.ieCP_setters = {}), t) {
      e.ieCP_setters["--" + n] = 1;
    }

    X(e);
  }

  function H() {
    for (var e in i) {
      for (var t, n = i[e], r = 0; t = n[r++];) {
        if (!t.owningElement) {
          var o = t["-ieVar-" + e];
          if (o && "" !== (o = G(getComputedStyle(document.documentElement), o))) try {
            t[e] = o;
          } catch (e) {}
        }
      }
    }
  }

  function V(e) {
    for (var t in e = e.split(",")[0], h) {
      var n = e.split(":" + t);
      n.length > 1 && function () {
        var e = n[1].match(/^[^\s]*/),
            r = U(n[0] + e),
            i = h[t];
        O(r, function (e) {
          e.addEventListener(i.on, W), e.addEventListener(i.off, W);
        });
      }();
    }
  }

  function U(e) {
    return e.replace(d, "").replace(":not()", "");
  }

  function q(e) {
    o.add(e), a || (a = !0, requestAnimationFrame(function () {
      a = !1, s = !0, o.forEach(z), o.clear(), setTimeout(function () {
        s = !1;
      });
    }));
  }

  function z(e) {
    e.ieCP_unique || (e.ieCP_unique = ++v, e.classList.add("iecp-u" + e.ieCP_unique));
    var t = getComputedStyle(e),
        n = "";

    for (var r in e.runtimeStyle.cssText = "", e.ieCPSelectors) {
      var i = t["-ieVar-❗" + r],
          o = i || t["-ieVar-" + r];

      if (o) {
        var a = {},
            s = G(t, o, a);
        i && (s += " !important");

        for (var c, u = 0; c = e.ieCPSelectors[r][u++];) {
          "%styleAttr" === c.selector && (e.style[r] = s), (i || !1 === a.allByRoot) && (c.pseudo ? n += c.selector + ".iecp-u" + e.ieCP_unique + c.pseudo + "{" + r + ":" + s + "}\n" : e.runtimeStyle[r] = s);
        }
      }
    }

    !function (e, t) {
      if (!e.ieCP_styleEl && t) {
        var n = document.createElement("style");
        n.ieCP_elementSheet = 1, document.head.appendChild(n), e.ieCP_styleEl = n;
      }

      e.ieCP_styleEl && (e.ieCP_styleEl.innerHTML = t);
    }(e, n);
  }

  function X(e) {
    if (e) {
      e === document.documentElement && H();
      var t = e.querySelectorAll("[iecp-needed]");
      e.hasAttribute && e.hasAttribute("iecp-needed") && q(e);

      for (var n, r = 0; n = t[r++];) {
        q(n);
      }
    }
  }

  function W(e) {
    X(e.target);
  }

  function G(e, t, n) {
    return function (e, t) {
      for (var n, r, i = 0, o = null, a = 0, s = "", c = 0; n = e[c++];) {
        if ("(" === n && (++i, null === o && e[c - 4] + e[c - 3] + e[c - 2] === "var" && (o = i, s += e.substring(a, c - 4), a = c), e[c - 5] + e[c - 4] + e[c - 3] + e[c - 2] === "calc" && (r = i)), ")" === n && o === i) {
          var u = e.substring(a, c - 1).trim(),
              l = void 0,
              p = u.indexOf(",");
          -1 !== p && (l = u.slice(p + 1), u = u.slice(0, p)), s += t(u, l, r), a = c, o = null;
        }

        ")" === n && r === --i && (r = null);
      }

      return s + e.substring(a);
    }(t, function (t, r, i) {
      var o = e.getPropertyValue(t);
      return i && (o = o.replace(/^calc\(/, "(")), n && e.lastPropertyServedBy !== document.documentElement && (n.allByRoot = !1), "" === o && r && (o = G(e, r, n)), o;
    });
  }
}

function Bn(e) {
  return e && !/^https?/.test(e) ? "https://".concat(e) : e;
}

function Ln(e) {
  var t = e.channelId;
  return !!e.isBindCard || !p[t];
}

Ae(".payment-sdk-hidden {\n  display: none;\n}\n\n.pci-container * {\n  margin: 0;\n}\n\n.pci-container {\n  margin: 0 auto;\n}\n\n.pci-content {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.pci-content-form {\n  position: relative;\n  flex: 0 1 100%;\n}\n\n.pci-content-loading .pci-input-container {\n  background-color: var(--input-font-color);\n  opacity: 0.05;\n  border-radius: var(--input-border-radius);\n  height: var(--input-height);\n}\n\n.pci-content-loading .pci-input-box,\n.pci-content-loading .pci-icon {\n  display: none;\n}\n\n.pci-dateAndCvc-box {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n}\n\n.pci-pc-style .pci-dateAndCvc-box .pci-input-container {\n  width: 50%;\n}\n\n.pci-dateAndCvc-box > .pci-input-container:first-child {\n  margin-right: var(--form-item-gutter);\n}\n\n.pci-input-container {\n  position: relative;\n  width: 100%;\n  margin-bottom: var(--form-item-gutter);\n  overflow: visible;\n  transition: all 0.2s linear;\n}\n\n.pci-input-box {\n  position: relative;\n  box-sizing: border-box;\n  overflow: hidden;\n  z-index: 1;\n  background-color: var(--input-background);\n  height: var(--input-height);\n  border-width: 1px;\n  border-style: solid;\n  border-color: var(--input-border-color);\n  border-radius: var(--input-border-radius);\n  box-shadow: 0 0 0 0 var(--input-error-border-color);\n}\n\n.pci-input-box.pci-input-box-focus {\n  border-color: var(--input-focus-border-color);\n  box-shadow: 0 0 0 1px var(--input-focus-border-color);\n}\n\n.pci-input-box-not-empty .pci-input-label {\n  font-size: 10px;\n  transform: translateY(-9px);\n  transition: all 0.2s linear;\n}\n\n.pci-input-box-not-empty .pci-input-content {\n  transition: all 0.2s linear;\n  height: var(--input-height);\n}\n\n.pci-input-box-not-empty .pci-input-content input {\n  transition: all 0.2s linear;\n  padding: 20px 0 0 16px;\n}\n\n.pci-input-valid-error-box .pci-input-box {\n  border-color: var(--input-error-border-color);\n  box-shadow: 0 0 0 1px var(--input-error-border-color);\n}\n\n.pci-input-content {\n  height: 100%;\n  background-color: transparent;\n}\n\n#pci-input-number-content,\n#pci-input-firstName-content,\n#pci-input-cvc-content {\n  margin-right: 40px;\n}\n\n.pci-number-icon,\n.pci-firstName-icon,\n.pci-cvc-icon {\n  position: absolute;\n  top: calc(var(--input-height) / 2 - 16px / 2);\n  right: 16px;\n  width: 16px;\n  height: 16px;\n  z-index: 10;\n}\n\n.pci-input-label {\n  position: absolute;\n  top: calc(var(--input-height) / 2 - 16px / 2);\n  left: 16px;\n  font-size: 14px;\n  line-height: 16px;\n  color: var(--input-label-color);\n  pointer-events: none;\n  transition: all 0.2s linear;\n  white-space: nowrap;\n}\n\n.pci-tip-icon {\n  color: var(--input-icon-color);\n  width: 16px;\n  height: 16px;\n}\n\n.pci-number-icon .pci-brand-icon {\n  width: 38px;\n  height: 24px;\n  position: absolute;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  margin: auto;\n  max-width: -webkit-fit-content;\n  max-width: -moz-fit-content;\n  max-width: fit-content;\n}\n\n.pci-input-tip{\n  height: 0;\n  font-size: 14px;\n  line-height: 16px;\n  overflow: hidden;\n  transition: all 0.2s linear;\n  margin-left: 1px;\n  margin-top: var(--input-tip-gutter);\n  color: var(--input-tip-color);\n}\n\n.pci-input-tip:not(.pci-input-tip-show){\n  margin-top: 0 !important;\n}\n\n.pci-error-tip {\n  color: var(--input-error-font-color);\n}\n\n.pci-card {\n  flex: 0 1 316px;\n  height: 176px;\n  padding: 24px 24px 0;\n  box-sizing: border-box;\n  background: linear-gradient(180deg, #cfcfcf 0%, #c4c3c3 100%);\n  box-shadow: inset 0px 0px 10px rgba(255, 255, 255, 0.25);\n  border-radius: 4px;\n}\n\n.pci-card-logo {\n  width: 64px;\n  height: 40px;\n  margin-bottom: 24px;\n  background: #ffffff;\n  opacity: 0.4;\n  border-radius: 2px;\n}\n\n.pci-card-number {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 24px;\n}\n\n.pci-card-number-dot-list {\n  width: 48px;\n  height: 6px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.pci-card-number-dot-item {\n  width: 6px;\n  height: 6px;\n  border-radius: 6px;\n  background-color: #fff;\n}\n\n.pci-card-nameAndexpDate {\n  display: flex;\n  justify-content: space-between;\n}\n\n.pci-card-name,\n.pci-card-expDate {\n  float: right;\n  text-align: right;\n}\n\n.pci-card-name p,\n.pci-card-expDate p {\n  margin: 0 0 8px 0;\n  font-size: 12px;\n  line-height: 14px;\n  color: rgba(255, 255, 255, 0.7);\n}\n\n.pci-card-name .pci-card-number-dot-list {\n  float: left;\n}\n\n.pci-card-expDate .pci-card-number-dot-list {\n  float: right;\n}\n\n.pci-footer {\n  font-size: 11px;\n  line-height: 16px;\n  display: flex;\n}\n\n.pci-footer a,\n.pci-footer a:hover,\n.pci-footer a:active {\n  color: var(--footer-link-color);\n  text-decoration: none;\n}\n\n.pci-footer-tips {\n  color: var(--footer-font-color);\n  word-break: break-word;\n}\n\n.pci-footer-icon {\n  color: var(--footer-icon-color);\n  width: 16px;\n  height: 16px;\n  flex-shrink: 0;\n  margin-right: 4px;\n}\n\n.pci-footer-tips img {\n  max-width: 100%;\n}\n\n.pci-footer-loading {\n  background-color: var(--input-font-color);\n  opacity: 0.05;\n  border-radius: 4px;\n  height: 10px;\n}\n\n.pci-footer-loading .pci-footer-tips {\n  display: none;\n}\n\n.pci-mobile-style {\n  padding: 0;\n  box-sizing: border-box;\n}\n\n/* 小屏幕不展示卡片 */\n\n.pci-mobile-style .pci-container,\n.pci-mobile-style {\n  max-width: 100%;\n  width: 100%;\n  margin: 0 auto;\n}\n\n.pci-mobile-style .pci-content-form {\n  flex: auto;\n}\n\n.pci-mobile-style .pci-bind-card-container {\n  width: 100%;\n}\n\n.pci-mobile-style .pci-name-box {\n  margin-bottom: 0;\n}\n\n.pci-mobile-style .pci-dateAndCvc-box {\n  display: block;\n}\n\n.pci-mobile-style .pci-input-box {\n  margin-bottom: 0;\n}\n\n.pci-mobile-style .pci-input-container {\n  width: 100%;\n}\n\n.pci-mobile-style .pci-dateAndCvc-box .pci-input-container {\n  margin-right: 0;\n}\n\n.pci-mobile-style .pci-card {\n  display: none;\n}\n\n@media (min-width: 640px) {\n}\n\n@media (min-width: 768px) {\n}\n\n@media (min-width: 1024px) {\n}\n\n@media (min-width: 1280px) {\n}\n", {});
var Mn = ["fieldName"];

function An(e, t) {
  var n = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), n.push.apply(n, r);
  }

  return n;
}

function Hn(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = null != arguments[t] ? arguments[t] : {};
    t % 2 ? An(Object(n), !0).forEach(function (t) {
      s(e, t, n[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : An(Object(n)).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
    });
  }

  return e;
}

function Vn(e, t) {
  var _n4 = "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];

  if (!_n4) {
    if (Array.isArray(e) || (_n4 = function (e, t) {
      if (!e) return;
      if ("string" == typeof e) return Un(e, t);
      var n = Object.prototype.toString.call(e).slice(8, -1);
      "Object" === n && e.constructor && (n = e.constructor.name);
      if ("Map" === n || "Set" === n) return Array.from(e);
      if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Un(e, t);
    }(e)) || t && e && "number" == typeof e.length) {
      _n4 && (e = _n4);

      var r = 0,
          i = function i() {};

      return {
        s: i,
        n: function n() {
          return r >= e.length ? {
            done: !0
          } : {
            done: !1,
            value: e[r++]
          };
        },
        e: function e(_e6) {
          throw _e6;
        },
        f: i
      };
    }

    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  var o,
      a = !0,
      s = !1;
  return {
    s: function s() {
      _n4 = _n4.call(e);
    },
    n: function n() {
      var e = _n4.next();

      return a = e.done, e;
    },
    e: function e(_e7) {
      s = !0, o = _e7;
    },
    f: function f() {
      try {
        a || null == _n4["return"] || _n4["return"]();
      } finally {
        if (s) throw o;
      }
    }
  };
}

function Un(e, t) {
  (null == t || t > e.length) && (t = e.length);

  for (var n = 0, r = new Array(t); n < t; n++) {
    r[n] = e[n];
  }

  return r;
}

var qn = function () {
  function e(t, n) {
    var o = this;
    i(this, e), s(this, "env", void 0), s(this, "paymentMethod", void 0), s(this, "channelId", void 0), s(this, "i18n", void 0), s(this, "hasTipsArray", void 0), s(this, "pciSdk", void 0), s(this, "theme", void 0), s(this, "validateResult", {}), s(this, "cardBrand", void 0), s(this, "supportCardBrands", void 0), s(this, "isSupportCardBrand", void 0), s(this, "memoryResolve", void 0), s(this, "paymentInitData", void 0), s(this, "isPc", void 0), s(this, "container", void 0), s(this, "uuid", void 0), s(this, "reporter", void 0), s(this, "cardBinSwitch", !1), s(this, "cardBinVerifyResult", void 0), s(this, "createEventListener", r(v.mark(function e() {
      return v.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              o.pciSdk.create({
                placeholder: {},
                onInit: o.pciSdkInit,
                onFocus: o.handleFocusInput,
                onFieldValidChange: o.onFieldValidChange,
                onCardBinChange: o.onCardBinChange,
                extraConfig: {
                  cardBinSwitch: Boolean(o.cardBinSwitch),
                  cardBinRequestParams: {
                    merchantId: o.paymentInitData.merchantId,
                    paymentMethod: o.paymentInitData.paymentMethod,
                    currency: o.paymentInitData.currency
                  },
                  supportCardBrands: o.supportCardBrands
                }
              });

            case 1:
            case "end":
              return e.stop();
          }
        }
      }, e);
    }))), s(this, "onCardBinChange", function () {
      var e = r(v.mark(function e(t) {
        var n, r, i, a;
        return v.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                if (o.cardBinVerifyResult = t, n = t.binInfo, null != (r = t.verifyResult) && r.result ? o.isSupportCardBrand = !0 : o.isSupportCardBrand = !1, n.brand && "Other" !== n.brand ? (o.cardBrand = n.brand, o.setBrandIcon(o.cardBrand)) : (o.cardBrand = "", o.setBrandIcon(void 0)), null != r && r.result || null == r || !r.errorCode) {
                  e.next = 17;
                  break;
                }

                return i = r.errorCode, e.next = 8, o.i18n.get("validator.".concat(i));

              case 8:
                if (e.t0 = e.sent, e.t0) {
                  e.next = 13;
                  break;
                }

                return e.next = 12, o.i18n.get("cardIsNotSupported");

              case 12:
                e.t0 = e.sent;

              case 13:
                a = e.t0, o.setError("number", a), e.next = 18;
                break;

              case 17:
                o.setError("number", "");

              case 18:
              case "end":
                return e.stop();
            }
          }
        }, e);
      }));
      return function (t) {
        return e.apply(this, arguments);
      };
    }()), s(this, "insertLanguage", function () {
      var e = r(v.mark(function e(t, n) {
        var r, i, a, s, c, u, l, p, d, h, f, m;
        return v.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                o.i18n = t, o.hasTipsArray = [], r = n.showFirstName, i = y.filter(function (e) {
                  return r || "firstName" !== e;
                }), a = Vn(i), e.prev = 5, a.s();

              case 7:
                if ((s = a.n()).done) {
                  e.next = 26;
                  break;
                }

                return c = s.value, u = o.container.querySelector("#pci-input-".concat(c, "-label")), l = o.container.querySelector("#pci-input-".concat(c, "-container")), e.next = 13, o.i18n.get("formItems.".concat(c, ".labelTitle"));

              case 13:
                return u.textContent = e.sent, e.next = 16, o.i18n.get("formItems.".concat(c, ".tips"));

              case 16:
                if ((p = e.sent) && o.hasTipsArray.push({
                  key: c,
                  content: p
                }), o.validateResult[c] = {
                  isValid: !1,
                  isEmpty: !0
                }, p && Be(o.createTooltipDom(c), l), "firstName" !== c) {
                  e.next = 24;
                  break;
                }

                return e.next = 23, o.i18n.get("pleaseEnterNameOnCardOrBusinessName");

              case 23:
                o.container.querySelector("#pci-input-name-tip").textContent = e.sent;

              case 24:
                e.next = 7;
                break;

              case 26:
                e.next = 31;
                break;

              case 28:
                e.prev = 28, e.t0 = e["catch"](5), a.e(e.t0);

              case 31:
                return e.prev = 31, a.f(), e.finish(31);

              case 34:
                return o.hasTipsArray.length > 0 && (d = new He(), o.hasTipsArray.forEach(function (e) {
                  var t = o.container.querySelector("#pci-".concat(e.key, "-icon"));
                  d.mount(t, e.content);
                })), e.next = 37, o.getFooterTips(n);

              case 37:
                return h = e.sent, f = new Sn(), h && (null === (m = o.container.querySelector(".pci-footer-tips")) || void 0 === m || m.appendChild(f.autoParseToDom(h))), o.pciSdk.mount(".pci-content-form-".concat(o.uuid)), Nn(), e.abrupt("return", new Promise(function (e) {
                  o.memoryResolve = e;
                }));

              case 43:
              case "end":
                return e.stop();
            }
          }
        }, e, null, [[5, 28, 31, 34]]);
      }));
      return function (t, n) {
        return e.apply(this, arguments);
      };
    }()), s(this, "needShowPcStyle", function (e) {
      o.isPc = e;
      var t = o.container.querySelector("#pci-container");

      if (t) {
        var n = t.getAttribute("class");
        n = n.replace(/(\s*pci-mobile-style)|(\s*pci-pc-style)/g, ""), n += " ".concat(e ? "pci-pc-style" : "pci-mobile-style"), t.setAttribute("class", n);
        ["number", "firstName", "expDate", "cvc"].forEach(function (e) {
          var t,
              n = null === (t = o.container) || void 0 === t ? void 0 : t.querySelector("#pci-".concat(e, "-error"));

          if (n) {
            var r = null == n ? void 0 : n.textContent,
                i = null == n ? void 0 : n.parentElement;
            r && i && (i.style.height = "".concat(n.offsetHeight, "px"));
          }
        });
      }
    }), s(this, "createErrorDom", function (e) {
      return {
        content: "div",
        props: {
          "class": "pci-error-tip pci-input-tip"
        },
        children: {
          content: "div",
          props: {
            id: "pci-".concat(e, "-error")
          }
        }
      };
    }), s(this, "handleFocusInput", function () {
      var e = r(v.mark(function e(t) {
        var n, r, i, a, s, c, u, l, p, d, h, f, y;
        return v.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                if (n = t.fieldName, r = t.isEmpty, i = t.isFocus, a = t.isValid, s = o.container.querySelector("#pci-input-".concat(n, "-content")).parentElement, c = s.getAttribute("class"), u = !1, o.validateResult[n].isValid = a, o.validateResult[n].isEmpty = r, r && !i || c.includes("pci-input-box-not-empty") ? !i && r && c.includes("pci-input-box-not-empty") && (c = c.replace(" pci-input-box-not-empty", "")) : c += " pci-input-box-not-empty", i ? (o.checkAllInputClass(), c.includes("pci-input-box-focus") || (c += " pci-input-box-focus"), o.setError(n, ""), u = !0) : (u = !1, c = c.replace(" pci-input-box-focus", "")), "firstName" === n && o.handleShowOrHideDom({
                  id: "pci-input-name-tip",
                  type: "tip",
                  className: "pci-input-tip-show",
                  show: u
                }), l = "", i || r) {
                  e.next = 32;
                  break;
                }

                if (p = o.validateResult[n].isValid, d = !1, !p) {
                  e.next = 28;
                  break;
                }

                if (d = !0, !1 !== o.isSupportCardBrand || "number" !== n) {
                  e.next = 26;
                  break;
                }

                return d = !1, y = null === (h = o.cardBinVerifyResult) || void 0 === h || null === (f = h.verifyResult) || void 0 === f ? void 0 : f.errorCode, e.next = 20, o.i18n.get("validator.".concat(y));

              case 20:
                if (e.t0 = e.sent, e.t0) {
                  e.next = 25;
                  break;
                }

                return e.next = 24, o.i18n.get("cardIsNotSupported");

              case 24:
                e.t0 = e.sent;

              case 25:
                l = e.t0;

              case 26:
                e.next = 31;
                break;

              case 28:
                return e.next = 30, o.i18n.get("formItems.".concat(n, ".errorTips"));

              case 30:
                l = e.sent;

              case 31:
                d ? o.setError(n, "") : o.setError(n, l);

              case 32:
                s.setAttribute("class", c);

              case 33:
              case "end":
                return e.stop();
            }
          }
        }, e);
      }));
      return function (t) {
        return e.apply(this, arguments);
      };
    }()), s(this, "handleShowOrHideDom", function (e) {
      var t = e.id,
          n = e.className,
          r = e.type,
          i = e.content,
          a = e.show,
          s = o.container.querySelector("#".concat(t));
      if (!s) return null;
      var c = s.parentElement,
          u = c.parentElement,
          l = c.getAttribute("class"),
          p = u.getAttribute("class");
      "error" === r && (s.textContent = i), !i && !0 !== a || l.includes("".concat(n)) ? "" !== i && !1 !== a || !l.includes("".concat(n)) || (c.style.height = "0px", l = l.replace(" ".concat(n), ""), "error" === r && (p = p.replace(" pci-input-valid-error-box", ""))) : (l += " ".concat(n), c.style.height = "".concat(s.offsetHeight, "px"), "error" === r && (p += " pci-input-valid-error-box")), c.setAttribute("class", l), "error" === r && u.setAttribute("class", p);
    }), s(this, "onFieldValidChange", function (e) {
      var t = e.fieldName,
          n = m(e, Mn);
      o.validateResult[t] = Hn(Hn({}, o.validateResult[t]), n), e.isEmpty && o.setError(t, "");
    }), s(this, "pciSdkInit", function () {
      o.memoryResolve(!0);
      var e = o.container.querySelector("#pci-content-form"),
          t = e.getAttribute("class").replace(" pci-content-loading", "");
      e.setAttribute("class", t);
      var n = o.container.querySelector(".pci-footer"),
          r = n.getAttribute("class").replace(" pci-footer-loading", "");
      n.setAttribute("class", r);
      var i = {
        padding: "20px 0 0 16px",
        color: o.theme.getCreditCardThemeValue("inputFontColor")
      },
          a = o.theme.handleDefaultThemeValidate(),
          s = o.theme.getDefaultFontLib(),
          c = o.theme.getDefaultFontFamily();
      a ? (i.fontLib = s, i.fontFamily = c) : (o.reporter.reportErrorData("pci_form_setStyle_font_error", {
        fontLib: s,
        fontFamily: c
      }), console.warn("请检查 initTheme.fontLib 或者 initTheme.fontFamily 传值是否有误"));
      ["number", "firstName", "expDate", "cvc"].forEach(function (e) {
        o.pciSdk.setStyle({
          style: i,
          type: "base",
          fieldName: e
        });
      }), console.log("pciSdk Init 完成");
    }), s(this, "setCardBinSwitch", function () {
      var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
      o.cardBinSwitch = e;
    }), this.env = t, this.paymentInitData = n, this.paymentMethod = n.paymentMethod, this.channelId = n.channelId, this.uuid = nt(), this.pciSdk = new mn({
      host: n.host
    }), this.theme = new Rn(n.theme), this.reporter = new me(n), this.supportCardBrands = [];
  }

  var t, n, o, c, u, p, d;
  return a(e, [{
    key: "render",
    value: (d = r(v.mark(function e(t) {
      var n;
      return v.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              this.container = t, t.setAttribute("ontouchstart", ""), this.mutationObserver(), n = this.theme.getCreditCardStyle(), Be({
                content: "div",
                props: {
                  id: "pci-container",
                  "class": "pci-container ".concat(this.isPc ? "pci-pc-style" : "pci-mobile-style"),
                  style: Fn ? n : void 0,
                  "ie-style": Fn ? void 0 : n
                },
                children: [{
                  content: "div",
                  props: {
                    "class": "pci-content"
                  },
                  children: {
                    content: "div",
                    props: {
                      "class": "pci-content-form pci-content-loading pci-content-form-".concat(this.uuid),
                      id: "pci-content-form"
                    },
                    children: this.createFormItemsDom()
                  }
                }, {
                  content: "div",
                  props: {
                    "class": "pci-footer pci-footer-loading",
                    id: "pci-footer"
                  },
                  children: [this.createIconDom("footer", "pci-footer-icon"), {
                    content: "div",
                    props: {
                      "class": "pci-footer-tips"
                    }
                  }]
                }]
              }, t);

            case 6:
            case "end":
              return e.stop();
          }
        }
      }, e, this);
    })), function (e) {
      return d.apply(this, arguments);
    })
  }, {
    key: "getFooterTips",
    value: (p = r(v.mark(function e(t) {
      var n, r;
      return v.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              if ("SLPayments" !== this.channelId) {
                e.next = 18;
                break;
              }

              return e.next = 3, this.i18n.get("slPaymentsCountryFooter.".concat(t.merchantCountry));

            case 3:
              if (!(r = e.sent)) {
                e.next = 8;
                break;
              }

              n = r, e.next = 16;
              break;

            case 8:
              return e.next = 10, this.i18n.get("SLPaymentsFooter");

            case 10:
              if (e.t0 = e.sent, e.t0) {
                e.next = 15;
                break;
              }

              return e.next = 14, this.i18n.get("footer");

            case 14:
              e.t0 = e.sent;

            case 15:
              n = e.t0;

            case 16:
              e.next = 21;
              break;

            case 18:
              return e.next = 20, this.i18n.get("footer");

            case 20:
              n = e.sent;

            case 21:
              return e.t1 = "", e.next = 24, this.i18n.get("content.creditCard.serviceTips");

            case 24:
              if (e.t2 = e.sent, e.t2) {
                e.next = 27;
                break;
              }

              e.t2 = "";

            case 27:
              return e.t3 = e.t2, e.abrupt("return", e.t1.concat.call(e.t1, e.t3).concat(n || ""));

            case 29:
            case "end":
              return e.stop();
          }
        }
      }, e, this);
    })), function (e) {
      return p.apply(this, arguments);
    })
  }, {
    key: "createIconDom",
    value: function value(e, t) {
      var n = this.theme.getInputIcon(e),
          r = n.imgSrc,
          i = n.svg;
      return r ? {
        content: "img",
        props: {
          "class": t,
          src: r
        }
      } : i ? {
        content: "div",
        props: {
          "class": t,
          innerHTML: i
        }
      } : null;
    }
  }, {
    key: "createTooltipDom",
    value: function value(e) {
      var t = this.createIconDom(e, "pci-tip-icon");
      return {
        content: "div",
        props: {
          id: "pci-".concat(e, "-icon"),
          "class": "pci-icon pci-".concat(e, "-icon")
        },
        children: [t, {
          content: "img",
          props: {
            "class": "pci-brand-icon payment-sdk-hidden"
          }
        }]
      };
    }
  }, {
    key: "createFormItemsDom",
    value: function value() {
      var e = Ln(this.paymentInitData),
          t = this.createFormItem("number"),
          n = e ? this.createFormItem("firstName") : null,
          r = this.createFormItem("expDate"),
          i = this.createFormItem("cvc"),
          o = [t, n, {
        content: "div",
        props: {
          "class": "".concat(e ? "pci-dateAndCvc-box" : "")
        },
        children: [r, i]
      }];
      return e || o.splice(1, 1), o;
    }
  }, {
    key: "createFormItem",
    value: function value(e) {
      var t = {
        content: "div",
        props: {
          "class": "pci-input-container",
          id: "pci-input-".concat(e, "-container")
        },
        children: [{
          content: "div",
          props: {
            "class": "pci-input-box"
          },
          children: [{
            content: "label",
            props: {
              "class": "pci-input-label",
              id: "pci-input-".concat(e, "-label")
            }
          }, {
            content: "div",
            props: {
              "data-pci": e,
              "class": "pci-input-content",
              id: "pci-input-".concat(e, "-content")
            }
          }]
        }]
      };

      if ("firstName" === e) {
        var n = this.createNameEnterTipDom();
        t.children.push(n);
      }

      var r = this.createErrorDom(e);
      return t.children.push(r), t;
    }
  }, {
    key: "createNameEnterTipDom",
    value: function value() {
      return {
        content: "div",
        props: {
          "class": "pci-input-tip"
        },
        children: {
          content: "div",
          props: {
            id: "pci-input-name-tip"
          }
        }
      };
    }
  }, {
    key: "setError",
    value: function value(e, t) {
      var n = "pci-".concat(e, "-error");
      this.handleShowOrHideDom({
        id: n,
        type: "error",
        className: "pci-input-tip-show",
        content: t
      });
    }
  }, {
    key: "checkAllInputClass",
    value: function value() {
      var e = this,
          t = this.container.querySelectorAll(".pci-input-box-focus");
      [].slice.call(t).forEach(function (e) {
        e.classList.remove("pci-input-box-focus");
      }), Object.keys(this.validateResult).forEach(function (t) {
        e.validateResult[t].isEmpty && e.container.querySelector("#pci-input-".concat(t, "-content")).parentElement.classList.remove("pci-input-box-not-empty");
      });
    }
  }, {
    key: "validate",
    value: (u = r(v.mark(function e() {
      var t,
          n,
          r,
          i,
          o,
          a,
          s,
          c,
          u,
          l,
          p,
          d,
          h,
          f = this;
      return v.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              t = !0, n = Object.keys(this.validateResult), r = 0, i = n;

            case 3:
              if (!(r < i.length)) {
                e.next = 16;
                break;
              }

              if (o = i[r], a = this.validateResult[o], s = "", !a.isEmpty && a.isValid) {
                e.next = 12;
                break;
              }

              return e.next = 10, this.i18n.get("formItems.".concat(o, ".errorTips"));

            case 10:
              s = e.sent, t = !1;

            case 12:
              this.setError(o, s);

            case 13:
              r++, e.next = 3;
              break;

            case 16:
              if (this.cardBrand) {
                e.next = 23;
                break;
              }

              return e.next = 19, this.pciSdk.getCardBinVerifyResult()["catch"](function (e) {
                return f.reporter.handleError(e, "pci_sdk_getCardBrand_error");
              });

            case 19:
              c = e.sent, this.cardBinVerifyResult = c, null != (u = c.verifyResult) && u.result ? this.isSupportCardBrand = !0 : this.isSupportCardBrand = !1;

            case 23:
              if (!1 !== this.isSupportCardBrand) {
                e.next = 36;
                break;
              }

              return t = !1, d = null === (l = this.cardBinVerifyResult) || void 0 === l || null === (p = l.verifyResult) || void 0 === p ? void 0 : p.errorCode, e.next = 28, this.i18n.get("validator.".concat(d));

            case 28:
              if (e.t0 = e.sent, e.t0) {
                e.next = 33;
                break;
              }

              return e.next = 32, this.i18n.get("cardIsNotSupported");

            case 32:
              e.t0 = e.sent;

            case 33:
              h = e.t0, this.setError("number", h), this.reporter.reportData("validate_card", {
                validateState: "".concat(t, "_").concat(this.cardBrand)
              });

            case 36:
              if (!t) {
                e.next = 40;
                break;
              }

              return e.next = 39, this.pciSdk.validate()["catch"](function (e) {
                return f.reporter.handleError(e, "pci_validate_error");
              });

            case 39:
              t = e.sent;

            case 40:
              return e.abrupt("return", t);

            case 41:
            case "end":
              return e.stop();
          }
        }
      }, e, this);
    })), function () {
      return u.apply(this, arguments);
    })
  }, {
    key: "pay",
    value: (c = r(v.mark(function e(t, n) {
      var r,
          i,
          o,
          a,
          s,
          c = this;
      return v.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.prev = 0, e.next = 3, this.beforePay()["catch"](this.reporter.handleError);

            case 3:
              if (r = e.sent, i = n.hooks, e.t0 = null == i ? void 0 : i.beforeConfirm, !e.t0) {
                e.next = 9;
                break;
              }

              return e.next = 9, i.beforeConfirm()["catch"](this.reporter.handleError);

            case 9:
              if (o = tt(this.channelId, r), null == i || !i.extendConfirmParams) {
                e.next = 15;
                break;
              }

              return e.next = 13, i.extendConfirmParams()["catch"](this.reporter.handleError);

            case 13:
              (a = e.sent) && Xe(a) && (o = Ge(a, o));

            case 15:
              return e.next = 17, this.pciSdk.pay(t, Hn({
                paymentMethod: this.paymentMethod
              }, o))["catch"](function (e) {
                return 400 === e.statusCode && c.getErrorFromServer(e.data), c.reporter.handleError(e, "pci_pay_error", {
                  request: {
                    params: {
                      nextAction: t,
                      extraParams: o
                    }
                  },
                  response: {
                    error: e
                  }
                });
              });

            case 17:
              if (s = e.sent, e.t1 = null == i ? void 0 : i.afterConfirm, !e.t1) {
                e.next = 22;
                break;
              }

              return e.next = 22, i.afterConfirm()["catch"](this.reporter.handleError);

            case 22:
              return e.abrupt("return", Ke(s, n));

            case 25:
              e.prev = 25, e.t2 = e["catch"](0), this.reporter.handleError(e.t2);

            case 28:
            case "end":
              return e.stop();
          }
        }
      }, e, this, [[0, 25]]);
    })), function (e, t) {
      return c.apply(this, arguments);
    })
  }, {
    key: "beforePay",
    value: (o = r(v.mark(function e() {
      return v.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              if (this.channelId !== l.WorldPay) {
                e.next = 2;
                break;
              }

              return e.abrupt("return", this.worldpayBeforePay());

            case 2:
            case "end":
              return e.stop();
          }
        }
      }, e, this);
    })), function () {
      return o.apply(this, arguments);
    })
  }, {
    key: "worldpayBeforePay",
    value: (n = r(v.mark(function e() {
      var t,
          n,
          r,
          i,
          o,
          a,
          s,
          c,
          u,
          l,
          p,
          d,
          h = this;
      return v.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return t = this.paymentInitData, n = t.merchantId, r = t.paymentMethod, i = t.channelId, o = {
                merchantId: n,
                paymentMethod: r,
                channelId: i
              }, a = "".concat(this.env.host, "/v1/api/cashier/channel/info"), e.next = 5, Ce.post(a, o)["catch"](function (e) {
                return h.reporter.handleError(e, "cashier_channel_info_error", {
                  url: a,
                  request: {
                    params: o
                  },
                  response: {
                    error: e
                  }
                });
              });

            case 5:
              if (s = e.sent, c = (null == s ? void 0 : s.data) || {}, (u = c.type) !== f.Confirm) {
                e.next = 12;
                break;
              }

              return e.abrupt("return", c);

            case 12:
              if (u !== f.WorldPayGather) {
                e.next = 19;
                break;
              }

              return e.next = 15, this.pciSdk.getBeforePayData(c)["catch"](function (e) {
                h.reporter.handleError(e, "cashier_pci_ddc_error", {
                  response: {
                    error: e
                  }
                });
              });

            case 15:
              return l = e.sent, e.abrupt("return", Hn(Hn({}, l), {}, {
                type: u
              }));

            case 19:
              throw p = "'NextAction' type not support: ".concat(u), (d = new j(p, x.InnerSDKError, "NextActionTypeNotSupport")).data = {
                code: x.InnerSDKError,
                msg: p
              }, d;

            case 23:
            case "end":
              return e.stop();
          }
        }
      }, e, this);
    })), function () {
      return n.apply(this, arguments);
    })
  }, {
    key: "setSupportCardBrands",
    value: function value(e) {
      this.supportCardBrands = e;
    }
  }, {
    key: "getErrorFromServer",
    value: (t = r(v.mark(function e(t) {
      var n, r;
      return v.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              n = "", r = "", e.t0 = t.code, e.next = "4455" === e.t0 ? 5 : "3001" === e.t0 ? 10 : "4459" === e.t0 ? 15 : "4453" === e.t0 ? 20 : 25;
              break;

            case 5:
              return n = "number", e.next = 8, this.i18n.get("pleaseEnterValidCardNumber");

            case 8:
              return r = e.sent, e.abrupt("break", 25);

            case 10:
              return n = "number", e.next = 13, this.i18n.get("pleaseChangeAnotherCard");

            case 13:
              return r = e.sent, e.abrupt("break", 25);

            case 15:
              return n = "expDate", e.next = 18, this.i18n.get("pleaseEnterExpired");

            case 18:
              return r = e.sent, e.abrupt("break", 25);

            case 20:
              return n = "cvc", e.next = 23, this.i18n.get("pleaseEnterCVV");

            case 23:
              return r = e.sent, e.abrupt("break", 25);

            case 25:
              r && (this.setError(n, r), this.validateResult[n].isValid = !1);

            case 26:
            case "end":
              return e.stop();
          }
        }
      }, e, this);
    })), function (e) {
      return t.apply(this, arguments);
    })
  }, {
    key: "mutationObserver",
    value: function value() {
      var e = this,
          t = this.paymentInitData.needAdaptive,
          n = void 0 === t || t,
          r = "number" == typeof n ? n : 600;
      this.isPc = this.container.offsetWidth >= r;
      var i = null;
      if (!n && 0 !== n) return null;
      window.addEventListener("resize", function () {
        i && (clearTimeout(i), i = null), i = setTimeout(function () {
          var t = getComputedStyle(e.container).getPropertyValue("width").replace("px", "");
          e.needShowPcStyle(Number(t) > r);
        }, 200);
      });
    }
  }, {
    key: "setBrandIcon",
    value: function value(e) {
      var t = this.container.querySelector("#pci-number-icon"),
          n = t.querySelector(".pci-tip-icon"),
          r = t.querySelector(".pci-brand-icon"),
          i = t.querySelector(".pci-tooltip-wrap");

      if (r.onerror = function () {
        r.style.display = "none";
      }, r.onload = function () {
        r.style.display = "block";
      }, e) {
        var o = "".concat(this.env.host, "/payment-sdk/assets/image/").concat(encodeURIComponent(e), ".png");
        r.setAttribute("src", o), r.classList.remove("payment-sdk-hidden"), n.classList.add("payment-sdk-hidden"), i.classList.add("payment-sdk-hidden");
      } else r.classList.add("payment-sdk-hidden"), n.classList.remove("payment-sdk-hidden"), i.classList.remove("payment-sdk-hidden"), r.setAttribute("src", "");
    }
  }]), e;
}();

function zn(e) {
  var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "en";
  return "https://cdn.myshopline.com/t/i18n/payment-acceptance-payment-sdk/".concat(e, "/").concat(t, ".raw.tree.json");
}

function Xn(e, t) {
  var n = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), n.push.apply(n, r);
  }

  return n;
}

function Wn(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = null != arguments[t] ? arguments[t] : {};
    t % 2 ? Xn(Object(n), !0).forEach(function (t) {
      s(e, t, n[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Xn(Object(n)).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
    });
  }

  return e;
}

var Gn = {
  "zh-CN": "zh-hans-cn",
  "zh-TW": "zh-hant-tw",
  no: "nb"
},
    Zn = {},
    Jn = function () {
  function e(t, n) {
    i(this, e), s(this, "newLanguage", void 0), s(this, "displayLanguage", void 0), s(this, "data", void 0), s(this, "defaultData", void 0), s(this, "language", "en"), s(this, "env", void 0), s(this, "languageJson", void 0), s(this, "defaultJson", void 0), this.language = t, this.env = n.env, this.init();
  }

  var t, n, o, c, u, l, p;
  return a(e, [{
    key: "init",
    value: function value() {
      var e = this;
      this.newLanguage = "string" == typeof this.language ? {
        extend: this.language
      } : this.language, this.newLanguage.extend = this.newLanguage.extend || "en", this.displayLanguage = this.newLanguage.extend;
      var t = Gn[this.displayLanguage] ? Gn[this.displayLanguage] : this.displayLanguage;
      this.languageJson = this.requestJsonData(t)["catch"](function () {
        var n = r(v.mark(function n(r) {
          var i;
          return v.wrap(function (n) {
            for (;;) {
              switch (n.prev = n.next) {
                case 0:
                  return ye.reportErrorData("I18n_request_json_error", {
                    language: t,
                    response: {
                      error: r
                    }
                  }), e.displayLanguage = "en", i = e.requestJsonData("en"), e.defaultJson = i, n.abrupt("return", i);

                case 5:
                case "end":
                  return n.stop();
              }
            }
          }, n);
        }));
        return function (e) {
          return n.apply(this, arguments);
        };
      }());
    }
  }, {
    key: "setData",
    value: (p = r(v.mark(function e() {
      var t, n;
      return v.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.next = 2, this.languageJson;

            case 2:
              t = e.sent, n = t.data, this.data = n;

            case 5:
            case "end":
              return e.stop();
          }
        }
      }, e, this);
    })), function () {
      return p.apply(this, arguments);
    })
  }, {
    key: "setDefaultData",
    value: (l = r(v.mark(function e() {
      var t, n;
      return v.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return this.defaultJson || (this.defaultJson = this.requestJsonData("en")), e.next = 3, this.defaultJson;

            case 3:
              t = e.sent, n = t.data, this.defaultData = n;

            case 6:
            case "end":
              return e.stop();
          }
        }
      }, e, this);
    })), function () {
      return l.apply(this, arguments);
    })
  }, {
    key: "requestJsonData",
    value: (u = r(v.mark(function e(t) {
      var n, r, i, o;
      return v.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              if (n = "".concat(this.env, "_").concat(t), !(r = Zn[n])) {
                e.next = 6;
                break;
              }

              return e.next = 5, r;

            case 5:
              return e.abrupt("return", e.sent);

            case 6:
              return i = zn(this.env, t), Zn[n] = Ce.get(i), e.next = 10, Zn[n];

            case 10:
              return o = e.sent, e.abrupt("return", o);

            case 12:
            case "end":
              return e.stop();
          }
        }
      }, e, this);
    })), function (e) {
      return u.apply(this, arguments);
    })
  }, {
    key: "getVal",
    value: function value(e, t) {
      return t.split(".").reduce(function (e, t) {
        var n;
        return null !== (n = null == e ? void 0 : e[t]) && void 0 !== n ? n : "";
      }, e);
    }
  }, {
    key: "getOne",
    value: (c = r(v.mark(function e(t) {
      var n;
      return v.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              if (this.data) {
                e.next = 3;
                break;
              }

              return e.next = 3, this.setData();

            case 3:
              if ("" !== (n = "" === (n = this.getVal(this.newLanguage, t)) ? this.getVal(this.data, t) : n)) {
                e.next = 12;
                break;
              }

              if (this.defaultData) {
                e.next = 9;
                break;
              }

              return e.next = 9, this.setDefaultData();

            case 9:
              return e.abrupt("return", this.getVal(this.defaultData, t));

            case 12:
              return e.abrupt("return", n);

            case 13:
            case "end":
              return e.stop();
          }
        }
      }, e, this);
    })), function (e) {
      return c.apply(this, arguments);
    })
  }, {
    key: "getData",
    value: (o = r(v.mark(function e() {
      return v.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              if (this.data) {
                e.next = 3;
                break;
              }

              return e.next = 3, this.setData();

            case 3:
              return e.abrupt("return", Wn(Wn({}, this.data), this.newLanguage));

            case 4:
            case "end":
              return e.stop();
          }
        }
      }, e, this);
    })), function () {
      return o.apply(this, arguments);
    })
  }, {
    key: "get",
    value: (n = r(v.mark(function e(t) {
      var n = this;
      return v.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              if (!Array.isArray(t)) {
                e.next = 6;
                break;
              }

              return e.next = 3, Promise.all(t.map(function (e) {
                return n.getOne(e);
              }));

            case 3:
              return e.abrupt("return", e.sent);

            case 6:
              return e.next = 8, this.getOne(t);

            case 8:
              return e.abrupt("return", e.sent);

            case 9:
            case "end":
              return e.stop();
          }
        }
      }, e, this);
    })), function (e) {
      return n.apply(this, arguments);
    })
  }, {
    key: "getDisplayLanguage",
    value: (t = r(v.mark(function e() {
      return v.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              if (this.data) {
                e.next = 3;
                break;
              }

              return e.next = 3, this.setData();

            case 3:
              return e.abrupt("return", this.displayLanguage);

            case 4:
            case "end":
              return e.stop();
          }
        }
      }, e, this);
    })), function () {
      return t.apply(this, arguments);
    })
  }]), e;
}();

function Qn(e, t) {
  var n = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), n.push.apply(n, r);
  }

  return n;
}

function Yn(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = null != arguments[t] ? arguments[t] : {};
    t % 2 ? Qn(Object(n), !0).forEach(function (t) {
      s(e, t, n[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Qn(Object(n)).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
    });
  }

  return e;
}

var $n = function () {
  function e(t, n, r) {
    i(this, e), s(this, "env", void 0), s(this, "initData", void 0), s(this, "containerElement", void 0), s(this, "pciUiInstance", void 0), s(this, "reporter", void 0), s(this, "initResult", void 0), this.env = t, this.initData = n, this.reporter = new me(n), r && (this.containerElement = r);
  }

  var t, n, o, c;
  return a(e, [{
    key: "validate",
    value: (c = r(v.mark(function e() {
      return v.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.next = 2, this.pciUiInstance.validate();

            case 2:
              return e.abrupt("return", e.sent);

            case 3:
            case "end":
              return e.stop();
          }
        }
      }, e, this);
    })), function () {
      return c.apply(this, arguments);
    })
  }, {
    key: "pay",
    value: (o = r(v.mark(function e(t, n) {
      return v.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.next = 2, this.pciUiInstance.pay(t, n);

            case 2:
              return e.abrupt("return", e.sent);

            case 3:
            case "end":
              return e.stop();
          }
        }
      }, e, this);
    })), function (e, t) {
      return o.apply(this, arguments);
    })
  }, {
    key: "render",
    value: (n = r(v.mark(function e(t, n) {
      var r,
          i = this;
      return v.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              if (!(!t && !this.containerElement || t && this.containerElement)) {
                e.next = 2;
                break;
              }

              return e.abrupt("return");

            case 2:
              return this.containerElement = t, this.pciUiInstance = new qn(this.env, Yn({}, this.initData)), this.pciUiInstance.setCardBinSwitch(this.initResult.cardBinSwitch), this.pciUiInstance.setSupportCardBrands(this.initResult.brands || []), this.pciUiInstance.createEventListener(), e.next = 9, this.pciUiInstance.render(t)["catch"](function (e) {
                return i.reporter.handleError(e, "pci_render_error");
              });

            case 9:
              return r = new Jn(this.initData.language, {
                env: this.env.slI18nEnv
              }), n.showFirstName = Ln(this.initData), e.next = 13, this.pciUiInstance.insertLanguage(r, n)["catch"](this.reporter.handleError);

            case 13:
              return e.abrupt("return", e.sent);

            case 14:
            case "end":
              return e.stop();
          }
        }
      }, e, this);
    })), function (e, t) {
      return n.apply(this, arguments);
    })
  }, {
    key: "destroy",
    value: function value() {
      this.containerElement && (this.containerElement.innerHTML = ""), this.pciUiInstance = null;
    }
  }, {
    key: "needRenderWidget",
    value: (t = r(v.mark(function e() {
      return v.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.abrupt("return", !0);

            case 1:
            case "end":
              return e.stop();
          }
        }
      }, e);
    })), function () {
      return t.apply(this, arguments);
    })
  }, {
    key: "setInitResult",
    value: function value(e) {
      this.initResult = e;
    }
  }]), e;
}(),
    Kn = {
  AED: "د.إ(*)",
  AUD: "A$(*)",
  CNY: "CN¥(*)",
  EUR: "€(*)",
  GBP: "£(*)",
  HKD: "HK$(*)",
  JPY: "JP¥(*)",
  MYR: "RM(*)",
  SGD: "S$(*)",
  THB: "฿(*)",
  TWD: "NT$(*)",
  USD: "US$(*)",
  VND: "(*) ₫"
};

function er(e, t) {
  var n = t,
      r = Kn[e];
  return r ? r.replace("(*)", n) : "".concat(e).concat(n);
}

var tr = function tr() {
  var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "payment-sdk";
  return function (t) {
    return "".concat(e, "_").concat(t);
  };
},
    nr = function nr(e, t, n) {
  if ("string" != typeof e || !e) return "";
  return e.replace(/{{\s*([^}\s]+)\s*}}/g, function (e, r) {
    if (void 0 !== t[r]) {
      var i = t[r];
      return "function" == typeof n ? n(i) : i;
    }

    return e;
  });
},
    rr = function () {
  var e = r(v.mark(function e(t, n) {
    return v.wrap(function (e) {
      for (;;) {
        switch (e.prev = e.next) {
          case 0:
            if (0 !== Number(n)) {
              e.next = 3;
              break;
            }

            return e.abrupt("return", "");

          case 3:
            return e.t0 = nr, e.next = 6, t.get("installmentCount");

          case 6:
            return e.t1 = e.sent, e.t2 = {
              number: n
            }, e.t3 = (0, e.t0)(e.t1, e.t2), e.abrupt("return", " x " + e.t3);

          case 10:
          case "end":
            return e.stop();
        }
      }
    }, e);
  }));
  return function (t, n) {
    return e.apply(this, arguments);
  };
}();

Ae(".payment-sdk-hidden {\n  display: none;\n}\n\n/** 以 payment-sdk-select 为calssname前缀 */\n\n.payment-sdk-select_container * {\n  margin: 0;\n}\n\n.payment-sdk-select_container {\n  margin: 0 auto;\n}\n\n.payment-sdk-select_content {\n  position: relative;\n}\n\n/* 骨架屏样式 开始 */\n\n.payment-sdk-select_loading .payment-sdk-select_select {\n  background-color: var(--input-font-color);\n  opacity: 0.05;\n}\n\n.payment-sdk-select_loading .payment-sdk-select_select-input\n{\n  display: none;\n}\n\n/* 骨架屏样式 结束 */\n\n.payment-sdk-select_select {\n  position: relative;\n  box-sizing: border-box;\n  overflow: hidden;\n  height: var(--input-height);\n  border-width: 1px;\n  border-style: solid;\n  border-color: var(--input-border-color);\n  border-radius: var(--input-border-radius);\n}\n\n.payment-sdk-select_select-input-mask {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1;\n}\n\n.payment-sdk-select_select-input {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  padding: 14px 16px;\n  line-height: 18px;\n  font-size: 14px;\n  border: 1px solid;\n  box-sizing: border-box;\n  border-radius: 4px;\n  outline: none;\n  background-image: none;\n  border-color: #CCCCCC;\n  transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);\n  -webkit-appearance: none; /* 不应用任何特殊样式（去除input的默认样式） */\n  -webkit-tap-highlight-color: rgba(255, 0, 0, 0); /* 删除点击输入框时高亮的蓝色 */\n  cursor: pointer;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n  border: none;\n  color: var(--input-font-color);\n  /* @apply bg-select; */\n  background-color: var(--input-background);\n}\n\n.payment-sdk-select_select-input::-moz-placeholder {\n  color: #999999;\n}\n\n.payment-sdk-select_select-input:-ms-input-placeholder {\n  color: #999999;\n}\n\n.payment-sdk-select_select-input::placeholder {\n  color: #999999;\n}\n\n.payment-sdk-select_selected-icon {\n  display: none;\n  position: absolute;\n  width: 20px;\n  height: 20px;\n  top: 14px;\n  left: 14px;\n}\n\n.payment-sdk-select_select .payment-sdk-select_input-suffix {\n  position: absolute;\n  top: calc(50% - 2px);\n  transform: translateY(-50%);\n  right: 19.75px;\n  color: #1E1E1E;\n  color: var(--select-icon-color);\n}\n\n.payment-sdk-select_bank-list {\n  position: absolute;\n  top: 48px;\n  top: var(--input-height);\n  left: 0;\n  width: 100%;\n  box-sizing: border-box;\n  max-height: 0;\n  z-index: 2043;\n  overflow-y: scroll;\n  box-shadow: 0px 1px 3px rgba(54, 62, 81, 0.2),\n    0px 0px 16px rgba(54, 62, 81, 0.1);\n  border-radius: 6px;\n  transition: max-height 0.15s linear;\n  color: #363D4D;\n  background-color: #FFFFFF;\n}\n\n.payment-sdk-select_bank-item {\n  position: relative;\n  display: flex;\n  height: 44px;\n  padding: 0 16px;\n  line-height: 44px;\n  box-sizing: border-box;\n  overflow: hidden;\n  color: var(--options-font-color);\n  background-color: var(--options-background);\n}\n\n.payment-sdk-select_bank-item-mask {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  cursor: pointer;\n}\n\n.is-disabled .payment-sdk-select_bank-item-mask {\n  cursor: not-allowed;\n}\n\n.payment-sdk-select_bank-item.is-disabled {\n  background-color: #F7F8FB;\n  color: #B8BECC;\n}\n\n.payment-sdk-select_bank-item img {\n  flex: 0 0 38px;\n  width: 38px;\n  height: 38px;\n  border-radius: 4px;\n}\n\n.payment-sdk-select_bank-info {\n  display: flex;\n  flex: 1;\n  margin-left: 10px;\n  font-size: 14px;\n}\n\n.payment-sdk-select_bank-info .payment-sdk-select_bank-name {\n  flex: 1;\n  margin-right: 10px;\n  white-space: nowrap;\n}\n\n/* 错误样式 开始 */\n\n.payment-sdk-select_content-error .payment-sdk-select_select-input {\n  border-color: #F04949;\n  box-shadow: 0 0 0 1px #F04949;\n}\n\n.payment-sdk-select_error-tip {\n  height: 0;\n  font-size: 14px;\n  /* line-height: 16px; */\n  overflow: hidden;\n  /* margin-left: 1px; */\n  /* margin-top: 6px; */\n  color: #F04949;\n  transition: all 0.2s linear;\n}\n\n/* 错误样式 结束 */\n\n.payment-sdk-select_mobile-style .is-disabled .payment-sdk-select_bank-info {\n  flex-direction: column;\n  line-height: 1;\n  justify-content: center;\n}\n\n.payment-sdk-select_mobile-style .is-disabled .payment-sdk-select_bank-name {\n  line-height: 20px;\n}\n\n@media (min-width: 640px) {\n}\n\n@media (min-width: 768px) {\n}\n\n@media (min-width: 1024px) {\n}\n\n@media (min-width: 1280px) {\n}\n", {});

var ir = tr("payment-sdk-select"),
    or = function () {
  function e(t) {
    var n = this,
        o = t.env,
        a = t.dataSource;
    i(this, e), s(this, "container", void 0), s(this, "theme", void 0), s(this, "env", void 0), s(this, "i18n", void 0), s(this, "paymentInitData", void 0), s(this, "isPc", void 0), s(this, "selectListDom", void 0), s(this, "selectContentDom", void 0), s(this, "installmentInfo", void 0), s(this, "config", {}), s(this, "selectResult", void 0), s(this, "mount", function (e) {
      var t;

      if (n.container = e, 1 !== (null === (t = n.installmentInfo) || void 0 === t ? void 0 : t.length)) {
        var r = n.theme.getInstallmentStyle();
        n.mutationObserver(), Be({
          content: "div",
          props: {
            "class": "".concat(ir("container"), " ").concat(n.isPc ? ir("pc-style") : ir("mobile-style")),
            style: Fn ? r : void 0,
            "ie-style": Fn ? void 0 : r
          },
          children: [{
            content: "div",
            props: {
              "class": "".concat(ir("content"), " ").concat(ir("loading")),
              id: "select-content"
            },
            children: [{
              content: "div",
              props: {
                "class": ir("select"),
                id: "select-wrap"
              },
              children: [{
                content: "div",
                props: {
                  "class": ir("select-input-mask")
                }
              }, {
                content: "input",
                props: {
                  readonly: "readonly",
                  autocomplete: "off",
                  id: "select-input",
                  "class": ir("select-input")
                }
              }, {
                content: "img",
                props: {
                  id: "selected-icon",
                  "class": ir("selected-icon")
                }
              }, {
                content: "div",
                props: {
                  "class": ir("input-suffix"),
                  innerHTML: '<svg width="9" height="6" viewBox="0 0 9 6" fill="none" xmlns="http://www.w3.org/2000/svg">\n<path d="M1.23682 1.5L4.73682 5L8.23682 1.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" fill="none"/>\n</svg>'
                }
              }]
            }, {
              content: "div",
              props: {
                id: "select-list",
                "class": ir("bank-list")
              },
              children: ""
            }]
          }]
        }, e), n.selectListDom = n.container.querySelector("#select-list"), n.selectListDom.addEventListener("click", n.handleSelect, !1), n.selectContentDom = n.container.querySelector("#select-content"), n.handleHideSelect(), n.bindClick();
      }
    }), s(this, "needShowPcStyle", function (e) {
      n.isPc = e;
      var t = n.container.querySelector("".concat(ir("container")));

      if (t) {
        var r = t.getAttribute("class");
        r = r.replace(/(\s*payment-sdk-select_mobile-style)|(\s*payment-sdk-select_pc-style)/g, ""), r += " ".concat(ir(e ? "pc-style" : "mobile-style")), t.setAttribute("class", r);
      }
    }), s(this, "insertLanguage", function () {
      var e = r(v.mark(function e(t) {
        var r, i;
        return v.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                if (1 !== (null === (r = n.installmentInfo) || void 0 === r ? void 0 : r.length)) {
                  e.next = 4;
                  break;
                }

                return i = n.installmentInfo[0].count, n.setSelectBankCode(i, "", !0), e.abrupt("return");

              case 4:
                return n.i18n = t, e.next = 7, n.createBankItemTemplate();

              case 7:
                Be(e.sent, n.selectListDom);

              case 9:
              case "end":
                return e.stop();
            }
          }
        }, e);
      }));
      return function (t) {
        return e.apply(this, arguments);
      };
    }()), s(this, "createBankItemTemplate", r(v.mark(function e() {
      var t, i, o, a;
      return v.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              if (n.installmentInfo) {
                e.next = 2;
                break;
              }

              throw new Error("installmentInfo is null");

            case 2:
              return t = "", i = "", o = {
                content: "div",
                props: {},
                children: []
              }, a = n.installmentInfo.map(function () {
                var e = r(v.mark(function e(r, o) {
                  var a, s, c, u, l, p;
                  return v.wrap(function (e) {
                    for (;;) {
                      switch (e.prev = e.next) {
                        case 0:
                          return a = r.count, s = r.installDownpay, c = r.installpay, u = "0" === a ? s : c, l = ir("bank-item"), e.t0 = "".concat(er(n.paymentInitData.currency, u), " "), e.next = 6, rr(n.i18n, a);

                        case 6:
                          return e.t1 = e.sent, p = e.t0.concat.call(e.t0, e.t1), 0 === o && (t = a, i = p), e.abrupt("return", {
                            content: "div",
                            props: {
                              "class": l
                            },
                            children: [{
                              content: "div",
                              props: {
                                count: a,
                                installDownpay: s,
                                installpay: c,
                                showVal: p,
                                "class": ir("bank-item-mask")
                              }
                            }, {
                              content: "div",
                              props: {
                                "class": ir("bank-info")
                              },
                              children: [{
                                content: "div",
                                props: {
                                  "class": ir("bank-name")
                                },
                                children: p
                              }]
                            }]
                          });

                        case 10:
                        case "end":
                          return e.stop();
                      }
                    }
                  }, e);
                }));
                return function (t, n) {
                  return e.apply(this, arguments);
                };
              }()), e.next = 8, Promise.all(a);

            case 8:
              return o.children = e.sent, t && i && n.setSelectBankCode(t, i, !0), e.abrupt("return", o);

            case 11:
            case "end":
              return e.stop();
          }
        }
      }, e);
    }))), s(this, "removeLoading", function () {
      var e;
      1 !== (null === (e = n.installmentInfo) || void 0 === e ? void 0 : e.length) && n.container.querySelector(".".concat(ir("loading"))).classList.remove(ir("loading"));
    }), s(this, "handleSelect", function (e) {
      var t = e.target;

      if (!(t.parentNode.getAttribute("class").indexOf("is-disabled") > -1)) {
        var r = t.getAttribute("count"),
            i = t.getAttribute("showVal");
        n.setSelectBankCode(r, i), n.handleToggleBankList(!1);
      }
    }), s(this, "handleToggleBankList", function (e) {
      n.selectListDom.style.maxHeight = e ? "434px" : "0px";
    }), s(this, "setError", function () {
      n.handleToggleErrortip(!0);
    }), s(this, "handleToggleErrortip", function (e) {
      var t = n.selectContentDom.getAttribute("class"),
          r = n.container.querySelector(ir("error-tip"));
      if (e) -1 === t.indexOf(ir("content-error")) && (t += " ".concat(ir("content-error")), n.selectContentDom.setAttribute("class", t)), r.style.height = "19px";else {
        var i = t.replace(" ".concat(ir("content-error")), "");
        n.selectContentDom.setAttribute("class", i), r.style.height = "0px";
      }
    }), s(this, "handleHideSelect", function () {
      document.addEventListener("click", function (e) {
        var t = e.target;
        n.selectContentDom.contains(t) || n.handleToggleBankList(!1);
      });
    }), s(this, "bindClick", function () {
      n.container.querySelector("#select-wrap").addEventListener("click", function () {
        var e = "434px" !== n.selectListDom.style.maxHeight;
        n.handleToggleBankList(e);
      }, !1);
    }), s(this, "create", function () {
      var e = r(v.mark(function e(t) {
        return v.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                n.config = t;

              case 1:
              case "end":
                return e.stop();
            }
          }
        }, e);
      }));
      return function (t) {
        return e.apply(this, arguments);
      };
    }()), this.env = o, this.paymentInitData = a, this.theme = new Rn(a.theme);
  }

  var t;
  return a(e, [{
    key: "setInstallmentInfo",
    value: (t = r(v.mark(function e(t) {
      return v.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              this.installmentInfo = t;

            case 1:
            case "end":
              return e.stop();
          }
        }
      }, e, this);
    })), function (e) {
      return t.apply(this, arguments);
    })
  }, {
    key: "mutationObserver",
    value: function value() {
      var e = this,
          t = this.paymentInitData.needAdaptive,
          n = void 0 === t || t,
          r = "number" == typeof n ? n : 600;
      this.isPc = this.container.offsetWidth >= r;
      var i = null;
      if (!n && 0 !== n) return null;
      window.addEventListener("resize", function () {
        i && (clearTimeout(i), i = null), i = setTimeout(function () {
          var t = getComputedStyle(e.container).getPropertyValue("width").replace("px", "");
          e.needShowPcStyle(Number(t) > r);
        }, 200);
      });
    }
  }, {
    key: "setSelectBankCode",
    value: function value(e, t) {
      var n = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
      this.selectResult = {
        installmentCount: e,
        showInstallmentCount: t,
        isFirst: n
      };
      var r = this.container.querySelector("#select-input");
      r && t && (r.value = t), this.triggerEvent("onChange", this.selectResult);
    }
  }, {
    key: "triggerEvent",
    value: function value(e, t) {
      this.config[e] && this.config[e](t);
    }
  }]), e;
}();

function ar(e, t) {
  (null == t || t > e.length) && (t = e.length);

  for (var n = 0, r = new Array(t); n < t; n++) {
    r[n] = e[n];
  }

  return r;
}

function sr(e, t) {
  if (e) {
    if ("string" == typeof e) return ar(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? ar(e, t) : void 0;
  }
}

function cr(e) {
  return function (e) {
    if (Array.isArray(e)) return ar(e);
  }(e) || function (e) {
    if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
  }(e) || sr(e) || function () {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}

Ae(".payment-sdk-hidden{\n  display: none;\n}\n\n.pci-container .pci-content-select{\n  margin-bottom: 0;\n  margin-bottom: var(--form-item-gutter);\n}\n\n@media (min-width: 640px){\n}\n\n@media (min-width: 768px){\n}\n\n@media (min-width: 1024px){\n}\n\n@media (min-width: 1280px){\n}", {});
var ur = ["fieldName"];

function lr(e, t) {
  var n = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), n.push.apply(n, r);
  }

  return n;
}

function pr(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = null != arguments[t] ? arguments[t] : {};
    t % 2 ? lr(Object(n), !0).forEach(function (t) {
      s(e, t, n[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : lr(Object(n)).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
    });
  }

  return e;
}

function dr(e, t) {
  var _n5 = "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];

  if (!_n5) {
    if (Array.isArray(e) || (_n5 = function (e, t) {
      if (!e) return;
      if ("string" == typeof e) return hr(e, t);
      var n = Object.prototype.toString.call(e).slice(8, -1);
      "Object" === n && e.constructor && (n = e.constructor.name);
      if ("Map" === n || "Set" === n) return Array.from(e);
      if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return hr(e, t);
    }(e)) || t && e && "number" == typeof e.length) {
      _n5 && (e = _n5);

      var r = 0,
          i = function i() {};

      return {
        s: i,
        n: function n() {
          return r >= e.length ? {
            done: !0
          } : {
            done: !1,
            value: e[r++]
          };
        },
        e: function e(_e8) {
          throw _e8;
        },
        f: i
      };
    }

    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  var o,
      a = !0,
      s = !1;
  return {
    s: function s() {
      _n5 = _n5.call(e);
    },
    n: function n() {
      var e = _n5.next();

      return a = e.done, e;
    },
    e: function e(_e9) {
      s = !0, o = _e9;
    },
    f: function f() {
      try {
        a || null == _n5["return"] || _n5["return"]();
      } finally {
        if (s) throw o;
      }
    }
  };
}

function hr(e, t) {
  (null == t || t > e.length) && (t = e.length);

  for (var n = 0, r = new Array(t); n < t; n++) {
    r[n] = e[n];
  }

  return r;
}

var fr = function () {
  function e(t, n) {
    var o = this;
    i(this, e), s(this, "env", void 0), s(this, "paymentMethod", void 0), s(this, "channelId", void 0), s(this, "i18n", void 0), s(this, "hasTipsArray", void 0), s(this, "pciSdk", void 0), s(this, "theme", void 0), s(this, "validateResult", {}), s(this, "cardBrand", void 0), s(this, "isSupportCardBrand", void 0), s(this, "memoryResolve", void 0), s(this, "paymentInitData", void 0), s(this, "isPc", void 0), s(this, "container", void 0), s(this, "uuid", void 0), s(this, "isGetCardBrandAndVerifyIng", !1), s(this, "isInstallment", !0), s(this, "cardBinRequestParams", void 0), s(this, "cardBinVerifyResult", void 0), s(this, "reporter", void 0), s(this, "needShowPcStyle", function (e) {
      o.isPc = e;
      var t = o.container.querySelector("#pci-container");

      if (t) {
        var n = t.getAttribute("class");
        n = n.replace(/(\s*pci-mobile-style)|(\s*pci-pc-style)/g, ""), n += " ".concat(e ? "pci-pc-style" : "pci-mobile-style"), t.setAttribute("class", n);
        ["number", "firstName", "expDate", "cvc"].forEach(function (e) {
          var t,
              n = null === (t = o.container) || void 0 === t ? void 0 : t.querySelector("#pci-".concat(e, "-error"));

          if (n) {
            var r = null == n ? void 0 : n.textContent,
                i = null == n ? void 0 : n.parentElement;
            r && i && (i.style.height = "".concat(n.offsetHeight, "px"));
          }
        });
      }
    }), s(this, "createErrorDom", function (e) {
      return {
        content: "div",
        props: {
          "class": "pci-error-tip pci-input-tip"
        },
        children: {
          content: "div",
          props: {
            id: "pci-".concat(e, "-error")
          }
        }
      };
    }), s(this, "insertLanguage", function () {
      var e = r(v.mark(function e(t, n) {
        var r, i, a, s, c, u, l, p, d, h, f, m;
        return v.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                o.i18n = t, o.hasTipsArray = [], r = n.showFirstName, i = y.filter(function (e) {
                  return r || "firstName" !== e;
                }), a = dr(i), e.prev = 5, a.s();

              case 7:
                if ((s = a.n()).done) {
                  e.next = 26;
                  break;
                }

                return c = s.value, u = o.container.querySelector("#pci-input-".concat(c, "-label")), l = o.container.querySelector("#pci-input-".concat(c, "-container")), e.next = 13, t.get("formItems.".concat(c, ".labelTitle"));

              case 13:
                return u.textContent = e.sent, e.next = 16, t.get("formItems.".concat(c, ".tips"));

              case 16:
                if ((p = e.sent) && o.hasTipsArray.push({
                  key: c,
                  content: p
                }), o.validateResult[c] = {
                  isValid: !1,
                  isEmpty: !0
                }, p && Be(o.createTooltipDom(c), l), "firstName" !== c) {
                  e.next = 24;
                  break;
                }

                return e.next = 23, t.get("pleaseEnterNameOnCardOrBusinessName");

              case 23:
                o.container.querySelector("#pci-input-name-tip").textContent = e.sent;

              case 24:
                e.next = 7;
                break;

              case 26:
                e.next = 31;
                break;

              case 28:
                e.prev = 28, e.t0 = e["catch"](5), a.e(e.t0);

              case 31:
                return e.prev = 31, a.f(), e.finish(31);

              case 34:
                return o.hasTipsArray.length > 0 && (d = new He(), o.hasTipsArray.forEach(function (e) {
                  var t = o.container.querySelector("#pci-".concat(e.key, "-icon"));
                  d.mount(t, e.content);
                })), e.next = 37, o.getFooterTips(n);

              case 37:
                return h = e.sent, f = new Sn(), h && (null === (m = o.container.querySelector(".pci-footer-tips")) || void 0 === m || m.appendChild(f.autoParseToDom(h))), o.pciSdk.mount(".pci-content-form-".concat(o.uuid)), e.abrupt("return", new Promise(function (e) {
                  o.memoryResolve = e;
                }));

              case 42:
              case "end":
                return e.stop();
            }
          }
        }, e, null, [[5, 28, 31, 34]]);
      }));
      return function (t, n) {
        return e.apply(this, arguments);
      };
    }()), s(this, "handleFocusInput", function () {
      var e = r(v.mark(function e(t) {
        var n, r, i, a, s, c, u, l, p, d, h, f, y;
        return v.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                if (n = t.fieldName, r = t.isEmpty, i = t.isFocus, a = t.isValid, s = o.container.querySelector("#pci-input-".concat(n, "-content")).parentElement, c = s.getAttribute("class"), u = !1, o.validateResult[n].isValid = a, o.validateResult[n].isEmpty = r, r && !i || c.includes("pci-input-box-not-empty") ? !i && r && c.includes("pci-input-box-not-empty") && (c = c.replace(" pci-input-box-not-empty", "")) : c += " pci-input-box-not-empty", i ? (o.checkAllInputClass(), c.includes("pci-input-box-focus") || (c += " pci-input-box-focus"), o.setError(n, ""), u = !0) : (u = !1, c = c.replace(" pci-input-box-focus", "")), "firstName" === n && o.handleShowOrHideDom({
                  id: "pci-input-name-tip",
                  type: "tip",
                  className: "pci-input-tip-show",
                  show: u
                }), l = "", i || r) {
                  e.next = 32;
                  break;
                }

                if (p = o.validateResult[n].isValid, d = !1, !p) {
                  e.next = 28;
                  break;
                }

                if (d = !0, !1 !== o.isSupportCardBrand || "number" !== n) {
                  e.next = 26;
                  break;
                }

                return d = !1, y = null === (h = o.cardBinVerifyResult) || void 0 === h || null === (f = h.verifyResult) || void 0 === f ? void 0 : f.errorCode, e.next = 20, o.i18n.get("validator.".concat(y));

              case 20:
                if (e.t0 = e.sent, e.t0) {
                  e.next = 25;
                  break;
                }

                return e.next = 24, o.i18n.get("cardIsNotSupported");

              case 24:
                e.t0 = e.sent;

              case 25:
                l = e.t0;

              case 26:
                e.next = 31;
                break;

              case 28:
                return e.next = 30, o.i18n.get("formItems.".concat(n, ".errorTips"));

              case 30:
                l = e.sent;

              case 31:
                d ? o.setError(n, "") : o.setError(n, l);

              case 32:
                s.setAttribute("class", c);

              case 33:
              case "end":
                return e.stop();
            }
          }
        }, e);
      }));
      return function (t) {
        return e.apply(this, arguments);
      };
    }()), s(this, "handleShowOrHideDom", function (e) {
      var t = e.id,
          n = e.className,
          r = e.type,
          i = e.content,
          a = e.show,
          s = o.container.querySelector("#".concat(t));
      if (!s) return null;
      var c = s.parentElement,
          u = c.parentElement,
          l = c.getAttribute("class"),
          p = u.getAttribute("class");
      "error" === r && (s.textContent = i), !i && !0 !== a || l.includes("".concat(n)) ? "" !== i && !1 !== a || !l.includes("".concat(n)) || (c.style.height = "0px", l = l.replace(" ".concat(n), ""), "error" === r && (p = p.replace(" pci-input-valid-error-box", ""))) : (l += " ".concat(n), c.style.height = "".concat(s.offsetHeight, "px"), "error" === r && (p += " pci-input-valid-error-box")), c.setAttribute("class", l), "error" === r && u.setAttribute("class", p);
    }), s(this, "onCardBinChange", function () {
      var e = r(v.mark(function e(t) {
        var n, r, i, a;
        return v.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                if (o.isGetCardBrandAndVerifyIng = !1, o.cardBinVerifyResult = t, n = t.binInfo, null != (r = t.verifyResult) && r.result ? o.isSupportCardBrand = !0 : o.isSupportCardBrand = !1, n.brand && "Other" !== n.brand ? (o.cardBrand = n.brand, o.setBrandIcon(o.cardBrand)) : (o.cardBrand = "", o.setBrandIcon(void 0)), null != r && r.result || null == r || !r.errorCode) {
                  e.next = 18;
                  break;
                }

                return i = r.errorCode, e.next = 9, o.i18n.get("validator.".concat(i));

              case 9:
                if (e.t0 = e.sent, e.t0) {
                  e.next = 14;
                  break;
                }

                return e.next = 13, o.i18n.get("cardIsNotSupported");

              case 13:
                e.t0 = e.sent;

              case 14:
                a = e.t0, o.setError("number", a), e.next = 19;
                break;

              case 18:
                o.setError("number", "");

              case 19:
              case "end":
                return e.stop();
            }
          }
        }, e);
      }));
      return function (t) {
        return e.apply(this, arguments);
      };
    }()), s(this, "onFieldValidChange", function (e) {
      var t = e.fieldName,
          n = m(e, ur);
      o.validateResult[t] = pr(pr({}, o.validateResult[t]), n), e.isEmpty && o.setError(t, "");
    }), s(this, "pciSdkInit", function () {
      o.memoryResolve(!0);
    }), s(this, "removeLoading", r(v.mark(function e() {
      var t, n, r, i, a, s, c, u;
      return v.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              t = o.container.querySelector("#pci-content-form"), n = t.getAttribute("class").replace(" pci-content-loading", ""), t.setAttribute("class", n), r = o.container.querySelector(".pci-footer"), i = r.getAttribute("class").replace(" pci-footer-loading", ""), r.setAttribute("class", i), a = {
                padding: "20px 0 0 16px",
                color: o.theme.getCreditCardThemeValue("inputFontColor")
              }, s = o.theme.handleDefaultThemeValidate(), c = o.theme.getDefaultFontLib("fontLib"), u = o.theme.getDefaultFontFamily("fontFamily"), s ? (a.fontLib = c, a.fontFamily = u) : (o.reporter.reportErrorData("installment_pci_form_setStyle_font_error", {
                fontLib: c,
                fontFamily: u
              }), console.warn("请检查 initTheme.fontLib 或者 initTheme.fontFamily 传值是否有误")), ["number", "firstName", "expDate", "cvc"].forEach(function (e) {
                o.pciSdk.setStyle({
                  style: a,
                  type: "base",
                  fieldName: e
                });
              }), console.log("pciSdk Init 完成");

            case 14:
            case "end":
              return e.stop();
          }
        }
      }, e);
    }))), s(this, "getValidateResult", r(v.mark(function e() {
      return v.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.abrupt("return", o.validateResult);

            case 1:
            case "end":
              return e.stop();
          }
        }
      }, e);
    }))), s(this, "setCardBinParams", function () {
      var e = r(v.mark(function e(t) {
        return v.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return o.cardBinRequestParams = t, e.abrupt("return", o.pciSdk.setCardBinOptions({
                  requestParams: t
                }));

              case 2:
              case "end":
                return e.stop();
            }
          }
        }, e);
      }));
      return function (t) {
        return e.apply(this, arguments);
      };
    }()), s(this, "getCardBinVerifyResult", r(v.mark(function e() {
      var t;
      return v.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return o.isGetCardBrandAndVerifyIng = !0, e.next = 3, o.pciSdk.getCardBinVerifyResult()["catch"](function (e) {
                return o.reporter.handleError(e, "installment_pci_getCardBinVerifyResult_error");
              });

            case 3:
              if (t = e.sent, o.cardBinVerifyResult = t, t) {
                e.next = 7;
                break;
              }

              return e.abrupt("return");

            case 7:
              if (o.isGetCardBrandAndVerifyIng) {
                e.next = 9;
                break;
              }

              return e.abrupt("return");

            case 9:
              return o.isGetCardBrandAndVerifyIng = !1, e.next = 12, o.onCardBinChange(t);

            case 12:
              return e.abrupt("return", e.sent);

            case 13:
            case "end":
              return e.stop();
          }
        }
      }, e);
    }))), this.env = t, this.paymentInitData = n, this.reporter = new me(n), this.paymentMethod = n.paymentMethod, this.channelId = n.channelId, this.uuid = nt(), this.pciSdk = new mn({
      host: n.host
    }), this.theme = new Rn(n.theme), this.pciSdk.create({
      placeholder: {},
      onInit: this.pciSdkInit,
      onFocus: this.handleFocusInput,
      onFieldValidChange: this.onFieldValidChange,
      onCardBinChange: this.onCardBinChange,
      extraConfig: {
        cardBinSwitch: this.isInstallment
      }
    });
  }

  var t, n, o, c, u;
  return a(e, [{
    key: "render",
    value: (u = r(v.mark(function e(t) {
      var n;
      return v.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              this.container = t, t.setAttribute("ontouchstart", ""), this.mutationObserver(), n = this.theme.getCreditCardStyle(), Be({
                content: "div",
                props: {
                  id: "pci-container",
                  "class": "pci-container ".concat(this.isPc ? "pci-pc-style" : "pci-mobile-style"),
                  style: Fn ? n : void 0,
                  "ie-style": Fn ? void 0 : n
                },
                children: [{
                  content: "div",
                  props: {
                    "class": "pci-content"
                  },
                  children: {
                    content: "div",
                    props: {
                      "class": "pci-content-form pci-content-loading pci-content-form-".concat(this.uuid),
                      id: "pci-content-form"
                    },
                    children: [{
                      content: "div",
                      props: {
                        id: "pci-content-header",
                        "class": "pci-content-header"
                      }
                    }, {
                      content: "div",
                      props: {
                        id: "pci-content-select",
                        "class": "pci-content-select"
                      }
                    }].concat(cr(this.createFormItemsDom()))
                  }
                }, {
                  content: "div",
                  props: {
                    "class": "pci-footer pci-footer-loading",
                    id: "pci-footer"
                  },
                  children: [this.createIconDom("footer", "pci-footer-icon"), {
                    content: "div",
                    props: {
                      "class": "pci-footer-tips"
                    }
                  }]
                }]
              }, t);

            case 6:
            case "end":
              return e.stop();
          }
        }
      }, e, this);
    })), function (e) {
      return u.apply(this, arguments);
    })
  }, {
    key: "mutationObserver",
    value: function value() {
      var e = this,
          t = this.paymentInitData.needAdaptive,
          n = void 0 === t || t,
          r = "number" == typeof n ? n : 600;
      this.isPc = this.container.offsetWidth >= r;
      var i = null;
      if (!n && 0 !== n) return null;
      window.addEventListener("resize", function () {
        i && (clearTimeout(i), i = null), i = setTimeout(function () {
          var t = getComputedStyle(e.container).getPropertyValue("width").replace("px", "");
          e.needShowPcStyle(Number(t) > r);
        }, 200);
      });
    }
  }, {
    key: "createFormItemsDom",
    value: function value() {
      var e = Ln(this.paymentInitData),
          t = this.createFormItem("number"),
          n = e ? this.createFormItem("firstName") : null,
          r = this.createFormItem("expDate"),
          i = this.createFormItem("cvc"),
          o = [t, n, {
        content: "div",
        props: {
          "class": "".concat(e ? "pci-dateAndCvc-box" : "")
        },
        children: [r, i]
      }];
      return e || o.splice(1, 1), o;
    }
  }, {
    key: "createFormItem",
    value: function value(e) {
      var t = {
        content: "div",
        props: {
          "class": "pci-input-container",
          id: "pci-input-".concat(e, "-container")
        },
        children: [{
          content: "div",
          props: {
            "class": "pci-input-box"
          },
          children: [{
            content: "label",
            props: {
              "class": "pci-input-label",
              id: "pci-input-".concat(e, "-label")
            }
          }, {
            content: "div",
            props: {
              "data-pci": e,
              "class": "pci-input-content",
              id: "pci-input-".concat(e, "-content")
            }
          }]
        }]
      };

      if ("firstName" === e) {
        var n = this.createNameEnterTipDom();
        t.children.push(n);
      }

      var r = this.createErrorDom(e);
      return t.children.push(r), t;
    }
  }, {
    key: "createNameEnterTipDom",
    value: function value() {
      return {
        content: "div",
        props: {
          "class": "pci-input-tip"
        },
        children: {
          content: "div",
          props: {
            id: "pci-input-name-tip"
          }
        }
      };
    }
  }, {
    key: "createIconDom",
    value: function value(e, t) {
      var n = this.theme.getInputIcon(e),
          r = n.imgSrc,
          i = n.svg;
      return r ? {
        content: "img",
        props: {
          "class": t,
          src: r
        }
      } : i ? {
        content: "div",
        props: {
          "class": t,
          innerHTML: i
        }
      } : null;
    }
  }, {
    key: "getFooterTips",
    value: (c = r(v.mark(function e(t) {
      var n, r;
      return v.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              if ("SLPayments" !== this.channelId) {
                e.next = 18;
                break;
              }

              return e.next = 3, this.i18n.get("slPaymentsCountryFooter.".concat(t.merchantCountry));

            case 3:
              if (!(r = e.sent)) {
                e.next = 8;
                break;
              }

              n = r, e.next = 16;
              break;

            case 8:
              return e.next = 10, this.i18n.get("SLPaymentsFooter");

            case 10:
              if (e.t0 = e.sent, e.t0) {
                e.next = 15;
                break;
              }

              return e.next = 14, this.i18n.get("footer");

            case 14:
              e.t0 = e.sent;

            case 15:
              n = e.t0;

            case 16:
              e.next = 21;
              break;

            case 18:
              return e.next = 20, this.i18n.get("footer");

            case 20:
              n = e.sent;

            case 21:
              return e.t1 = "", e.next = 24, this.i18n.get("content.creditCard.serviceTips");

            case 24:
              if (e.t2 = e.sent, e.t2) {
                e.next = 27;
                break;
              }

              e.t2 = "";

            case 27:
              return e.t3 = e.t2, e.abrupt("return", e.t1.concat.call(e.t1, e.t3).concat(n || ""));

            case 29:
            case "end":
              return e.stop();
          }
        }
      }, e, this);
    })), function (e) {
      return c.apply(this, arguments);
    })
  }, {
    key: "createTooltipDom",
    value: function value(e) {
      var t = this.createIconDom(e, "pci-tip-icon");
      return {
        content: "div",
        props: {
          id: "pci-".concat(e, "-icon"),
          "class": "pci-icon pci-".concat(e, "-icon")
        },
        children: [t, {
          content: "img",
          props: {
            "class": "pci-brand-icon payment-sdk-hidden"
          }
        }]
      };
    }
  }, {
    key: "setError",
    value: function value(e, t) {
      var n = "pci-".concat(e, "-error");
      this.handleShowOrHideDom({
        id: n,
        type: "error",
        className: "pci-input-tip-show",
        content: t
      });
    }
  }, {
    key: "checkAllInputClass",
    value: function value() {
      var e = this,
          t = this.container.querySelectorAll(".pci-input-box-focus");
      [].slice.call(t).forEach(function (e) {
        e.classList.remove("pci-input-box-focus");
      }), Object.keys(this.validateResult).forEach(function (t) {
        e.validateResult[t].isEmpty && e.container.querySelector("#pci-input-".concat(t, "-content")).parentElement.classList.remove("pci-input-box-not-empty");
      });
    }
  }, {
    key: "validate",
    value: (o = r(v.mark(function e() {
      var t,
          n,
          r,
          i,
          o,
          a,
          s,
          c,
          u,
          l,
          p,
          d,
          h,
          f = this;
      return v.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              t = !0, n = Object.keys(this.validateResult), r = 0, i = n;

            case 3:
              if (!(r < i.length)) {
                e.next = 16;
                break;
              }

              if (o = i[r], a = this.validateResult[o], s = "", !a.isEmpty && a.isValid) {
                e.next = 12;
                break;
              }

              return e.next = 10, this.i18n.get("formItems.".concat(o, ".errorTips"));

            case 10:
              s = e.sent, t = !1;

            case 12:
              this.setError(o, s);

            case 13:
              r++, e.next = 3;
              break;

            case 16:
              if (this.cardBrand) {
                e.next = 23;
                break;
              }

              return e.next = 19, this.pciSdk.getCardBinVerifyResult()["catch"](function (e) {
                return f.reporter.handleError(e, "installment_pci_sdk_getCardBrand_error");
              });

            case 19:
              c = e.sent, this.cardBinVerifyResult = c, null != (u = c.verifyResult) && u.result ? this.isSupportCardBrand = !0 : this.isSupportCardBrand = !1;

            case 23:
              if (!1 !== this.isSupportCardBrand) {
                e.next = 36;
                break;
              }

              return t = !1, d = null === (l = this.cardBinVerifyResult) || void 0 === l || null === (p = l.verifyResult) || void 0 === p ? void 0 : p.errorCode, e.next = 28, this.i18n.get("validator.".concat(d));

            case 28:
              if (e.t0 = e.sent, e.t0) {
                e.next = 33;
                break;
              }

              return e.next = 32, this.i18n.get("cardIsNotSupported");

            case 32:
              e.t0 = e.sent;

            case 33:
              h = e.t0, this.setError("number", h), this.reporter.reportData("installment_validate_card", {
                validateState: "installment_".concat(t, "_").concat(this.cardBrand)
              });

            case 36:
              if (!t) {
                e.next = 40;
                break;
              }

              return e.next = 39, this.pciSdk.validate()["catch"](function (e) {
                return f.reporter.handleError(e, "installment_pci_validate_error");
              });

            case 39:
              t = e.sent;

            case 40:
              return e.abrupt("return", t);

            case 41:
            case "end":
              return e.stop();
          }
        }
      }, e, this);
    })), function () {
      return o.apply(this, arguments);
    })
  }, {
    key: "pay",
    value: (n = r(v.mark(function e(t, n) {
      var r,
          i,
          o = this;
      return v.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.prev = 0, r = tt(this.channelId, {}, {
                isInstallment: this.isInstallment,
                installmentCount: this.cardBinRequestParams.installmentCount
              }), e.next = 4, this.pciSdk.pay(t, pr({
                paymentMethod: this.paymentMethod
              }, r))["catch"](function (e) {
                return 400 === e.statusCode && o.getErrorFromServer(e.data), o.reporter.handleError(e, "installment_pci_pay_error", {
                  request: {
                    params: {
                      nextAction: t,
                      extraParams: r
                    },
                    response: {
                      error: e
                    }
                  }
                });
              });

            case 4:
              return i = e.sent, e.abrupt("return", Ke(i, n));

            case 8:
              e.prev = 8, e.t0 = e["catch"](0), this.reporter.handleError(e.t0);

            case 11:
            case "end":
              return e.stop();
          }
        }
      }, e, this, [[0, 8]]);
    })), function (e, t) {
      return n.apply(this, arguments);
    })
  }, {
    key: "getErrorFromServer",
    value: (t = r(v.mark(function e(t) {
      var n, r;
      return v.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              n = "", r = "", e.t0 = t.code, e.next = "4455" === e.t0 ? 5 : "3001" === e.t0 ? 10 : "4459" === e.t0 ? 15 : "4453" === e.t0 ? 20 : 25;
              break;

            case 5:
              return n = "number", e.next = 8, this.i18n.get("pleaseEnterValidCardNumber");

            case 8:
              return r = e.sent, e.abrupt("break", 25);

            case 10:
              return n = "number", e.next = 13, this.i18n.get("pleaseChangeAnotherCard");

            case 13:
              return r = e.sent, e.abrupt("break", 25);

            case 15:
              return n = "expDate", e.next = 18, this.i18n.get("pleaseEnterExpired");

            case 18:
              return r = e.sent, e.abrupt("break", 25);

            case 20:
              return n = "cvc", e.next = 23, this.i18n.get("pleaseEnterCVV");

            case 23:
              return r = e.sent, e.abrupt("break", 25);

            case 25:
              r && (this.setError(n, r), this.validateResult[n].isValid = !1);

            case 26:
            case "end":
              return e.stop();
          }
        }
      }, e, this);
    })), function (e) {
      return t.apply(this, arguments);
    })
  }, {
    key: "setBrandIcon",
    value: function value(e) {
      var t = this.container.querySelector("#pci-number-icon"),
          n = t.querySelector(".pci-tip-icon"),
          r = t.querySelector(".pci-brand-icon"),
          i = t.querySelector(".pci-tooltip-wrap");

      if (r.onerror = function () {
        r.style.display = "none";
      }, r.onload = function () {
        r.style.display = "block";
      }, e) {
        var o = "".concat(this.env.host, "/payment-sdk/assets/image/").concat(encodeURIComponent(e), ".png");
        r.setAttribute("src", o), r.classList.remove("payment-sdk-hidden"), n.classList.add("payment-sdk-hidden"), i.classList.add("payment-sdk-hidden");
      } else r.classList.add("payment-sdk-hidden"), n.classList.remove("payment-sdk-hidden"), i.classList.remove("payment-sdk-hidden"), r.setAttribute("src", "");
    }
  }]), e;
}();

function vr(e, t) {
  return function (e) {
    if (Array.isArray(e)) return e;
  }(e) || function (e, t) {
    var n = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];

    if (null != n) {
      var r,
          i,
          o = [],
          a = !0,
          s = !1;

      try {
        for (n = n.call(e); !(a = (r = n.next()).done) && (o.push(r.value), !t || o.length !== t); a = !0) {
          ;
        }
      } catch (e) {
        s = !0, i = e;
      } finally {
        try {
          a || null == n["return"] || n["return"]();
        } finally {
          if (s) throw i;
        }
      }

      return o;
    }
  }(e, t) || sr(e, t) || function () {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}

Ae(".payment-sdk-installment-header_container{\n  display: block;\n  width: 100%;\n}\n\n.payment-sdk-installment-header_container svg{\n  vertical-align: baseline;\n}\n\n.payment-sdk-installment-header_content{\n  display: flex;\n  width: 100%;\n  margin: 16px 0 12px;\n  font-size: 14px;\n  line-height: 1.42;\n  color: rgba(44, 44, 44, 0.75);\n}\n\n.payment-sdk-installment-header_content-loading{\n  background-color: var(--input-font-color);\n  opacity: 0.05;\n  border-radius: 4px;\n}\n\n.payment-sdk-installment-header_content-hd{\n  flex: 1;\n}\n\n.payment-sdk-installment-header_content-hd{\n  display: flex;\n}\n\n/* 请选择分期期数tip */\n\n.payment-sdk-installment-header_content-hd-tip strong{\n  color: #2c2c2c;\n  font-weight: bold;\n}\n\n.payment-sdk-installment-header_content-hd-icon{\n  display: inline-block;\n  position: relative;\n  top: 3px;\n}\n\n.payment-sdk-installment-header_content-hd-icon .pci-tooltip-content{\n  width: 290px;\n  height: auto;\n  box-sizing: border-box;\n  left: -100px;\n  bottom: 30px;\n}\n\n.payment-sdk-installment-header_content-hd-icon .pci-tooltip-wrap::after{\n  top: auto;\n  bottom: 18px;\n}\n\n.payment-sdk-installment-header_lf-tip-line{\n  font-size: 12px;\n  line-height: 1.5;\n}\n\n/* 右边提示 */\n\n.payment-sdk-installment-header_content-bd{\n  display: flex;\n}\n\n.payment-sdk-installment-header_content-bd-icon{\n  position: relative;\n  padding: 1px 2px 0 2px;\n}\n\n.payment-sdk-installment-header_content-bd-icon .pci-tooltip-content{\n  right: -8px;\n  top: 30px;\n  bottom: auto;\n  left: auto;\n  z-index: 2044;\n  width: auto;\n  height: auto;\n  padding: 16px 0;\n  min-width: 375px;\n  max-width: 440px;\n  max-height: 270px;\n  overflow: hidden;\n  box-sizing: border-box;\n  background: #fff;\n  color: #474F5E;\n  box-shadow: 0 0 15px rgba(0,0,0,0.22);\n}\n\n.payment-sdk-installment-header_lr-tip{\n  padding: 0 20px 20px;\n  height: 228px;\n  overflow: auto;\n  -webkit-overflow-scrolling:touch;\n}\n\n.payment-sdk-installment-header_content-bd-icon .pci-tooltip-wrap::after{\n  top: 26px;\n  left: 3px;\n  z-index: 2044;\n  border: none;\n  width: 14px;\n  height: 14px;\n  background: #fff;\n  transform: rotate(45deg);\n}\n\n.payment-sdk-installment-header_lr-tip-content-title{\n  width: 100%;\n  text-align: center;\n  font-size: 14px;\n  line-height: 1.42;\n  color: #242833;\n}\n\n.payment-sdk-installment-header_lr-tip-content-title-sm{\n  width: 100%;\n  padding: 2px 0 8px;\n  text-align: center;\n  font-size: 12px;\n  line-height: 1.33;\n  color: #7a8499;\n}\n\n.payment-sdk-installment-header_lr-tip-content-bd div{\n  line-height: 1.33;\n}\n\n.payment-sdk-installment-header_lr-tip-content-bd p{\n  font-size: 12px;\n  line-height: 1.33;\n  color: #474f5e;\n}\n\n.payment-sdk-installment-header_lr-tip-content-bd pre{\n  white-space: break-spaces;\n  padding: 0;\n  background: none;\n  border: none;\n  color: #474f5e;\n}\n\n/* 手机适配 */\n\n.payment-sdk-installment-header_content--sm{\n  display: block;\n}\n\n.payment-sdk-installment-header_content-bd-icon--sm .pci-tooltip-content{\n  left: 0;\n  right: 0;\n  padding: 12px;\n}", {});

var yr,
    mr,
    gr = tr("payment-sdk-installment-header"),
    br = new He(),
    kr = function () {
  function e(t) {
    var n = this,
        o = t.env,
        a = t.dataSource;
    i(this, e), s(this, "env", void 0), s(this, "paymentInitData", void 0), s(this, "container", void 0), s(this, "outerContainer", void 0), s(this, "theme", void 0), s(this, "installmentInfo", void 0), s(this, "i18n", void 0), s(this, "isZeroCount", !1), s(this, "setOuterContainer", function () {
      var e = r(v.mark(function e(t) {
        return v.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                n.outerContainer = t;

              case 1:
              case "end":
                return e.stop();
            }
          }
        }, e);
      }));
      return function (t) {
        return e.apply(this, arguments);
      };
    }()), s(this, "mount", function () {
      var e = r(v.mark(function e(t) {
        var r;
        return v.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                if (n.container = t, !n.isZeroCount) {
                  e.next = 3;
                  break;
                }

                return e.abrupt("return", null);

              case 3:
                r = n.theme.getCreditCardStyle(), Be({
                  content: "div",
                  props: {
                    "class": "".concat(gr("container"))
                  },
                  children: [{
                    content: "div",
                    props: {
                      "class": "".concat(gr("content"), " ").concat(gr("content-loading")),
                      id: "content",
                      style: Fn ? r : void 0,
                      "ie-style": Fn ? void 0 : r
                    },
                    children: [{
                      content: "div",
                      props: {
                        "class": "".concat(gr("content-hd"))
                      },
                      children: [{
                        content: "div",
                        props: {
                          "class": "".concat(gr("content-hd-tip")),
                          id: "content-hd-tip"
                        },
                        children: [{
                          content: "div",
                          props: {
                            id: "content-hd-icon",
                            "class": "".concat(gr("content-hd-icon")),
                            innerHTML: '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">\n<path fill-rule="evenodd" clip-rule="evenodd" d="M13.6 8C13.6 11.0928 11.0928 13.6 8 13.6C4.90721 13.6 2.4 11.0928 2.4 8C2.4 4.90721 4.90721 2.4 8 2.4C11.0928 2.4 13.6 4.90721 13.6 8ZM15 8C15 11.866 11.866 15 8 15C4.13401 15 1 11.866 1 8C1 4.13401 4.13401 1 8 1C11.866 1 15 4.13401 15 8ZM9.45298 7.94043C8.86649 8.2889 8.60666 8.62269 8.59923 9.33797C8.59563 9.68549 8.31985 9.94303 7.89582 9.94303C7.49737 9.94303 7.1924 9.68549 7.1924 9.33797C7.19612 8.05414 7.54504 7.66166 8.16865 7.27285C8.62522 6.98674 8.97785 6.66762 8.97785 6.1871C8.97785 5.67724 8.57325 5.34712 8.07214 5.34712C7.58587 5.34712 7.15624 5.63856 7.11445 6.26413C7.0902 6.62714 6.78059 6.98126 6.35721 6.98126C5.93369 6.98126 5.59998 6.61104 5.59998 6.26413C5.59998 4.80823 6.73212 4.09998 8.07956 4.09998C9.55321 4.09998 10.6 4.84826 10.6 6.13208C10.6 6.99407 10.1471 7.53328 9.45298 7.94043ZM7.92373 12.4033C8.39886 12.4033 8.81089 12.0109 8.8146 11.523C8.81089 11.0425 8.39886 10.65 7.92373 10.65C7.43375 10.65 7.02915 11.0425 7.03286 11.523C7.02915 12.0109 7.43375 12.4033 7.92373 12.4033Z" fill="#2C2C2C" fill-opacity="0.45"/>\n</svg>\n'
                          }
                        }]
                      }]
                    }, {
                      content: "div",
                      props: {
                        "class": "".concat(gr("content-bd"))
                      },
                      children: [{
                        content: "div",
                        props: {
                          "class": "".concat(gr("content-bd-text")),
                          id: "content-bd-text"
                        },
                        children: ""
                      }, {
                        content: "div",
                        props: {
                          id: "content-bd-icon",
                          "class": "".concat(gr("content-bd-icon")),
                          innerHTML: '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">\n<path fill-rule="evenodd" clip-rule="evenodd" d="M13.6 8C13.6 11.0928 11.0928 13.6 8 13.6C4.90721 13.6 2.4 11.0928 2.4 8C2.4 4.90721 4.90721 2.4 8 2.4C11.0928 2.4 13.6 4.90721 13.6 8ZM15 8C15 11.866 11.866 15 8 15C4.13401 15 1 11.866 1 8C1 4.13401 4.13401 1 8 1C11.866 1 15 4.13401 15 8ZM8.00005 4C8.44188 4 8.80005 4.35817 8.80005 4.8V9C8.80005 9.44183 8.44188 9.8 8.00005 9.8C7.55822 9.8 7.20005 9.44183 7.20005 9V4.8C7.20005 4.35817 7.55822 4 8.00005 4ZM7.99999 12.45C8.47998 12.45 8.89623 12.0471 8.89998 11.5463C8.89623 11.053 8.47998 10.65 7.99999 10.65C7.505 10.65 7.09625 11.053 7.1 11.5463C7.09625 12.0471 7.505 12.45 7.99999 12.45Z" fill="#2C2C2C" fill-opacity="0.45"/>\n</svg>\n'
                        }
                      }]
                    }]
                  }]
                }, t), n.createInstallmentTip(), n.createBankTip();

              case 8:
              case "end":
                return e.stop();
            }
          }
        }, e);
      }));
      return function (t) {
        return e.apply(this, arguments);
      };
    }()), s(this, "createInstallmentTip", r(v.mark(function e() {
      var t, r;
      return v.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              t = n.container.querySelector("#content-hd-icon"), r = {
                content: "div",
                props: {
                  "class": "".concat(gr("lf-tip"))
                },
                children: [{
                  content: "div",
                  props: {
                    "class": "".concat(gr("lf-tip-content"))
                  },
                  children: [{
                    content: "div",
                    props: {
                      "class": "".concat(gr("lf-tip-line"))
                    },
                    children: ""
                  }, {
                    content: "div",
                    props: {
                      "class": "".concat(gr("lf-tip-line"))
                    },
                    children: ""
                  }, {
                    content: "div",
                    props: {
                      "class": "".concat(gr("lf-tip-line"))
                    },
                    children: ""
                  }]
                }]
              }, br.mount(t, r);

            case 3:
            case "end":
              return e.stop();
          }
        }
      }, e);
    }))), s(this, "createBankTip", r(v.mark(function e() {
      var t, r;
      return v.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              t = n.container.querySelector("#content-bd-icon"), r = {
                content: "div",
                props: {
                  "class": "".concat(gr("lr-tip"))
                },
                children: [{
                  content: "div",
                  props: {
                    "class": "".concat(gr("lr-tip-content"))
                  },
                  children: [{
                    content: "div",
                    props: {
                      "class": "".concat(gr("lr-tip-content-title")),
                      id: "lr-tip-content-title"
                    },
                    children: ""
                  }, {
                    content: "div",
                    props: {
                      "class": "".concat(gr("lr-tip-content-title-sm")),
                      id: "lr-tip-content-title-sm"
                    },
                    children: ""
                  }, {
                    content: "div",
                    props: {
                      "class": "".concat(gr("lr-tip-content-bd")),
                      id: "lr-tip-content-bd"
                    },
                    children: ""
                  }]
                }]
              }, br.mount(t, r);

            case 3:
            case "end":
              return e.stop();
          }
        }
      }, e);
    }))), s(this, "insertLanguage", function () {
      var e = r(v.mark(function e(t) {
        return v.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                if (n.i18n = t, !n.isZeroCount) {
                  e.next = 3;
                  break;
                }

                return e.abrupt("return", null);

              case 3:
                return e.next = 5, n.insertInstallmentTip();

              case 5:
                return e.next = 7, n.setContentHdTip();

              case 7:
                return e.next = 9, n.setBankTip();

              case 9:
                return e.next = 11, n.calcPostion();

              case 11:
              case "end":
                return e.stop();
            }
          }
        }, e);
      }));
      return function (t) {
        return e.apply(this, arguments);
      };
    }()), s(this, "insertInstallmentTip", r(v.mark(function e() {
      var t;
      return v.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.next = 2, n.i18n.get(["installmentDesc1", "installmentDesc2", "installmentDesc3"]);

            case 2:
              t = e.sent, n.container.querySelectorAll(".".concat(gr("lf-tip-line"))).forEach(function (e, n) {
                e.innerText = t[n];
              });

            case 5:
            case "end":
              return e.stop();
          }
        }
      }, e);
    }))), s(this, "setContentHdTip", r(v.mark(function e() {
      var t, r, i, o, a, s, c, u, l, p, d, h, f, y, m;
      return v.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              if (r = 1 === (null === (t = n.installmentInfo) || void 0 === t ? void 0 : t.length), i = n.container.querySelector("#content-hd-tip"), o = n.container.querySelector("#content-hd-icon"), a = o.cloneNode(!0), i.innerHTML = "", !r) {
                e.next = 18;
                break;
              }

              return s = n.installmentInfo[0], c = s.count, u = s.installDownpay, l = s.installpay, p = "0" === c ? u : l, p = er(n.paymentInitData.currency, p), e.next = 11, n.i18n.get("installmentSelectParm");

            case 11:
              d = e.sent, h = nr(d, {
                count: c,
                money: p
              }, function (e) {
                return "**".concat(e, "**");
              }), f = new Sn(), y = f.autoParseToDom("$RT$".concat(h)), [].slice.call(y.children).forEach(function (e) {
                i.appendChild(e);
              }), e.next = 23;
              break;

            case 18:
              return m = document.createElement("span"), e.next = 21, n.i18n.get("installmentSelect");

            case 21:
              m.innerText = e.sent, i.appendChild(m);

            case 23:
              i.appendChild(a);

            case 24:
            case "end":
              return e.stop();
          }
        }
      }, e);
    }))), s(this, "setBankTip", r(v.mark(function e() {
      var t, r, i, o, a, s, c, u, l;
      return v.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return t = n.container.querySelector("#content-bd-text"), e.next = 3, n.i18n.get(["installmentSupportTip", "installmentSupportContentTip", "installmentDiff", "installmentBank"]);

            case 3:
              r = e.sent, i = vr(r, 4), o = i[0], a = i[1], s = i[2], c = i[3], t.innerText = o, n.container.querySelector("#lr-tip-content-title").innerText = a, n.container.querySelector("#lr-tip-content-title-sm").innerText = s, u = n.container.querySelector("#lr-tip-content-bd"), (l = document.createElement("pre")).innerText = c, u.appendChild(l);

            case 18:
            case "end":
              return e.stop();
          }
        }
      }, e);
    }))), s(this, "calcPostion", r(v.mark(function e() {
      var t, i, o, a, s;
      return v.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              t = ["#content-bd-icon", "#content-hd-icon"], i = n.paymentInitData.needAdaptive, a = "number" == typeof (o = void 0 === i || i) ? o : 600, s = function () {
                var e = r(v.mark(function e(t) {
                  var r, i, o, s, c, u, l, p;
                  return v.wrap(function (e) {
                    for (;;) {
                      switch (e.prev = e.next) {
                        case 0:
                          if (r = n.container.querySelector("#content")) {
                            e.next = 3;
                            break;
                          }

                          return e.abrupt("return");

                        case 3:
                          if (i = n.container.querySelector(t)) {
                            e.next = 6;
                            break;
                          }

                          return e.abrupt("return");

                        case 6:
                          if (o = i.querySelector(".pci-tooltip-content")) {
                            e.next = 9;
                            break;
                          }

                          return e.abrupt("return");

                        case 9:
                          s = r.getBoundingClientRect(), c = s.x || s.left, u = s.width, n.outerContainer.offsetWidth >= a ? (r.classList.remove(gr("content--sm")), o.removeAttribute("style")) : (r.classList.add(gr("content--sm")), l = i.getBoundingClientRect(), p = l.x || l.left, o.style.left = "".concat(-(p - c - 10), "px"), o.style.right = "auto", o.style.width = "".concat(u - 20, "px"), o.style.maxWidth = "auto", o.style.minWidth = "auto");

                        case 14:
                        case "end":
                          return e.stop();
                      }
                    }
                  }, e);
                }));
                return function (t) {
                  return e.apply(this, arguments);
                };
              }(), setTimeout(function () {
                t.forEach(function (e) {
                  s(e);
                });
              }, 0), mr = function mr() {
                yr && (clearTimeout(yr), yr = null), yr = setTimeout(function () {
                  t.forEach(function (e) {
                    s(e);
                  });
                }, 200);
              }, window.removeEventListener("resize", mr), window.addEventListener("resize", mr);

            case 8:
            case "end":
              return e.stop();
          }
        }
      }, e);
    }))), s(this, "removeLoading", function () {
      var e = n.container.querySelector(".".concat(gr("content")));
      e && e.classList.remove(gr("content-loading"));
    }), this.env = o, this.paymentInitData = a, this.theme = new Rn(a.theme);
  }

  var t;
  return a(e, [{
    key: "setInstallmentInfo",
    value: (t = r(v.mark(function e(t) {
      var n;
      return v.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              this.installmentInfo = t, 1 === (null == t ? void 0 : t.length) && "0" === (null === (n = t[0]) || void 0 === n ? void 0 : n.count) && (this.isZeroCount = !0);

            case 2:
            case "end":
              return e.stop();
          }
        }
      }, e, this);
    })), function (e) {
      return t.apply(this, arguments);
    })
  }]), e;
}(),
    xr = function () {
  function e(t, n) {
    var o = this;
    i(this, e), s(this, "env", void 0), s(this, "i18n", void 0), s(this, "validateResult", {}), s(this, "cardBrand", void 0), s(this, "isSupportCardBrand", void 0), s(this, "paymentInitData", void 0), s(this, "container", void 0), s(this, "installmentInfo", void 0), s(this, "selectUI", void 0), s(this, "pciUI", void 0), s(this, "headerUI", void 0), s(this, "selectResult", void 0), s(this, "reporter", void 0), s(this, "insertLanguage", function () {
      var e = r(v.mark(function e(t, n) {
        return v.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return o.i18n = t, e.next = 3, o.pciUI.insertLanguage(t, n);

              case 3:
                return e.next = 5, o.headerUI.insertLanguage(t);

              case 5:
                return e.next = 7, o.selectUI.insertLanguage(t);

              case 7:
                return e.next = 9, o.headerUI.removeLoading();

              case 9:
                return e.next = 11, o.pciUI.removeLoading();

              case 11:
                return e.next = 13, o.selectUI.removeLoading();

              case 13:
                return Nn(), e.abrupt("return", !0);

              case 15:
              case "end":
                return e.stop();
            }
          }
        }, e);
      }));
      return function (t, n) {
        return e.apply(this, arguments);
      };
    }()), s(this, "selectUIOnChange", function () {
      var e = r(v.mark(function e(t) {
        return v.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return o.selectResult = t, e.next = 3, o.pciUI.setCardBinParams({
                  merchantId: o.paymentInitData.merchantId,
                  paymentMethod: o.paymentInitData.paymentMethod,
                  currency: o.paymentInitData.currency,
                  amount: o.paymentInitData.amount,
                  installmentCount: o.selectResult.installmentCount
                })["catch"](o.reporter.handleError);

              case 3:
                if (t.isFirst) {
                  e.next = 7;
                  break;
                }

                return e.next = 6, o.pciUI.getCardBinVerifyResult()["catch"](o.reporter.handleError);

              case 6:
                return e.abrupt("return", e.sent);

              case 7:
              case "end":
                return e.stop();
            }
          }
        }, e);
      }));
      return function (t) {
        return e.apply(this, arguments);
      };
    }()), this.paymentInitData = n, this.pciUI = new fr(t, n), this.reporter = new me(n), this.selectUI = new or({
      env: this.env,
      dataSource: n
    }), this.headerUI = new kr({
      env: this.env,
      dataSource: n
    }), this.selectUI.create({
      onChange: this.selectUIOnChange
    });
  }

  var t, n, o, c;
  return a(e, [{
    key: "setInstallmentInfo",
    value: (c = r(v.mark(function e(t) {
      return v.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return this.installmentInfo = t, e.next = 3, this.headerUI.setInstallmentInfo(t);

            case 3:
              return e.next = 5, this.selectUI.setInstallmentInfo(t);

            case 5:
            case "end":
              return e.stop();
          }
        }
      }, e, this);
    })), function (e) {
      return c.apply(this, arguments);
    })
  }, {
    key: "render",
    value: (o = r(v.mark(function e(t) {
      var n, r;
      return v.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return this.container = t, e.next = 3, this.pciUI.render(t);

            case 3:
              return n = this.container.querySelector("#pci-content-header"), r = this.container.querySelector("#pci-content-select"), e.next = 7, this.headerUI.setOuterContainer(t);

            case 7:
              return e.next = 9, this.headerUI.mount(n);

            case 9:
              return e.next = 11, this.selectUI.mount(r);

            case 11:
            case "end":
              return e.stop();
          }
        }
      }, e, this);
    })), function (e) {
      return o.apply(this, arguments);
    })
  }, {
    key: "validate",
    value: (n = r(v.mark(function e() {
      return v.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.abrupt("return", this.pciUI.validate());

            case 1:
            case "end":
              return e.stop();
          }
        }
      }, e, this);
    })), function () {
      return n.apply(this, arguments);
    })
  }, {
    key: "pay",
    value: (t = r(v.mark(function e(t, n) {
      return v.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.abrupt("return", this.pciUI.pay(t, n));

            case 1:
            case "end":
              return e.stop();
          }
        }
      }, e, this);
    })), function (e, n) {
      return t.apply(this, arguments);
    })
  }]), e;
}();

function wr(e, t) {
  var n = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), n.push.apply(n, r);
  }

  return n;
}

function Cr(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = null != arguments[t] ? arguments[t] : {};
    t % 2 ? wr(Object(n), !0).forEach(function (t) {
      s(e, t, n[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : wr(Object(n)).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
    });
  }

  return e;
}

var Er = function () {
  function e(t, n, r) {
    i(this, e), s(this, "env", void 0), s(this, "initData", void 0), s(this, "containerElement", void 0), s(this, "pciUiInstance", void 0), s(this, "installmentInfo", void 0), s(this, "reporter", void 0), this.env = t, this.initData = n, this.reporter = new me(n), r && (this.containerElement = r);
  }

  var t, n, o, c, u;
  return a(e, [{
    key: "setInstallmentInfo",
    value: (u = r(v.mark(function e(t) {
      return v.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              this.installmentInfo = t;

            case 1:
            case "end":
              return e.stop();
          }
        }
      }, e, this);
    })), function (e) {
      return u.apply(this, arguments);
    })
  }, {
    key: "validate",
    value: (c = r(v.mark(function e() {
      return v.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.next = 2, this.pciUiInstance.validate();

            case 2:
              return e.abrupt("return", e.sent);

            case 3:
            case "end":
              return e.stop();
          }
        }
      }, e, this);
    })), function () {
      return c.apply(this, arguments);
    })
  }, {
    key: "pay",
    value: (o = r(v.mark(function e(t, n) {
      return v.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.next = 2, this.pciUiInstance.pay(t, n);

            case 2:
              return e.abrupt("return", e.sent);

            case 3:
            case "end":
              return e.stop();
          }
        }
      }, e, this);
    })), function (e, t) {
      return o.apply(this, arguments);
    })
  }, {
    key: "render",
    value: (n = r(v.mark(function e(t, n) {
      var r,
          i = this;
      return v.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              if (!(!t && !this.containerElement || t && this.containerElement)) {
                e.next = 2;
                break;
              }

              return e.abrupt("return");

            case 2:
              return this.containerElement = t, this.pciUiInstance = new xr(this.env, Cr({}, this.initData)), e.next = 6, this.pciUiInstance.setInstallmentInfo(this.installmentInfo)["catch"](this.reporter.handleError);

            case 6:
              return e.next = 8, this.pciUiInstance.render(t)["catch"](function (e) {
                return i.reporter.handleError(e, "installment_pci_render_error");
              });

            case 8:
              return r = new Jn(this.initData.language, {
                env: this.env.slI18nEnv
              }), n.showFirstName = Ln(this.initData), e.next = 12, this.pciUiInstance.insertLanguage(r, n)["catch"](this.reporter.handleError);

            case 12:
              return e.abrupt("return", e.sent);

            case 13:
            case "end":
              return e.stop();
          }
        }
      }, e, this);
    })), function (e, t) {
      return n.apply(this, arguments);
    })
  }, {
    key: "destroy",
    value: function value() {
      this.containerElement && (this.containerElement.innerHTML = ""), this.pciUiInstance = null;
    }
  }, {
    key: "needRenderWidget",
    value: (t = r(v.mark(function e() {
      return v.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.abrupt("return", !0);

            case 1:
            case "end":
              return e.stop();
          }
        }
      }, e);
    })), function () {
      return t.apply(this, arguments);
    })
  }]), e;
}();

Ae(".payment-sdk-hidden {\n  display: none;\n}\n\n.payment-sdk-simple-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.payment-sdk-simple-container .payment-sdk-simaple-image {\n  width: 137px;\n  height: auto;\n  max-width: 100%;\n}\n\n.payment-sdk-simple-container .payment-sdk-simple-space {\n  margin-top: 24px;\n}\n\n.payment-sdk-simple-container .payment-sdk-simaple-text {\n  width: 100%;\n  text-align: center;\n  font-size: 12px;\n  line-height: 18px;\n  word-break: break-word;\n  color: var(--simple-font-color);\n}\n\n@media (min-width: 640px) {\n}\n\n@media (min-width: 768px) {\n}\n\n@media (min-width: 1024px) {\n}\n\n@media (min-width: 1280px) {\n}", {});

var Ir = function () {
  function e(t, n, o) {
    var a = this;
    i(this, e), s(this, "env", void 0), s(this, "container", void 0), s(this, "initData", void 0), s(this, "paymentMethodInfo", void 0), s(this, "theme", void 0), s(this, "CONTAINER_ID", "payment-sdk-simple"), s(this, "getI18n", r(v.mark(function e() {
      var t, n;
      return v.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return t = a.initData.language, n = new Jn(t, {
                env: a.env.slI18nEnv
              }), e.abrupt("return", n);

            case 3:
            case "end":
              return e.stop();
          }
        }
      }, e);
    }))), this.env = t, this.initData = n, this.paymentMethodInfo = o, this.theme = new Rn(n.theme);
  }

  var t;
  return a(e, [{
    key: "getImageElement",
    value: function value() {
      return this.paymentMethodInfo.image ? {
        content: "img",
        props: {
          "class": "payment-sdk-simaple-image",
          src: this.paymentMethodInfo.image
        }
      } : null;
    }
  }, {
    key: "getTextElement",
    value: function value(e) {
      return e ? {
        content: "div",
        props: {
          "class": "payment-sdk-simaple-text ".concat(this.paymentMethodInfo.image ? "payment-sdk-simple-space" : "")
        },
        children: e
      } : null;
    }
  }, {
    key: "render",
    value: (t = r(v.mark(function e(t) {
      var n, r, i, o, a;
      return v.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.next = 2, this.getI18n();

            case 2:
              if (n = e.sent, r = this.paymentMethodInfo || {}, i = r.image, o = r.description, i || o) {
                e.next = 6;
                break;
              }

              return e.abrupt("return");

            case 6:
              return this.container = t, a = this.theme.getSimpleStyle(), e.t0 = {
                id: this.CONTAINER_ID,
                "class": "payment-sdk-simple-container",
                style: Fn ? a : void 0,
                "ie-style": Fn ? void 0 : a
              }, e.t1 = this.getImageElement(), e.t2 = this, e.next = 13, n.get("".concat(o));

            case 13:
              e.t3 = e.sent, e.t4 = e.t2.getTextElement.call(e.t2, e.t3), e.t5 = [e.t1, e.t4], Be({
                content: "div",
                props: e.t0,
                children: e.t5
              }, t), Nn();

            case 19:
            case "end":
              return e.stop();
          }
        }
      }, e, this);
    })), function (e) {
      return t.apply(this, arguments);
    })
  }, {
    key: "destroy",
    value: function value() {
      var e;
      this.container && (null === (e = this.container.querySelector("#".concat(this.CONTAINER_ID))) || void 0 === e || e.remove());
    }
  }]), e;
}(),
    Sr = function () {
  function e(t, n) {
    i(this, e), s(this, "env", void 0), s(this, "initData", void 0), s(this, "containerElement", void 0), s(this, "paymentMethodInfo", void 0), s(this, "simpleUI", void 0), this.env = t, this.initData = n;
  }

  var t, n, o, c;
  return a(e, [{
    key: "validate",
    value: (c = r(v.mark(function e() {
      return v.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.abrupt("return", !0);

            case 1:
            case "end":
              return e.stop();
          }
        }
      }, e);
    })), function () {
      return c.apply(this, arguments);
    })
  }, {
    key: "setInitResult",
    value: function value(e) {
      var t = e.paymentMethodInfo;
      this.paymentMethodInfo = t;
    }
  }, {
    key: "render",
    value: (o = r(v.mark(function e(t) {
      return v.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              if (t || this.containerElement) {
                e.next = 2;
                break;
              }

              return e.abrupt("return");

            case 2:
              t && (this.containerElement = t), this.simpleUI = new Ir(this.env, this.initData, this.paymentMethodInfo), this.simpleUI.render(this.containerElement);

            case 5:
            case "end":
              return e.stop();
          }
        }
      }, e, this);
    })), function (e) {
      return o.apply(this, arguments);
    })
  }, {
    key: "pay",
    value: (n = r(v.mark(function e(t, n) {
      return v.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.abrupt("return", Ye(t, {
                payOptions: n,
                paymentMethod: this.initData.paymentMethod
              }));

            case 1:
            case "end":
              return e.stop();
          }
        }
      }, e, this);
    })), function (e, t) {
      return n.apply(this, arguments);
    })
  }, {
    key: "destroy",
    value: function value() {
      this.simpleUI && (this.simpleUI.destroy(), this.simpleUI = null);
    }
  }, {
    key: "needRenderWidget",
    value: (t = r(v.mark(function e() {
      return v.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.abrupt("return", !0);

            case 1:
            case "end":
              return e.stop();
          }
        }
      }, e);
    })), function () {
      return t.apply(this, arguments);
    })
  }]), e;
}();

Ae(".payment-sdk-paypal-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.payment-sdk-paypal-container .paypal-img {\n  width: 192px;\n  height: 107px;\n  margin-bottom: 32px;\n}\n\n.payment-sdk-paypal-container .paypal-img img {\n  max-width: 100%;\n}\n\n.payment-sdk-paypal-container .paypal-tips {\n  font-size: 12px;\n  line-height: 18px;\n  text-align: center;\n  color: #959595;\n}\n", {});

var Or = function () {
  function e() {
    i(this, e), s(this, "container", void 0);
  }

  return a(e, [{
    key: "render",
    value: function value(e) {
      this.container = e, Be({
        content: "div",
        props: {
          "class": "payment-sdk-paypal-container"
        },
        children: [{
          content: "div",
          props: {
            "class": "paypal-img"
          },
          children: {
            content: "img",
            props: {
              src: "data:image/svg+xml,%3csvg width='193' height='108' viewBox='0 0 193 108' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M8 0.5C3.85786 0.5 0.5 3.85786 0.5 8V100C0.5 104.142 3.85786 107.5 8 107.5H162C166.142 107.5 169.5 104.142 169.5 100V69.1259C169.5 69.0155 169.41 68.9259 169.3 68.9259H166.7C166.59 68.9259 166.5 69.0155 166.5 69.1259V100C166.5 102.485 164.485 104.5 162 104.5H8C5.51472 104.5 3.5 102.485 3.5 100V21.7C3.5 21.5895 3.58954 21.5 3.69999 21.5H166.3C166.41 21.5 166.5 21.5895 166.5 21.7V53.8C166.5 53.9105 166.59 54 166.7 54H169.3C169.41 54 169.5 53.9105 169.5 53.8V8C169.5 3.85787 166.142 0.5 162 0.5H8ZM166.3 18.5C166.41 18.5 166.5 18.4105 166.5 18.3V8C166.5 5.51472 164.485 3.5 162 3.5H8C5.51472 3.5 3.5 5.51472 3.5 8V18.3C3.5 18.4105 3.58954 18.5 3.69999 18.5H166.3ZM14 11C14 12.6569 12.6569 14 11 14C9.34315 14 8 12.6569 8 11C8 9.34315 9.34315 8 11 8C12.6569 8 14 9.34315 14 11ZM21 14C22.6569 14 24 12.6569 24 11C24 9.34315 22.6569 8 21 8C19.3431 8 18 9.34315 18 11C18 12.6569 19.3431 14 21 14ZM34 11C34 12.6569 32.6569 14 31 14C29.3431 14 28 12.6569 28 11C28 9.34315 29.3431 8 31 8C32.6569 8 34 9.34315 34 11ZM191.98 61.1415C192.058 61.0634 192.058 60.9368 191.98 60.8587L183.202 52.0809C183.124 52.0028 182.997 52.0028 182.919 52.0809L181.081 53.9193C181.003 53.9975 181.003 54.1241 181.081 54.2022L186.037 59.1587C186.163 59.2847 186.074 59.5001 185.896 59.5001H139.7C139.59 59.5001 139.5 59.5897 139.5 59.7001V62.3001C139.5 62.4106 139.59 62.5001 139.7 62.5001H185.896C186.074 62.5001 186.163 62.7155 186.037 62.8415L181.081 67.798C181.003 67.8761 181.003 68.0028 181.081 68.0809L182.919 69.9194C182.997 69.9975 183.124 69.9975 183.202 69.9194L191.98 61.1415Z' fill='%232C2C2C' fill-opacity='0.5'/%3e%3c/svg%3e"
            }
          }
        }, {
          content: "div",
          props: {
            "class": "paypal-tips"
          },
          children: "After clicking “Complete order”, you will be redirected to PayPal to complete your purchase securely."
        }]
      }, e);
    }
  }]), e;
}(),
    _r = function () {
  function e(t, n) {
    i(this, e), s(this, "initData", void 0), s(this, "containerElement", void 0), s(this, "paypalUiInstance", void 0), s(this, "reporter", void 0), this.initData = t, this.reporter = new me(t), n && (this.containerElement = n);
  }

  var t, n, o, c;
  return a(e, [{
    key: "render",
    value: (c = r(v.mark(function e(t) {
      return v.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              if (t || this.containerElement) {
                e.next = 2;
                break;
              }

              return e.abrupt("return");

            case 2:
              return t && (this.containerElement = t), this.paypalUiInstance = new Or(), this.paypalUiInstance.render(this.containerElement), e.abrupt("return");

            case 6:
            case "end":
              return e.stop();
          }
        }
      }, e, this);
    })), function (e) {
      return c.apply(this, arguments);
    })
  }, {
    key: "pay",
    value: (o = r(v.mark(function e(t, n) {
      var r;
      return v.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.prev = 0, e.next = 3, Ve(t.url, {
                paymentInstrument: {
                  paymentMethod: this.initData.paymentMethod
                }
              });

            case 3:
              return r = e.sent, e.abrupt("return", Ke(r, n));

            case 7:
              return e.prev = 7, e.t0 = e["catch"](0), e.abrupt("return", this.reporter.handleError(e.t0, "paypal_pay_error"));

            case 10:
            case "end":
              return e.stop();
          }
        }
      }, e, this, [[0, 7]]);
    })), function (e, t) {
      return o.apply(this, arguments);
    })
  }, {
    key: "validate",
    value: (n = r(v.mark(function e() {
      return v.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.abrupt("return", !0);

            case 1:
            case "end":
              return e.stop();
          }
        }
      }, e);
    })), function () {
      return n.apply(this, arguments);
    })
  }, {
    key: "destroy",
    value: function value() {
      this.containerElement && (this.containerElement.innerHTML = ""), this.paypalUiInstance = null;
    }
  }, {
    key: "needRenderWidget",
    value: (t = r(v.mark(function e() {
      return v.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.abrupt("return", !0);

            case 1:
            case "end":
              return e.stop();
          }
        }
      }, e);
    })), function () {
      return t.apply(this, arguments);
    })
  }]), e;
}();

Ae(".payment-sdk-hidden {\n  display: none;\n}\n\n.payment-sdk-block-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 24px;\n}\n\n.payment-sdk-block-container .block-img {\n  width: 200px;\n  height: 113px;\n  background-repeat: no-repeat;\n  background-size: 100% 100%;\n  margin-bottom: 16px;\n  color: var(--block-img-color);\n}\n\n.payment-sdk-block-container .block-tips {\n  font-size: 12px;\n  line-height: 16px;\n  color: var(--block-font-color);\n}\n\n@media (min-width: 640px) {\n}\n\n@media (min-width: 768px) {\n}\n\n@media (min-width: 1024px) {\n}\n\n@media (min-width: 1280px) {\n}\n", {});

var Dr,
    Pr = function () {
  function e(t, n) {
    var o = this;
    i(this, e), s(this, "env", void 0), s(this, "theme", void 0), s(this, "container", void 0), s(this, "reporter", void 0), s(this, "mount", function () {
      var e = r(v.mark(function e(t, n) {
        var r, i;
        return v.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return o.reporter.addReportData(n), o.container = t, e.next = 4, o.getText(n.language)["catch"](function (e) {
                  return o.reporter.handleError(e);
                });

              case 4:
                r = e.sent, i = o.theme.getBlockStyle(), Be({
                  content: "div",
                  props: {
                    "class": "payment-sdk-block-container",
                    style: Fn ? i : void 0,
                    "ie-style": Fn ? void 0 : i
                  },
                  children: [{
                    content: "div",
                    props: {
                      "class": "block-img",
                      innerHTML: '\n<svg width="200" height="113" viewBox="0 0 200 113" fill="none" xmlns="http://www.w3.org/2000/svg">\n<path d="M151 70.0171C151 67.5027 152.704 66 154.704 66C156.703 66 158.407 67.5027 158.407 70.0171C158.407 70.9936 157.942 71.9062 157.125 72.6701C156.29 73.4516 155.231 73.9322 154.406 74.0565C153.427 74.204 152.704 75.0447 152.704 76.0342V78.6658C152.704 79.7705 153.599 80.6667 154.704 80.6667C155.808 80.6667 156.704 79.7712 156.704 78.6666V77.558C157.829 77.1301 158.932 76.4571 159.857 75.5915C161.269 74.2717 162.407 72.3637 162.407 70.0171C162.407 65.3862 159.004 62 154.704 62C150.403 62 147 65.3862 147 70.0171C147 71.1217 147.895 72.0171 149 72.0171C150.105 72.0171 151 71.1217 151 70.0171Z" fill="currentColor"/>\n<path d="M154.5 88C155.881 88 157 86.8807 157 85.5C157 84.1193 155.881 83 154.5 83C153.119 83 152 84.1193 152 85.5C152 86.8807 153.119 88 154.5 88Z" fill="currentColor"/>\n<path fill-rule="evenodd" clip-rule="evenodd" d="M25 13.219C25 12.1144 25.8954 11.219 27 11.219H64.022C68.8042 11.219 73.3899 13.122 76.7669 16.508L90.3001 30.0773H154.24C159.763 30.0773 164.24 34.5544 164.24 40.0773V54.2006L172.334 56.0079C173.248 56.2119 173.898 57.0229 173.898 57.9595L173.9 69.8512C173.9 72.8249 173.9 75.7995 173.9 78.0324C173.9 79.1488 173.9 80.0799 173.899 80.7328L173.899 81.6964L173.898 81.7537L173.898 81.777L173.898 81.7984L173.897 81.8294C173.896 81.8515 173.887 81.9744 173.874 82.0747C173.866 82.125 173.856 82.175 173.844 82.2246C171.338 92.7681 161.454 97.3662 157.263 98.8897C155.45 99.549 153.511 99.4864 151.773 98.8716C150.089 98.2761 148.567 97.6263 147.191 96.9382H69.4814C63.9586 96.9382 59.4814 92.4611 59.4814 86.9382V66.8548H54.4261C50.2409 66.8548 46.2278 65.1894 43.2723 62.2261C41.0674 60.0152 38.0732 58.7727 34.9508 58.7727H28.791C27.6864 58.7727 26.791 57.8773 26.791 56.7727C26.791 55.6681 27.6864 54.7727 28.791 54.7727H34.9508C39.1359 54.7727 43.1491 56.4381 46.1045 59.4014C48.3095 61.6123 51.3036 62.8548 54.4261 62.8548H59.4814V52.1721C53.7323 50.0648 49.6299 44.5436 49.6299 38.0642C49.6299 36.9596 50.5253 36.0642 51.6299 36.0642C52.7345 36.0642 53.6299 36.9596 53.6299 38.0642C53.6299 44.151 58.5642 49.0854 64.6511 49.0854H69.9975C72.4759 49.0854 74.8529 50.0697 76.6057 51.8219L82.4235 57.6377C84.0397 59.2533 86.2314 60.1609 88.5166 60.1609C91.465 60.1609 92.9414 56.5958 90.8561 54.5113L67.5836 31.2469C66.8024 30.4659 66.8022 29.1996 67.5831 28.4184C68.364 27.6372 69.6303 27.637 70.4115 28.4179L72.0714 30.0773H84.6508L73.9347 19.3327C71.3081 16.6991 67.7415 15.219 64.022 15.219H27C25.8954 15.219 25 14.3236 25 13.219ZM141.086 92.9382C139.585 91.6448 138.415 90.3244 137.505 89.0513C136.653 87.8588 136.041 86.7235 135.602 85.7129H63.4814V86.9382C63.4814 90.2519 66.1677 92.9382 69.4814 92.9382H141.086ZM134.495 81.7129C134.481 81.5365 134.48 81.3835 134.48 81.2737V71.3447H63.4814V81.7129H134.495ZM134.48 67.3447V57.96C134.48 57.0176 135.138 56.2031 136.059 56.0048L152.379 52.4923C153.791 52.1884 155.252 52.194 156.662 52.5087L160.24 53.3075V40.0773C160.24 36.7636 157.553 34.0773 154.24 34.0773H76.0728L93.6841 51.6824C98.2898 56.2866 95.029 64.1609 88.5166 64.1609C85.1707 64.1609 81.9619 62.832 79.5956 60.4666L73.7778 54.6508C72.7751 53.6485 71.4153 53.0854 69.9975 53.0854H64.6511C64.2575 53.0854 63.8674 53.0702 63.4814 53.0405V67.3447H134.48ZM169.898 59.5625L155.791 56.4126C154.945 56.2238 154.068 56.2204 153.221 56.4028L138.48 59.5754V81.2737C138.48 81.3715 138.482 81.396 138.483 81.4037C138.525 81.8111 138.835 84.0307 140.76 86.7262C142.673 89.4047 146.275 92.684 153.107 95.1005C154.053 95.4352 155.034 95.4443 155.897 95.1305C159.872 93.6852 167.813 89.7797 169.899 81.5182L169.899 80.7311C169.9 80.0789 169.9 79.1483 169.9 78.032C169.9 75.7996 169.9 72.8252 169.9 69.8515L169.898 59.5625Z" fill="currentColor"/>\n</svg>\n'
                    }
                  }, {
                    content: "div",
                    props: {
                      "class": "block-tips"
                    },
                    children: r
                  }]
                }, t), Nn();

              case 9:
              case "end":
                return e.stop();
            }
          }
        }, e);
      }));
      return function (t, n) {
        return e.apply(this, arguments);
      };
    }()), s(this, "getText", function () {
      var e = r(v.mark(function e(t) {
        var n;
        return v.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return n = new Jn(t, {
                  env: o.env.slI18nEnv
                }), e.next = 3, n.get("paymentMethodNotSupported");

              case 3:
                return e.abrupt("return", e.sent);

              case 4:
              case "end":
                return e.stop();
            }
          }
        }, e);
      }));
      return function (t) {
        return e.apply(this, arguments);
      };
    }()), this.env = t, this.theme = new Rn(n), this.reporter = new me({});
  }

  return a(e, [{
    key: "destroy",
    value: function value() {
      if (this.container) {
        var e = this.container.querySelector(".".concat("payment-sdk-block-container"));
        e && e.remove();
      }
    }
  }]), e;
}();

function jr() {
  var e = navigator.userAgent,
      t = -1 !== e.indexOf("MSIE"),
      n = /Windows\sNT ([0-9\.]+).*?Trident\/7\.0.*rv\:([0-9\.]+).*\).*Gecko$/.exec(e),
      r = n ? Number(n[1]) : null,
      i = n ? Number(n[2]) : null;
  return t || !!(n && i <= 11 && r <= 7);
}

!function (e) {
  e.PCI = "pci";
}(Dr || (Dr = {}));

var Tr = function () {
  function e(t, n) {
    i(this, e), s(this, "env", void 0), s(this, "initData", void 0), s(this, "containerElement", null), s(this, "plugin", void 0), s(this, "theme", void 0), s(this, "reporter", void 0), s(this, "subScene", void 0), s(this, "blockRender", void 0), this.initData = n, this.env = t, this.reporter = new me(n), this.theme = new Rn(n.theme), this.findPlugin(), this.reporter.reportData("plugin_init");
  }

  var t, n, o, c, u, l, p, d;
  return a(e, [{
    key: "findPlugin",
    value: function value() {
      var e = this.initData.plugins;
      if (e && Array.isArray(e)) for (var t = e.length, n = 0; n < t; n++) {
        var r = e[n],
            i = Array.isArray(r),
            o = i ? r[0] : r,
            a = i ? r[1] : void 0;

        if (!(!o.info.channelId || o.info.channelId !== this.initData.channelId || !o.info.paymentMethod || o.info.paymentMethod !== this.initData.paymentMethod) && !this.plugin) {
          if (this.plugin = new o(a), o.info.scene === Dr.PCI) {
            if (jr()) throw this.reporter.reportData("plugin_not_support_browser"), new j("浏览器版本过低不兼容，支付失败", x.NotSupportBrowser, "NotSupportBrowser");
            this.subScene = new $n(this.env, this.initData);
          }

          break;
        }
      }
    }
  }, {
    key: "applyHook",
    value: (d = r(v.mark(function e(t) {
      var n,
          r,
          i,
          o,
          a,
          s,
          c,
          u,
          l = arguments;
      return v.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              if (this.plugin) {
                e.next = 2;
                break;
              }

              return e.abrupt("return");

            case 2:
              for (e.prev = 2, this.reporter.reportData("plugin_applyHook_".concat(t, "_start")), r = l.length, i = new Array(r > 1 ? r - 1 : 0), o = 1; o < r; o++) {
                i[o - 1] = l[o];
              }

              if (!this.subScene || !this.subScene[t]) {
                e.next = 11;
                break;
              }

              return e.next = 8, (a = this.subScene)[t].apply(a, i);

            case 8:
              n = e.sent, e.next = 16;
              break;

            case 11:
              if (!this.plugin || !this.plugin[t]) {
                e.next = 16;
                break;
              }

              return c = (i || []).map(function (e) {
                return We(e);
              }), e.next = 15, (s = this.plugin)[t].apply(s, cr(c));

            case 15:
              n = e.sent;

            case 16:
              return this.reporter.reportData("plugin_applyHook_".concat(t, "_end")), e.abrupt("return", n);

            case 20:
              e.prev = 20, e.t0 = e["catch"](2), u = "plugin_applyHook_".concat(t, "_error"), this.reporter.reportData(u), this.reporter.handleError(e.t0, u);

            case 25:
            case "end":
              return e.stop();
          }
        }
      }, e, this, [[2, 20]]);
    })), function (e) {
      return d.apply(this, arguments);
    })
  }, {
    key: "needRenderWidget",
    value: (p = r(v.mark(function e() {
      return v.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.abrupt("return", !0);

            case 1:
            case "end":
              return e.stop();
          }
        }
      }, e);
    })), function () {
      return p.apply(this, arguments);
    })
  }, {
    key: "afterInit",
    value: (l = r(v.mark(function e(t, n) {
      var r, i, o;
      return v.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return this.reporter.reportData("plugin_applyHook_afterInit_start"), r = this.theme.getTheme(), i = new Jn(this.initData.language, {
                env: this.env.slI18nEnv
              }), e.next = 5, i.getData();

            case 5:
              return o = e.sent, e.t0 = this, e.t1 = Object, e.t2 = {}, e.t3 = t, e.t4 = r, e.next = 13, i.getDisplayLanguage();

            case 13:
              return e.t5 = e.sent, e.t6 = o, e.t7 = this.env.env, e.t8 = this.initData.clientId, e.t9 = {
                theme: e.t4,
                displayLanguage: e.t5,
                languageObj: e.t6,
                env: e.t7,
                clientId: e.t8
              }, e.t10 = e.t1.assign.call(e.t1, e.t2, e.t3, e.t9), e.t11 = n, e.next = 22, e.t0.applyHook.call(e.t0, "afterInit", e.t10, e.t11);

            case 22:
              return e.abrupt("return", e.sent);

            case 23:
            case "end":
              return e.stop();
          }
        }
      }, e, this);
    })), function (e, t) {
      return l.apply(this, arguments);
    })
  }, {
    key: "render",
    value: (u = r(v.mark(function e(t, n) {
      var r;
      return v.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return t && (this.containerElement = t), e.prev = 1, e.next = 4, this.applyHook("beforeRender", t);

            case 4:
              return e.next = 6, this.applyHook("render", t, n);

            case 6:
              e.next = 16;
              break;

            case 8:
              return e.prev = 8, e.t0 = e["catch"](1), r = new Pr(this.env, this.initData.theme), this.blockRender = r, e.next = 14, r.mount(t, this.initData);

            case 14:
              this.reporter.reportData("plugin_applyHook_render_error"), this.reporter.handleError(e.t0);

            case 16:
            case "end":
              return e.stop();
          }
        }
      }, e, this, [[1, 8]]);
    })), function (e, t) {
      return u.apply(this, arguments);
    })
  }, {
    key: "setInitResult",
    value: function value(e) {
      this.subScene && this.subScene.setInitResult && this.subScene.setInitResult(e);
    }
  }, {
    key: "validate",
    value: (c = r(v.mark(function e() {
      return v.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              if (!this.blockRender) {
                e.next = 2;
                break;
              }

              return e.abrupt("return", !1);

            case 2:
              return e.next = 4, this.applyHook("validate");

            case 4:
              return e.abrupt("return", e.sent);

            case 5:
            case "end":
              return e.stop();
          }
        }
      }, e, this);
    })), function () {
      return c.apply(this, arguments);
    })
  }, {
    key: "extendPaySession",
    value: (o = r(v.mark(function e() {
      return v.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.next = 2, this.applyHook("extendPaySession");

            case 2:
              return e.abrupt("return", e.sent);

            case 3:
            case "end":
              return e.stop();
          }
        }
      }, e, this);
    })), function () {
      return o.apply(this, arguments);
    })
  }, {
    key: "pay",
    value: (n = r(v.mark(function e(t, n) {
      var r;
      return v.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              if (e.prev = 0, r = this.createHooks(["beforeConfirm", "extendConfirmParams", "afterConfirm", "handlePayAction"]), n.hooks = r, !this.subScene || !this.subScene.pay) {
                e.next = 5;
                break;
              }

              return e.abrupt("return", this.subScene.pay(t, n));

            case 5:
              return e.next = 7, Ye(t, {
                payOptions: n,
                paymentMethod: this.initData.paymentMethod
              });

            case 7:
              return e.abrupt("return", e.sent);

            case 10:
              e.prev = 10, e.t0 = e["catch"](0), this.reporter.handleError(e.t0, "plugin_pay_error");

            case 13:
            case "end":
              return e.stop();
          }
        }
      }, e, this, [[0, 10]]);
    })), function (e, t) {
      return n.apply(this, arguments);
    })
  }, {
    key: "createHooks",
    value: function value(e) {
      var t = this,
          n = {};
      return e.map(function (e) {
        n[e] = function () {
          var n = r(v.mark(function n(r) {
            return v.wrap(function (n) {
              for (;;) {
                switch (n.prev = n.next) {
                  case 0:
                    return n.next = 2, t.applyHook(e, r);

                  case 2:
                    return n.abrupt("return", n.sent);

                  case 3:
                  case "end":
                    return n.stop();
                }
              }
            }, n);
          }));
          return function (e) {
            return n.apply(this, arguments);
          };
        }();
      }), n;
    }
  }, {
    key: "destroy",
    value: (t = r(v.mark(function e() {
      return v.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              if (!this.blockRender) {
                e.next = 5;
                break;
              }

              this.blockRender.destroy(), this.reporter.reportData("plugin_destroy_block_fail"), e.next = 7;
              break;

            case 5:
              return e.next = 7, this.applyHook("destroy", this.containerElement);

            case 7:
            case "end":
              return e.stop();
          }
        }
      }, e, this);
    })), function () {
      return t.apply(this, arguments);
    })
  }], [{
    key: "checkHasPlugin",
    value: function value(e) {
      var t = e.plugins;
      if (t && Array.isArray(t)) for (var n = t.length, r = 0; r < n; r++) {
        var i = t[r],
            o = Array.isArray(i) ? i[0] : i;
        if (!(!o.info.channelId || o.info.channelId !== e.channelId || !o.info.paymentMethod || o.info.paymentMethod !== e.paymentMethod)) return !0;
      }
    }
  }]), e;
}();

Ae(".payment-sdk-hidden {\n  display: none;\n}\n\n.payment-sdk-FPX-container * {\n  margin: 0;\n}\n\n.payment-sdk-FPX-container {\n  margin: 0 auto;\n}\n\n.FPX-content {\n  position: relative;\n}\n\n/* 骨架屏样式 开始 */\n\n.FPX-content-loading .FPX-select {\n  background-color: rgb(44, 44, 44);\n  opacity: 0.05;\n  border-radius: 4px;\n}\n\n.FPX-content-loading .FPX-select-input,\n.FPX-content-loading .footer-tip-icon\n{\n  display: none;\n}\n\n.FPX-content-loading .FPX-next-step-tip, \n.FPX-content-loading .PFX-footer-tip{\n  background-color: rgb(44, 44, 44);\n  opacity: 0.05;\n  border-radius: 4px;\n  height: 10px;\n}\n\n.FPX-content-loading .FPX-next-step-tip {\n  height: 20px;\n}\n\n/* 骨架屏样式 结束 */\n\n.FPX-select {\n  position: relative;\n  height: 48px;\n}\n\n.FPX-select-input-mask {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1;\n}\n\n.FPX-select-input {\n  position: relative;\n  width: calc(100% - 34px);\n  height: 18px;\n  padding: 14px 16px;\n  line-height: 18px;\n  font-size: 14px;\n  border: 1px solid;\n  box-sizing: content-box;\n  border-radius: 4px;\n  outline: none;\n  background-image: none;\n  border-color: var(--select-border-color);\n  transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);\n  -webkit-appearance: none; /* 不应用任何特殊样式（去除input的默认样式） */\n  -webkit-tap-highlight-color: rgba(255, 0, 0, 0); /* 删除点击输入框时高亮的蓝色 */\n  cursor: pointer;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n  color: var(--select-font-color);\n  background-color: var(--select-background);\n}\n\n.FPX-select-input.FPX-selected {\n  width: calc(100% - 64px);\n  padding-left: 46px;\n}\n\n.FPX-select-input::-moz-placeholder {\n  color: var(--select-placeholder-font-color);\n}\n\n.FPX-select-input:-ms-input-placeholder {\n  color: var(--select-placeholder-font-color);\n}\n\n.FPX-select-input::placeholder {\n  color: var(--select-placeholder-font-color);\n}\n\n.FPX-select-input .selected-bank-content {\n  display: flex;\n}\n\n.FPX-select-input .selected-bank-content .bank-icon {\n  flex: 0 0 20px;\n  width: 20px;\n  height: 20px;\n  border-radius: 4px;\n}\n\n.FPX-select-input .selected-bank-content .bank-name {\n  flex: 1;\n  margin-left: 10px;\n  color: var(--options-font-color)\n}\n\n.selected-icon {\n  display: none;\n  position: absolute;\n  width: 20px;\n  height: 20px;\n  top: 14px;\n  left: 14px;\n}\n\n.FPX-select .input-suffix {\n  position: absolute;\n  top: 12px;\n  right: 19.75px;\n  color: var(--select-icon-color);\n}\n\n.FPX-next-step-tip {\n  margin-top: 10px;\n  margin-bottom: 12px;\n  font-size: 12px;\n  line-height: 18px;\n  color: var(--next-step-tip-font-color);\n}\n\n.FPX-bank-list {\n  position: absolute;\n  top: 48px;\n  left: 0;\n  width: 100%;\n  box-sizing: border-box;\n  max-height: 0;\n  z-index: 2043;\n  overflow-y: scroll;\n  box-shadow: 0px 1px 3px rgba(54, 62, 81, 0.2),\n    0px 0px 16px rgba(54, 62, 81, 0.1);\n  border-radius: 6px;\n  transition: max-height 0.15s linear;\n  color: var(--options-font-color);\n  background-color: var(--options-background);\n}\n\n.FPX-bank-item {\n  position: relative;\n  display: flex;\n  height: 62px;\n  padding: 12px 16px;\n  line-height: 38px;\n  box-sizing: border-box;\n  overflow: hidden;\n}\n\n.bank-item-mask {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  cursor: pointer;\n}\n\n.is-disabled .bank-item-mask {\n  cursor: not-allowed;\n}\n\n.FPX-bank-item.is-disabled {\n  background-color: var(--options-disabled-background);\n  color: var(--options-disabled-font-color);\n}\n\n.FPX-bank-item.is-disabled .bank-maintain-end-time {\n  font-size: 12px;\n  color: var(--maintain-time-font-color);\n}\n\n.FPX-bank-item img {\n  flex: 0 0 38px;\n  width: 38px;\n  height: 38px;\n  border-radius: 4px;\n}\n\n.bank-info {\n  display: flex;\n  flex: 1;\n  margin-left: 10px;\n  font-size: 14px;\n}\n\n.bank-info .bank-name {\n  flex: 1;\n  margin-right: 10px;\n  white-space: nowrap;\n}\n\n.PFX-footer-tip {\n  display: flex;\n  font-size: 11px;\n  line-height: 16px;\n}\n\n.footer-tip-icon {\n  font-size: 12px;\n  color: var(--footer-icon-color);\n}\n\n.PFX-footer-tip span {\n  color: var(--footer-font-color);\n}\n\n.PFX-footer-tip a {\n  color: var(--footer-link-color);\n}\n\n/* 错误样式 开始 */\n\n.FPX-content-error .FPX-select-input {\n  border-color: var(--select-error-border-color);\n  box-shadow: 0 0 0 1px var(--select-error-border-color);\n}\n\n.FPX-error-tip {\n  height: 0;\n  font-size: 14px;\n  line-height: 16px;\n  overflow: hidden;\n  margin-left: 1px;\n  margin-top: 6px;\n  color: var(--select-error-font-color);\n  transition: all 0.2s linear;\n}\n\n/* 错误样式 结束 */\n\n.FPX-mobile-style .is-disabled .bank-info {\n  flex-direction: column;\n  line-height: 1;\n  justify-content: center;\n}\n\n.FPX-mobile-style .is-disabled .bank-name {\n  line-height: 20px;\n}\n\n@media (min-width: 640px) {\n}\n\n@media (min-width: 768px) {\n}\n\n@media (min-width: 1024px) {\n}\n\n@media (min-width: 1280px) {\n}\n", {});

var Rr = function () {
  function e(t, n, o) {
    var a = this;
    i(this, e), s(this, "container", void 0), s(this, "initData", void 0), s(this, "host", void 0), s(this, "isPc", void 0), s(this, "bankCode", void 0), s(this, "bankListDom", void 0), s(this, "FPXContentDom", void 0), s(this, "theme", void 0), s(this, "paymentMethodInfo", void 0), s(this, "createBankItemTemplate", function () {
      var e = a.paymentMethodInfo.banks || [],
          t = [];
      return e.forEach(function (e) {
        var n,
            r = e.bankCode,
            i = e.bankName,
            o = e.maintainEndTime,
            s = "FPX-bank-item",
            c = 0 === e.status;
        c && (n = function (e) {
          var t;
          t = Number(e);
          var n = (t = new Date(t)).getFullYear(),
              r = t.getMonth() + 1 >= 10 ? t.getMonth() + 1 : "0".concat(t.getMonth() + 1),
              i = t.getDate() >= 10 ? t.getDate() : "0".concat(t.getDate()),
              o = t.getHours() >= 10 ? t.getHours() : "0".concat(t.getHours()),
              a = t.getMinutes() >= 10 ? t.getMinutes() : "0".concat(t.getMinutes()),
              s = t.getSeconds() >= 10 ? t.getSeconds() : "0".concat(t.getSeconds());
          return "".concat(n, "/").concat(r, "/").concat(i, " ").concat(o, ":").concat(a, ":").concat(s);
        }(o), s = "".concat(s, " is-disabled")), t.push({
          content: "div",
          props: {
            "class": s
          },
          children: [{
            content: "div",
            props: {
              bankCode: r,
              bankName: i,
              "class": "bank-item-mask"
            }
          }, {
            content: "img",
            props: {
              src: "".concat(a.host, "/payment-sdk/assets/image/FPX/").concat(r, ".png")
            }
          }, {
            content: "div",
            props: {
              "class": "bank-info"
            },
            children: [{
              content: "div",
              props: {
                "class": "bank-name"
              },
              children: i
            }, {
              content: "div",
              props: {
                "class": "bank-maintain-end-time"
              },
              children: c ? "".concat(n) : null
            }]
          }]
        });
      }), t;
    }), s(this, "needShowPcStyle", function (e) {
      a.isPc = e;
      var t = a.container.querySelector(".payment-sdk-FPX-container");

      if (t) {
        var n = t.getAttribute("class");
        n = n.replace(/(\s*FPX-mobile-style)|(\s*FPX-pc-style)/g, ""), n += " ".concat(e ? "FPX-pc-style" : "FPX-mobile-style"), t.setAttribute("class", n);
      }
    }), s(this, "insertLanguage", function () {
      var e = r(v.mark(function e(t) {
        var n, r, i, o, s, c, u, l, p, d, h, f, y;
        return v.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return e.next = 2, t.get("FPX.FPXFooter");

              case 2:
                return r = e.sent, e.next = 5, t.get(["FPX.selectBank", "FPX.FPXPayGuide", "FPX.bankMaintenance", "FPX.serviceTerms"]);

              case 5:
                i = e.sent, o = vr(i, 4), s = o[0], c = o[1], u = o[2], l = o[3], p = "[".concat(l, "](https://www.mepsfpx.com.my/FPXMain/termsAndConditions.jsp)"), r = r.replace("${serviceTerms}", p), d = new Sn(), h = "$RT$".concat(r), null === (n = a.container.querySelector(".PFX-footer-tip")) || void 0 === n || n.appendChild(d.autoParseToDom(h)), f = a.container.querySelectorAll(".FPX-bank-item"), [].slice.call(f).forEach(function (e) {
                  var t,
                      n = null === (t = e.querySelector(".bank-maintain-end-time")) || void 0 === t ? void 0 : t.textContent;
                  n && (e.querySelector(".bank-maintain-end-time").textContent = "".concat(u, " ").concat(n));
                }), a.container.querySelector(".FPX-next-step-tip").innerHTML = c, a.container.querySelector(".FPX-error-tip").innerHTML = s, a.container.querySelector(".FPX-select-input").setAttribute("placeholder", s), y = a.FPXContentDom.getAttribute("class").replace(" FPX-content-loading", ""), a.FPXContentDom.setAttribute("class", y), Nn();

              case 24:
              case "end":
                return e.stop();
            }
          }
        }, e);
      }));
      return function (t) {
        return e.apply(this, arguments);
      };
    }()), s(this, "handleSelect", function (e) {
      var t = e.target;

      if (!(t.parentNode.getAttribute("class").indexOf("is-disabled") > -1)) {
        var n = t.getAttribute("bankCode"),
            r = t.getAttribute("bankName");
        a.setSelectBankCode(n, r), a.handleToggleBankList(!1);
      }
    }), s(this, "bindClick", function () {
      a.container.querySelector("#FPX-select").addEventListener("click", function () {
        a.handleToggleErrortip(!1);
        var e = "434px" !== a.bankListDom.style.maxHeight;
        a.handleToggleBankList(e);
      }, !1);
    }), s(this, "handleToggleBankList", function (e) {
      a.bankListDom.style.maxHeight = e ? "434px" : "0px";
    }), s(this, "handleHideSelect", function () {
      document.addEventListener("click", function (e) {
        var t = e.target;
        a.FPXContentDom.contains(t) || a.handleToggleBankList(!1);
      });
    }), s(this, "setError", function () {
      a.handleToggleErrortip(!0);
    }), s(this, "handleToggleErrortip", function (e) {
      var t = a.FPXContentDom.getAttribute("class"),
          n = a.container.querySelector(".FPX-error-tip");
      if (e) -1 === t.indexOf("FPX-content-error") && (t += " FPX-content-error", a.FPXContentDom.setAttribute("class", t)), n.style.height = "19px";else {
        var r = t.replace(" FPX-content-error", "");
        a.FPXContentDom.setAttribute("class", r), n.style.height = "0px";
      }
    }), this.initData = n, this.host = t.host, this.paymentMethodInfo = o, this.theme = new Rn(n.theme);
  }

  var t;
  return a(e, [{
    key: "render",
    value: (t = r(v.mark(function e(t) {
      var n;
      return v.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              this.container = t, this.mutationObserver(), n = this.theme.getFPXStyle(), Be({
                content: "div",
                props: {
                  "class": "payment-sdk-FPX-container ".concat(this.isPc ? "FPX-pc-style" : "FPX-mobile-style")
                },
                children: [{
                  content: "div",
                  props: {
                    "class": "FPX-content FPX-content-loading",
                    id: "FPX-content",
                    style: Fn ? n : void 0,
                    "ie-style": Fn ? void 0 : n
                  },
                  children: [{
                    content: "div",
                    props: {
                      "class": "FPX-select",
                      id: "FPX-select"
                    },
                    children: [{
                      content: "div",
                      props: {
                        "class": "FPX-select-input-mask"
                      }
                    }, {
                      content: "input",
                      props: {
                        readonly: "readonly",
                        autocomplete: "off",
                        id: "select-input",
                        "class": "FPX-select-input"
                      }
                    }, {
                      content: "img",
                      props: {
                        id: "selected-icon",
                        "class": "selected-icon"
                      }
                    }, {
                      content: "div",
                      props: {
                        "class": "input-suffix",
                        innerHTML: '<svg width="9" height="6" viewBox="0 0 9 6" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.23682 1.5L4.73682 5L8.23682 1.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" fill="none"/></svg>'
                      }
                    }]
                  }, {
                    content: "div",
                    props: {
                      "class": "FPX-error-tip",
                      id: "FPX-error-tip"
                    },
                    children: null
                  }, {
                    content: "div",
                    props: {
                      "class": "FPX-next-step-tip"
                    },
                    children: null
                  }, {
                    content: "div",
                    props: {
                      "class": "PFX-footer-tip"
                    },
                    children: [{
                      content: "div",
                      props: {
                        "class": "footer-tip-icon",
                        innerHTML: _n
                      }
                    }]
                  }, {
                    content: "div",
                    props: {
                      id: "FPX-bank-list",
                      "class": "FPX-bank-list"
                    },
                    children: this.createBankItemTemplate()
                  }]
                }]
              }, t), this.bankListDom = this.container.querySelector("#FPX-bank-list"), this.bankListDom.addEventListener("click", this.handleSelect, !1), this.FPXContentDom = this.container.querySelector("#FPX-content"), this.handleHideSelect(), this.bindClick();

            case 10:
            case "end":
              return e.stop();
          }
        }
      }, e, this);
    })), function (e) {
      return t.apply(this, arguments);
    })
  }, {
    key: "mutationObserver",
    value: function value() {
      var e = this,
          t = this.initData.needAdaptive,
          n = void 0 === t || t,
          r = "number" == typeof n ? n : 600;
      this.isPc = this.container.offsetWidth >= r;
      var i = null;
      if (!n && 0 !== n) return null;
      window.addEventListener("resize", function () {
        i && (clearTimeout(i), i = null), i = setTimeout(function () {
          var t = getComputedStyle(e.container).getPropertyValue("width").replace("px", "");
          e.needShowPcStyle(Number(t) > r);
        }, 200);
      });
    }
  }, {
    key: "setSelectBankCode",
    value: function value(e, t) {
      this.bankCode = e;
      var n = this.container.querySelector("#select-input"),
          r = this.container.querySelector("#selected-icon");
      n.value = t, n.classList.add("FPX-selected"), r.style.display = "inherit", r.src = "".concat(this.host, "/payment-sdk/assets/image/FPX/").concat(e, ".png");
    }
  }]), e;
}(),
    Fr = function () {
  function e(t, n) {
    i(this, e), s(this, "env", void 0), s(this, "initData", void 0), s(this, "containerElement", void 0), s(this, "paymentMethodInfo", void 0), s(this, "renderTimes", void 0), s(this, "FPXUI", void 0), s(this, "reporter", void 0), this.env = t, this.initData = n, this.renderTimes = 0, this.reporter = new me(n);
  }

  var t, n, o, c;
  return a(e, [{
    key: "validate",
    value: (c = r(v.mark(function e() {
      var t;
      return v.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return (t = !!this.FPXUI.bankCode) || this.FPXUI.setError(), e.abrupt("return", t);

            case 3:
            case "end":
              return e.stop();
          }
        }
      }, e, this);
    })), function () {
      return c.apply(this, arguments);
    })
  }, {
    key: "setInitResult",
    value: function value(e) {
      var t = e.paymentMethodInfo;
      this.paymentMethodInfo = t;
    }
  }, {
    key: "render",
    value: (o = r(v.mark(function e(t) {
      var n,
          r = this;
      return v.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              if (!(this.renderTimes >= 1)) {
                e.next = 4;
                break;
              }

              return console.error("请勿重复调用 render 方法!"), this.reporter.reportErrorData("fpx_repeat_render"), e.abrupt("return");

            case 4:
              if (t) {
                e.next = 6;
                break;
              }

              return e.abrupt("return");

            case 6:
              return t && (this.containerElement = t), this.FPXUI = new Rr(this.env, this.initData, this.paymentMethodInfo), this.renderTimes++, e.next = 11, this.FPXUI.render(this.containerElement)["catch"](function (e) {
                return r.reporter.handleError(e, "fpx_ui_render_error");
              });

            case 11:
              return n = new Jn(this.initData.language, {
                env: this.env.slI18nEnv
              }), e.next = 14, this.FPXUI.insertLanguage(n)["catch"](function (e) {
                return r.reporter.handleError(e, "fpx_ui_insert_language_error");
              });

            case 14:
              return e.abrupt("return", e.sent);

            case 15:
            case "end":
              return e.stop();
          }
        }
      }, e, this);
    })), function (e) {
      return o.apply(this, arguments);
    })
  }, {
    key: "pay",
    value: (n = r(v.mark(function e(t, n) {
      return v.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.abrupt("return", Ye(t, {
                payOptions: n,
                paymentMethod: this.initData.paymentMethod,
                subPaymentMethod: this.FPXUI.bankCode
              }));

            case 1:
            case "end":
              return e.stop();
          }
        }
      }, e, this);
    })), function (e, t) {
      return n.apply(this, arguments);
    })
  }, {
    key: "destroy",
    value: function value() {
      this.containerElement && (this.containerElement.innerHTML = ""), this.FPXUI = null;
    }
  }, {
    key: "needRenderWidget",
    value: (t = r(v.mark(function e() {
      return v.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.abrupt("return", !0);

            case 1:
            case "end":
              return e.stop();
          }
        }
      }, e);
    })), function () {
      return t.apply(this, arguments);
    })
  }]), e;
}(),
    Nr = function Nr(e) {
  return "[object Array]" === Object.prototype.toString.call(e);
};

function Br(e) {
  var t = e.installmentCounts;
  return !(void 0 === t || Nr(t) && !t.length);
}

var Lr,
    Mr = [/Trident\/7\.0.*rv\:([0-9\.]+).*\).*Gecko$/, /MSIE\s([0-9\.]+);.*Trident\/[4-7].0/, /MSIE\s(7\.0)/];

function Ar(e, t) {
  var n = "\n    <div style='width: 780px;padding: 153px 24px 24px;box-sizing:border-box;background: url(".concat("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAwIiBoZWlnaHQ9IjExMyIgdmlld0JveD0iMCAwIDIwMCAxMTMiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0xNDggOTZINTFDNDcuNjg2MyA5NiA0NSA5My4zMTM3IDQ1IDkwVjI0QzQ1IDIwLjY4NjMgNDcuNjg2MyAxOCA1MSAxOEgxNDhDMTUxLjMxNCAxOCAxNTQgMjAuNjg2MyAxNTQgMjRWOTBDMTU0IDkzLjMxMzcgMTUxLjMxNCA5NiAxNDggOTZaIiBzdHJva2U9IiNEOEQ4RDgiIHN0cm9rZS13aWR0aD0iNCIvPgo8cGF0aCBkPSJNMTI2IDUxLjgwOVY4MC43MzM3QzEyNiA4MC44NDgxIDEyNi4wMDIgODAuOTU5NiAxMjYuMDEzIDgxLjA3MzVDMTI2LjE2MiA4Mi41OTIxIDEyNy44ODMgOTQuMDMwNiAxNDYuMzM2IDEwMC4zMzdDMTQ3LjY4IDEwMC43OTYgMTQ5LjEyNyAxMDAuODMyIDE1MC40NjkgMTAwLjM2N0MxNTUuMjkxIDk4LjY5NzYgMTY3LjEwMyA5My40NDE1IDE2OS45OTggODEuMjk4MkMxNzAuMDAzIDgxLjI2NjcgMTY5Ljk5OCA1MS44MDg3IDE2OS45OTggNTEuODA4N0wxNTAuMTExIDQ3LjM4MDJDMTQ4Ljk4NiA0Ny4xMjk3IDE0Ny44MiA0Ny4xMjUyIDE0Ni42OTMgNDcuMzY3MUwxMjYgNTEuODA5WiIgZmlsbD0iI0Y4RkFGQiIgc3Ryb2tlPSIjRDhEOEQ4IiBzdHJva2Utd2lkdGg9IjQiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMTQxIDY4LjM4NDZDMTQxIDY0IDE0NC4xMzQgNjEgMTQ4IDYxQzE1MS44NjYgNjEgMTU1IDY0IDE1NSA2OC4zODQ2QzE1NSA3Mi40NjMgMTUxLjA2MiA3NS4zMDc3IDE0OCA3NS43NjkyQzE0OCA3Ny4xNTM4IDE0OCA3OSAxNDggNzkiIHN0cm9rZT0iI0Q4RDhEOCIgc3Ryb2tlLXdpZHRoPSI0IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPGNpcmNsZSBjeD0iMTQ4IiBjeT0iODYiIHI9IjIiIGZpbGw9IiNEOEQ4RDgiLz4KPHBhdGggZD0iTTQ3IDMzSDE1MyIgc3Ryb2tlPSIjRDhEOEQ4IiBzdHJva2Utd2lkdGg9IjQiLz4KPGNpcmNsZSBjeD0iMTMwIiBjeT0iMjUiIHI9IjIiIGZpbGw9IiNEOEQ4RDgiLz4KPGNpcmNsZSBjeD0iMTM4IiBjeT0iMjUiIHI9IjIiIGZpbGw9IiNEOEQ4RDgiLz4KPGNpcmNsZSBjeD0iMTQ2IiBjeT0iMjUiIHI9IjIiIGZpbGw9IiNEOEQ4RDgiLz4KPC9zdmc+Cg==", ") no-repeat center 40px/200px 113px;'>\n      <p style='margin: 0;padding: 0;text-align: center;font-size: 12px;line-height: 16px;color: #1e1e1e;opacity: 0.8'>").concat({
    de: "Entschuldigung, Ihr  Browser mit der aktuellen Benutzeroberfläche nicht kompatibel ist. Wir  empfehlen IE11/Chrome für eine optimale Verwendung.",
    en: "Sorry, this browser  is not supported, we suggest you to change to IE11/Chrome or other browsers  to try again",
    es: "Perdón, no es  compatible con el navegador actual, es recomendable intentar de nuevo con los  navegadores de IE11/Chrome, etc.",
    fr: "Désolé, le navigateur  actuel n’est pas compatible, il est recommandé de remplacer IE11 / Chrome et  d’autres navigateurs pour réessayer",
    ja: "申し訳ありませんが、このブラウザは現在サポートされていません  。IE11/ Chromeまたは他のブラウザに変更して再試行することをお勧めします",
    ru: "Извините, текущий  браузер несовместим, рекомендуется заменить на IE11 / Chrome или другие  браузеры для повторной попытки.",
    th: "ขออภัยค่ะ  เบราว์เซอร์ปัจจุบันไม่รองรับ ขอแนะนำให้เปลี่ยนเป็นเบราว์เซอร์ IE11/Chrome  เพื่อลองใหม่อีกครั้งค่ะ",
    "zh-CN": "抱歉，当前浏览器不兼容，建议更换IE11/Chrome等浏览器重试",
    "zh-TW": "抱歉，當前瀏覽器不相容，建議更換IE11/Chrome等瀏覽器重試",
    id: "Maaf, browser ini tidak  didukung, kami sarankan Anda mengubah ke IE11/Chrome atau browser lain untuk  coba lagi.",
    it: "Spiacenti, il browser attuale  non supporta, si consiglia di sostituire IE11/Chrome e altri browser per  riprovare",
    ko: "죄송합니다. 현재 인터넷을 겸용할 수 없고  IE11/Chrome 인터넷으로 교체하여 다시 시도하세요",
    nl: "Sorry, de huidige browser is  niet compatibel, wij raden u aan het opnieuw te proberen met IE11/Chrome of  andere browsers.",
    pl: "Przepraszam, bieżąca  przeglądarka nie jest kompatybilna, zaleca się zastąpienie IE11/Chrome i  innych przeglądarek, aby spróbować ponownie",
    pt: "Desculpe, o navegador atual não  é compatível, sugerimos que você tente novamente com o IE11/Chrome e outros  navegadores",
    vi: "Rất tiếc chúng tôi không hỗ trợ  trình duyệt này, bạn có thể sử dụng trình duyệt IE11/ Chrome hoặc các trình  duyệt khác và thử lại",
    bg: "Съжаляваме, този браузър е несъвместим Препоръчително е да  смените IE11/Chrome и да опитате отново",
    ro: "Ne pare rău,  browserul actual este incompatibil. Vă recomandăm să înlocuiți IE11/Chrome și  să încercați din nou",
    hu: "Sajnáljuk, a  jelenlegi böngésző nem kompatibilis. Javasoljuk, hogy IE11/Chrome-ot  használjon és próbálja újra",
    lt: "Atsiprašome,  dabartinė naršyklė nesuderinama. Rekomenduojama pakeisti į IE11/Chrome ir  bandyti dar kartą",
    ms: "Maaf, pelayar semasa  tidak serasi. Disyorkan agar menggantikan IE11/Chrome dan cuba lagi",
    sv: "Tyvärr är den  nuvarande webbläsaren inte kompatibel. Det rekommenderas att byta ut IE11 /  Chrome och försöka igen",
    no: "Beklager, gjeldende  leser er ikke kompatibel. Det anbefales å erstatte IE11 / Chrome og prøve  igjen",
    cs: "Omlouváme se, Váš  aktuální prohlížeč není podporován. Doporučuje se jej vyměnit a raději použít  IE11 / Chrome a zkusit to znovu",
    fi: "Nykyinen selain ei  ole valitettavasti yhteensopiva On suositeltavaa käyttää  IE11-/Chrome-selainta ja yritä uudelleen",
    da: "Beklager, den  aktuelle browser er ikke kompatibel. Det anbefales at erstatte IE11/Chrome og  prøve igen",
    lv: "Atvainojiet,  pašreizējais pārlūks nav savietojams. Ieteicams aizstāt IE11 / Chrome un  mēģināt vēlreiz",
    et: "Vabandame, kasutatav  veebilehitseja ei ole sobiv. Soovitatav on kasutada IE11/Chrome ja proovida  uuesti",
    hr: "Nažalost, trenutni  preglednik nije kompatibilan. Preporuča se zamijeniti IE11/Chrome i pokušati  ponovno",
    hi: "क्षमा करें, वर्तमान  ब्राउज़र असंगत है। IE11/Chrome को बदल कर पुन: प्रयास करने की अनुशंसा की जाती  है",
    tr: "Üzgünüz, geçerli  tarayıcı uyumsuz. IE11/Chrome ile değiştirilmesi ve tekrar denenmesi önerilir",
    sk: "Ľutujeme, aktuálny  prehliadač nie je kompatibilný. Odporúča sa nahradiť IE11/Chrome a skúsiť to  znova",
    sl: "Žal je trenutni  brskalnik nezdružljiv. Priporočamo, da zamenjate IE11/Chrome in poskusite  znova",
    el: "Συγγνώμη, tο  προσωρινό πρόγραμμα περιήγησης είναι ασύμβατο. Συνιστάται να αλλάξετε  IE11/Chrome και να προσπαθήσετε ξανά"
  }[t], "</p>\n    </div>\n  ");
  e.innerHTML = n;
}

function Hr(e, t) {
  var n = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), n.push.apply(n, r);
  }

  return n;
}

function Vr(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = null != arguments[t] ? arguments[t] : {};
    t % 2 ? Hr(Object(n), !0).forEach(function (t) {
      s(e, t, n[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Hr(Object(n)).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
    });
  }

  return e;
}

!function (e) {
  e.Success = "SUCCESS", e.Fail = "FAIL";
}(Lr || (Lr = {}));

var Ur,
    qr,
    zr,
    Xr = function () {
  function e(t, n) {
    var o = this;
    i(this, e), s(this, "env", void 0), s(this, "initData", void 0), s(this, "initResult", void 0), s(this, "blockRender", void 0), s(this, "reporter", void 0), s(this, "beforeParamCheck", function () {
      var e = r(v.mark(function e(t) {
        var n, r, i;
        return v.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                if (n = t.installmentCounts, r = t.amount, i = t.paymentMethod, !Br(t) || "number" == typeof r) {
                  e.next = 7;
                  break;
                }

                return o.reporter.reportErrorData("cashier_check_installment_error", {
                  amount: r
                }), e.abrupt("return", !1);

              case 7:
                if (i === u.CreditCard || !n) {
                  e.next = 12;
                  break;
                }

                return o.reporter.reportErrorData("render_checker_installmentCounts_param", {
                  installmentCounts: n
                }), e.abrupt("return", !0);

              case 12:
                if (i !== u.CreditCard || !n || Nr(n)) {
                  e.next = 15;
                  break;
                }

                return o.reporter.reportErrorData("render_checker_installmentCounts_param_arr", {
                  installmentCounts: n
                }), e.abrupt("return", !0);

              case 15:
                return e.abrupt("return", !0);

              case 16:
              case "end":
                return e.stop();
            }
          }
        }, e);
      }));
      return function (t) {
        return e.apply(this, arguments);
      };
    }()), s(this, "renderFail", function () {
      var e = r(v.mark(function e(t) {
        var n;
        return v.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return n = new Pr(o.env, o.initData.theme), o.blockRender = n, e.next = 4, n.mount(t, o.initData)["catch"](function (e) {
                  o.reporter.handleError(e, "render_fail_error");
                });

              case 4:
              case "end":
                return e.stop();
            }
          }
        }, e);
      }));
      return function (t) {
        return e.apply(this, arguments);
      };
    }()), s(this, "destroy", function () {
      o.blockRender.destroy(), o.blockRender = null;
    }), this.env = t, this.reporter = new me(n), this.initData = n, this.initResult = this.cashierCheck();
  }

  var t, n;
  return a(e, [{
    key: "cashierCheck",
    value: (n = r(v.mark(function e() {
      var t,
          n,
          r,
          i,
          o,
          a,
          s,
          c,
          u,
          l,
          p,
          d,
          h = this;
      return v.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return t = this.initData, e.next = 3, this.beforeParamCheck(t);

            case 3:
              if (e.sent) {
                e.next = 6;
                break;
              }

              return e.abrupt("return", {
                status: Lr.Fail
              });

            case 6:
              return n = t.merchantId, r = t.countryCode, i = t.paymentMethod, o = t.currency, a = t.channelId, s = t.installmentCounts, c = t.amount, u = "".concat(this.env.host, "/v1/api/cashier/init"), l = {
                merchantId: n,
                countryCode: r,
                paymentMethod: i,
                currency: o,
                channelId: a
              }, (p = Br(t)) && (l.installmentCounts = s, l.amount = c), e.next = 13, Ce.post(u, l).then(function (e) {
                var t, n, r;
                return h.reporter.reportData("cashier_check_success", {
                  url: u,
                  request: {
                    params: l
                  },
                  response: Vr(Vr({}, e.data), {}, {
                    channelInfo: null
                  })
                }), e.data.status = Lr.Success, !p || ("installments" in e.data && null !== (t = e.data.installments) && void 0 !== t && t.length && (e.data.installments = e.data.installments.filter(function (e) {
                  return !!e.supportCount;
                })), "installments" in e.data && null !== (n = e.data) && void 0 !== n && null !== (r = n.installments) && void 0 !== r && r.length) ? e.data : (h.reporter.reportErrorData("cashier_check_installment_error", {
                  installmentCounts: s,
                  amount: c
                }), {
                  status: Lr.Fail
                });
              })["catch"](function (e) {
                var t = Vr({
                  status: Lr.Fail
                }, e.data || {});
                return ye.reportErrorData("cashier_check_error", {
                  url: u,
                  request: {
                    params: l
                  },
                  response: {
                    error: e
                  }
                }), t;
              });

            case 13:
              return d = e.sent, e.abrupt("return", d);

            case 15:
            case "end":
              return e.stop();
          }
        }
      }, e, this);
    })), function () {
      return n.apply(this, arguments);
    })
  }, {
    key: "getInitResult",
    value: (t = r(v.mark(function e() {
      return v.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.abrupt("return", this.initResult);

            case 1:
            case "end":
              return e.stop();
          }
        }
      }, e, this);
    })), function () {
      return t.apply(this, arguments);
    })
  }]), e;
}();

function Wr(e, t) {
  var n = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), n.push.apply(n, r);
  }

  return n;
}

function Gr(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = null != arguments[t] ? arguments[t] : {};
    t % 2 ? Wr(Object(n), !0).forEach(function (t) {
      s(e, t, n[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Wr(Object(n)).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
    });
  }

  return e;
}

!function (e) {
  e.Dev = "stg", e.Test = "stg", e.Prev = "prev", e.Prod = "prod";
}(qr || (qr = {})), function (e) {
  e.Dev1 = "dev1", e.Prev1 = "prev1", e.Prev2 = "prev2", e.Prev3 = "prev3", e.Prev4 = "prev4", e.Prod = "prod";
}(zr || (zr = {}));
var Zr = zr.Prod,
    Jr = Object.freeze((s(Ur = {}, zr.Dev1, {
  env: zr.Dev1,
  cybsOrgId: "1snn5n9w",
  cybsMerchantId: "yyrisk",
  cybsLabel: "cybs",
  host: "https://cashiers-dev1.myshopline.com",
  slI18nEnv: qr.Dev
}), s(Ur, zr.Prev1, {
  env: zr.Prev1,
  cybsOrgId: "1snn5n9w",
  cybsMerchantId: "yyrisk",
  cybsLabel: "cybs",
  host: "https://cashiers-prev1.myshopline.com",
  slI18nEnv: qr.Prev
}), s(Ur, zr.Prev2, {
  env: zr.Prev2,
  cybsOrgId: "1snn5n9w",
  cybsMerchantId: "yyrisk",
  cybsLabel: "cybs",
  host: "https://cashiers-prev2.myshopline.com",
  slI18nEnv: qr.Prev
}), s(Ur, zr.Prev3, {
  env: zr.Prev3,
  cybsOrgId: "1snn5n9w",
  cybsMerchantId: "yyrisk",
  cybsLabel: "cybs",
  host: "https://cashiers-prev3.myshopline.com",
  slI18nEnv: qr.Prev
}), s(Ur, zr.Prev4, {
  env: zr.Prev4,
  cybsOrgId: "1snn5n9w",
  cybsMerchantId: "yyrisk",
  cybsLabel: "cybs",
  host: "https://cashiers-prev4.myshopline.com",
  slI18nEnv: qr.Prev
}), s(Ur, zr.Prod, {
  env: zr.Prod,
  cybsOrgId: "k8vif92e",
  cybsMerchantId: "yyrisk",
  cybsLabel: "cybs",
  host: "https://cashiers.myshopline.com",
  slI18nEnv: qr.Prod
}), Ur));

function Qr(e, t) {
  var n = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), n.push.apply(n, r);
  }

  return n;
}

function Yr(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = null != arguments[t] ? arguments[t] : {};
    t % 2 ? Qr(Object(n), !0).forEach(function (t) {
      s(e, t, n[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Qr(Object(n)).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
    });
  }

  return e;
}

var $r = function () {
  function e(t, n) {
    var o,
        a,
        c,
        l = this;
    i(this, e), s(this, "env", void 0), s(this, "initData", void 0), s(this, "element", void 0), s(this, "paySession", void 0), s(this, "scene", void 0), s(this, "metaData", void 0), s(this, "isNotSupportBrowser", void 0), s(this, "reporter", void 0), s(this, "renderChecker", void 0), s(this, "isRenderFail", void 0), s(this, "check", function () {
      if (l.isNotSupportBrowser) throw new j("no support browser", x.NotSupportBrowser, "NotSupportBrowser");
      if ([u.CreditCard, u.FPX].indexOf(l.initData.paymentMethod) > -1 && jr()) throw l.reporter.reportData("init_not_support_browser"), new j("浏览器版本过低不兼容，支付失败", x.NotSupportBrowser, "NotSupportBrowser");
    }), s(this, "init", r(v.mark(function e() {
      return v.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.prev = 0, l.reporter.reportData("init_start"), l.check(), e.next = 5, Promise.all([l.initRisk(), l.initRender()])["catch"](l.reporter.handleError);

            case 5:
              return l.reporter.reportData("init_end"), e.abrupt("return", l);

            case 9:
              e.prev = 9, e.t0 = e["catch"](0), l.reporter.handleError(e.t0, "init_error");

            case 12:
            case "end":
              return e.stop();
          }
        }
      }, e, null, [[0, 9]]);
    }))), s(this, "renderWidget", function () {
      var e = r(v.mark(function e(t) {
        var n, r;
        return v.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                if (e.prev = 0, l.reporter.reportData("renderWidget_start"), n = l.getRenderElement(t), !l.isNotSupportBrowser) {
                  e.next = 8;
                  break;
                }

                return r = l.parseLanguage(), Ar(n, r), l.reporter.reportData("renderWidget_notSupportBrowser_end"), e.abrupt("return");

              case 8:
                return e.next = 10, l.scene.needRenderWidget()["catch"](l.reporter.handleError);

              case 10:
                if (!e.sent) {
                  e.next = 16;
                  break;
                }

                return e.next = 14, l.render(n);

              case 14:
                e.next = 17;
                break;

              case 16:
                console.warn('支付方式 "'.concat(l.metaData.paymentMethod, '" 不需要渲染控件'));

              case 17:
                l.reporter.reportData("renderWidget_end"), e.next = 23;
                break;

              case 20:
                e.prev = 20, e.t0 = e["catch"](0), l.reporter.handleError(e.t0, "renderWidget_error");

              case 23:
              case "end":
                return e.stop();
            }
          }
        }, e, null, [[0, 20]]);
      }));
      return function (t) {
        return e.apply(this, arguments);
      };
    }()), s(this, "getPaySession", r(v.mark(function e() {
      var t, n, r;
      return v.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              if (e.prev = 0, l.reporter.reportData("getPaySession_start"), t = {}, !l.scene.extendPaySession) {
                e.next = 7;
                break;
              }

              return e.next = 6, l.scene.extendPaySession()["catch"](l.reporter.handleError);

            case 6:
              t = e.sent;

            case 7:
              return e.next = 9, l.paySession;

            case 9:
              return n = e.sent, r = JSON.stringify(Object.assign({}, t, n)), l.reporter.reportData("getPaySession_end", {
                paySession: r
              }), e.abrupt("return", r);

            case 15:
              e.prev = 15, e.t0 = e["catch"](0), l.reporter.handleError(e.t0, "getPaySession_error");

            case 18:
            case "end":
              return e.stop();
          }
        }
      }, e, null, [[0, 15]]);
    }))), s(this, "needRenderWidget", r(v.mark(function e() {
      var t;
      return v.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.prev = 0, l.reporter.reportData("needRenderWidget_start"), e.next = 4, l.renderChecker.getInitResult()["catch"](l.reporter.handleError);

            case 4:
              if (e.sent.status !== Lr.Fail) {
                e.next = 8;
                break;
              }

              return l.reporter.reportData("needRenderWidget_checkResult_fail_end"), e.abrupt("return", !0);

            case 8:
              if (!l.isNotSupportBrowser) {
                e.next = 11;
                break;
              }

              return l.reporter.reportData("needRenderWidget_notSupportBrowser_fail_end"), e.abrupt("return", !1);

            case 11:
              return e.next = 13, l.scene.needRenderWidget();

            case 13:
              return t = e.sent, l.reporter.reportData("needRenderWidget_end", {
                needRenderWidget: t
              }), e.abrupt("return", t);

            case 18:
              e.prev = 18, e.t0 = e["catch"](0), l.reporter.handleError(e.t0, "needRenderWidget_error");

            case 21:
            case "end":
              return e.stop();
          }
        }
      }, e, null, [[0, 18]]);
    }))), s(this, "validate", r(v.mark(function e() {
      var t;
      return v.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.prev = 0, l.reporter.reportData("validate_start"), e.next = 4, l.renderChecker.getInitResult()["catch"](l.reporter.handleError);

            case 4:
              if (e.sent.status !== Lr.Fail) {
                e.next = 8;
                break;
              }

              return l.reporter.reportData("validate_checkResult_fail_end"), e.abrupt("return", !1);

            case 8:
              return e.next = 10, l.scene.validate();

            case 10:
              return t = e.sent, l.reporter.reportData("validate_end", {
                validateResult: t
              }), e.abrupt("return", t);

            case 15:
              e.prev = 15, e.t0 = e["catch"](0), l.reporter.handleError(e.t0, "validate_error");

            case 18:
            case "end":
              return e.stop();
          }
        }
      }, e, null, [[0, 15]]);
    }))), s(this, "pay", function () {
      var e = r(v.mark(function e(t, n) {
        var i, o, a, s, c, u, p, d, h, y;
        return v.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return e.prev = 0, (null == (i = t) ? void 0 : i.type) === f.Confirm && (m = null == i ? void 0 : i.url, o = m && "string" == typeof m ? m.split("/").pop() : "", l.reporter.addReportData({
                  orderId: o
                })), l.reporter.reportData("call_pay_start", {
                  nextAction: t
                }), e.next = 6, l.paySession;

              case 6:
                return a = e.sent, e.next = 9, l.scene.pay(t, Yr(Yr({}, n), {}, {
                  beforeRedirect: function () {
                    var e = r(v.mark(function e(r) {
                      return v.wrap(function (e) {
                        for (;;) {
                          switch (e.prev = e.next) {
                            case 0:
                              if (l.reporter.reportData("call_pay_end_with_redirect", {
                                nextAction: t
                              }), !n || null == n || !n.beforeRedirect) {
                                e.next = 3;
                                break;
                              }

                              return e.abrupt("return", n.beforeRedirect(r));

                            case 3:
                            case "end":
                              return e.stop();
                          }
                        }
                      }, e);
                    }));
                    return function (t) {
                      return e.apply(this, arguments);
                    };
                  }(),
                  sessionId: a.sessionId
                }))["catch"](function (e) {
                  return l.reporter.handleError(e, "scene_pay_error", {
                    nextAction: t
                  });
                });

              case 9:
                l.reporter.reportData("call_pay_end_no_error"), e.next = 21;
                break;

              case 12:
                return e.prev = 12, e.t0 = e["catch"](0), s = "call_pay_end_with_error", c = e.t0.data || {}, u = c.code, p = c.msg, d = c.channelCode, h = c.channelMsg, pe.setTag("xTraceId", e.t0.xTraceId), y = {
                  paymentError: {
                    code: u || x.NetworkError,
                    msg: p || "Payment failed due to network error",
                    channelCode: d || "",
                    channelMsg: h || ""
                  }
                }, l.reporter.reportData(s, {
                  payResult: y,
                  xTraceId: e.t0.xTraceId
                }), l.reporter.reportError(e.t0, s, {
                  payResult: y,
                  nextAction: t
                }), e.abrupt("return", y);

              case 21:
              case "end":
                return e.stop();
            }
          }

          var m;
        }, e, null, [[0, 12]]);
      }));
      return function (t, n) {
        return e.apply(this, arguments);
      };
    }()), s(this, "destroy", function () {
      try {
        l.reporter.reportData("destroy_start"), l.isRenderFail ? (l.reporter.reportData("destroy_checkResult_fail"), l.renderChecker.destroy()) : l.scene.destroy(), l.reporter.reportData("destroy_end");
      } catch (e) {
        l.reporter.handleError(e, "destroy_error");
      }
    }), this.initReporter(t);

    try {
      this.reporter.reportData("constructor_start", t);
      var p = Yr({}, t);
      this.env = function (e) {
        e.env = e.env && Jr[e.env] ? e.env : Zr;
        var t = Gr({}, Jr[e.env]);
        return e.env === Zr ? e.host = void 0 : t && (t.host = e.host || t.host, e.host = t.host), Object.freeze(t);
      }(p), p.channelId = void 0 !== p.channelId ? p.channelId : "SLPayments", pe.setTag("host", this.env.host), pe.setTag("channelId", p.channelId), pe.setTag("paymentMethod", p.paymentMethod), pe.setTag("merchantId", p.merchantId), pe.setTag("clientId", p.clientId), p.host = Bn(p.host), this.initData = Object.freeze(p), this.isNotSupportBrowser = (c = navigator.userAgent, Mr.every(function (e) {
        var t = e.exec(c);
        return !!(t && Number(t[1]) < 11);
      })), this.reporter.addReportData(this.initData), this.isRenderFail = !1, this.check(), this.metaData = Object.freeze((o = this.initData, a = {}, ["currency", "countryCode", "channelId", "paymentMethod", "merchantId"].forEach(function (e) {
        void 0 !== o.hasOwnProperty(e) && (a[e] = o[e]);
      }), a)), this.element = n, this.scene = function (e, t) {
        if (Tr.checkHasPlugin(t)) return new Tr(e, t);
        var n;

        switch (t.paymentMethod) {
          case u.Paypal:
            n = new _r(t);
            break;

          case u.CreditCard:
            n = Br(t) ? new Er(e, t) : new $n(e, t);
            break;

          case u.FPX:
            n = new Fr(e, t);
            break;

          case u.Cash:
          case u.BankTransfer:
          case u.ChannelCashier:
          case u.VirtualAccount:
          case u.AtomeBNPL:
            n = new Sr(e, t);
            break;

          default:
            n = new Sr(e, t);
        }

        return n;
      }(this.env, this.initData), this.renderChecker = new Xr(this.env, this.initData), this.reporter.reportData("constructor_end", p);
    } catch (e) {
      this.reporter.handleError(e, "constructor_error");
    }
  }

  var t, n, o;
  return a(e, [{
    key: "initReporter",
    value: function value(e) {
      try {
        ye.init(e), this.reporter = new me(e);
      } catch (e) {
        ye.handleError(e, "init_reporter_error");
      }
    }
  }, {
    key: "initRisk",
    value: (o = r(v.mark(function e() {
      var t = this;
      return v.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return this.reporter.reportData("init_risk_start"), e.abrupt("return", (this.paySession = new Re(this.env, this.initData.host).init().then(function (e) {
                t.reporter.addReportData({
                  sessionId: e.sessionId
                });
                var n = Yr(Yr({}, e), {}, {
                  paymentMethod: t.initData.paymentMethod,
                  channelId: t.initData.channelId,
                  language: t.parseLanguage()
                });
                return t.reporter.reportData("init_risk_end", {
                  paySession: n
                }), n;
              }))["catch"](this.reporter.handleError));

            case 2:
            case "end":
              return e.stop();
          }
        }
      }, e, this);
    })), function () {
      return o.apply(this, arguments);
    })
  }, {
    key: "initRender",
    value: (n = r(v.mark(function e() {
      var t;
      return v.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.next = 2, this.renderChecker.getInitResult()["catch"](this.reporter.handleError);

            case 2:
              if (t = e.sent, !this.scene || !this.scene.afterInit) {
                e.next = 6;
                break;
              }

              return e.next = 6, this.scene.afterInit(Object.assign({}, this.metaData, {
                language: this.parseLanguage()
              }), t.channelInfo)["catch"](this.reporter.handleError);

            case 6:
              if (e.t0 = this.element, !e.t0) {
                e.next = 10;
                break;
              }

              return e.next = 10, this.renderWidget(this.element);

            case 10:
            case "end":
              return e.stop();
          }
        }
      }, e, this);
    })), function () {
      return n.apply(this, arguments);
    })
  }, {
    key: "parseLanguage",
    value: function value() {
      var e = this.initData.language,
          t = void 0 === e ? "en" : e;
      return "string" == typeof t ? t : (null == t ? void 0 : t.extend) || "en";
    }
  }, {
    key: "render",
    value: (t = r(v.mark(function e(t) {
      var n,
          r = this;
      return v.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.next = 2, this.renderChecker.getInitResult()["catch"](this.reporter.handleError);

            case 2:
              if ((n = e.sent).status !== Lr.Success) {
                e.next = 18;
                break;
              }

              if (this.scene && this.scene.setInitResult && this.scene.setInitResult(n), !(this.scene instanceof Er)) {
                e.next = 8;
                break;
              }

              return e.next = 8, this.scene.setInstallmentInfo(n.installments || [])["catch"](function (e) {
                return r.reporter.handleError(e, "scene_setInstallmentInfo_error");
              });

            case 8:
              if (!(this.scene instanceof $n || this.scene instanceof Tr || this.scene instanceof Er)) {
                e.next = 13;
                break;
              }

              return e.next = 11, this.scene.render(t, {
                merchantCountry: n.merchantCountry
              })["catch"](function (e) {
                return r.reporter.handleError(e, "scene_render_pci_error");
              });

            case 11:
              e.next = 15;
              break;

            case 13:
              return e.next = 15, this.scene.render(t)["catch"](function (e) {
                return r.reporter.handleError(e, "scene_render_error");
              });

            case 15:
              this.reporter.reportData("render_success"), e.next = 24;
              break;

            case 18:
              if (n.status !== Lr.Fail) {
                e.next = 24;
                break;
              }

              return this.isRenderFail = !0, e.next = 22, this.renderChecker.renderFail(t)["catch"](this.reporter.handleError);

            case 22:
              throw this.reporter.reportData("render_fail"), new P(n.msg, x.RenderFail, "RenderFail");

            case 24:
            case "end":
              return e.stop();
          }
        }
      }, e, this);
    })), function (e) {
      return t.apply(this, arguments);
    })
  }, {
    key: "getRenderElement",
    value: function value(e) {
      var t,
          n = e;
      "string" == typeof e && (n = document.querySelector(e), null === (t = console) || void 0 === t || t.assert(n, "请检查元素 ".concat(e, " 是否存在, 注意: id 需要加 '#' 前缀, class 需要加 '.' 前缀")));
      return n;
    }
  }]), e;
}(),
    Kr = function Kr(e) {
  var t;
  return Jr[e] ? e = (t = Gr({}, Jr[e || Zr])).host : t = function (e) {
    var t;

    for (var n in Jr) {
      if (e && -1 !== e.indexOf(n)) {
        t = n;
        break;
      }
    }

    return Gr({}, Jr[t = t || Zr]);
  }(e = Bn(e)), ye.reportData("init_risk_start"), new Re(t, e).init().then(function (e) {
    ye.reportData("init_risk_end", {
      sessionId: e.sessionId
    });
  });
},
    ei = function () {
  function e() {
    var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
    i(this, e), s(this, "options", {}), this.options = t;
  }

  return a(e, [{
    key: "afterInit",
    value: function value(e, t) {}
  }, {
    key: "beforeRender",
    value: function value(e) {}
  }, {
    key: "render",
    value: function value(e) {}
  }, {
    key: "validate",
    value: function value() {
      return !0;
    }
  }, {
    key: "extendPaySession",
    value: function value() {
      return {};
    }
  }, {
    key: "beforeConfirm",
    value: function value() {}
  }, {
    key: "extendConfirmParams",
    value: function value() {
      return {};
    }
  }, {
    key: "afterConfirm",
    value: function value() {}
  }, {
    key: "handlePayAction",
    value: function value(e) {}
  }, {
    key: "destroy",
    value: function value(e) {}
  }]), e;
}();

s(ei, "info", {
  channelId: "",
  paymentMethod: ""
});
export { $r as Payment, u as PaymentMethod, ei as PaymentSDKPlugin, Dr as PluginScene, Kr as initRisk, T as version };